import { Injectable, EventEmitter, TemplateRef, Component, ViewEncapsulation, ChangeDetectionStrategy, ChangeDetectorRef, ViewChild, Input, Output, Directive, HostBinding, HostListener, Inject, ElementRef, NgZone, Injector, ViewContainerRef, NgModule } from '@angular/core';
import { DOCUMENT, CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatChipsModule } from '@angular/material/chips';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatMenuTrigger, MatMenuModule } from '@angular/material/menu';
import { moveItemInArray, DragDropModule } from '@angular/cdk/drag-drop';
import { MtxUtilsModule } from '@ng-matero/extensions/utils';
import { MtxDialog, MtxDialogModule } from '@ng-matero/extensions/dialog';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { SelectionModel } from '@angular/cdk/collections';
import PhotoViewer from 'photoviewer';
import { Overlay, OverlayModule } from '@angular/cdk/overlay';
import { CdkFlexTableResizeStrategy, ColumnResize, ResizeStrategy, ColumnResizeNotifier, HeaderRowEventDispatcher, ColumnResizeNotifierSource, TABLE_LAYOUT_FIXED_RESIZE_STRATEGY_PROVIDER, ResizeOverlayHandle, ResizeRef, Resizable } from '@ng-matero/extensions/column-resize';
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@angular/material/progress-bar';
import * as ɵngcc3 from '@angular/material/table';
import * as ɵngcc4 from '@angular/material/sort';
import * as ɵngcc5 from '@angular/material/checkbox';
import * as ɵngcc6 from '@angular/material/icon';
import * as ɵngcc7 from '@angular/material/button';
import * as ɵngcc8 from '@angular/material/paginator';
import * as ɵngcc9 from '@ng-matero/extensions/utils';
import * as ɵngcc10 from '@ng-matero/extensions/dialog';
import * as ɵngcc11 from '@angular/material/chips';
import * as ɵngcc12 from '@angular/material/tooltip';
import * as ɵngcc13 from '@angular/material/menu';
import * as ɵngcc14 from '@angular/cdk/drag-drop';
import * as ɵngcc15 from '@angular/forms';
import * as ɵngcc16 from '@ng-matero/extensions/column-resize';
import * as ɵngcc17 from '@angular/cdk/table';
import * as ɵngcc18 from '@angular/cdk/bidi';
import * as ɵngcc19 from '@angular/cdk/overlay';

const _c0 = ["columnMenu"];
const _c1 = ["tableContainer"];
function MtxGridComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 16);
    ɵngcc0.ɵɵelement(1, "mat-progress-bar", 17);
    ɵngcc0.ɵɵelementEnd();
} }
function MtxGridComponent_div_1_ng_template_2_ng_template_0_Template(rf, ctx) { }
function MtxGridComponent_div_1_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, MtxGridComponent_div_1_ng_template_2_ng_template_0_Template, 0, 0, "ng-template", 23);
} if (rf & 2) {
    const ctx_r13 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r13.toolbarTemplate);
} }
function MtxGridComponent_div_1_ng_template_3_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 25);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r18 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r18.toolbarTitle);
} }
function MtxGridComponent_div_1_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, MtxGridComponent_div_1_ng_template_3_div_0_Template, 2, 1, "div", 24);
} if (rf & 2) {
    const ctx_r15 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r15.toolbarTitle);
} }
function MtxGridComponent_div_1_mtx_grid_column_menu_6_Template(rf, ctx) { if (rf & 1) {
    const _r21 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "mtx-grid-column-menu", 26, 27);
    ɵngcc0.ɵɵlistener("selectionChange", function MtxGridComponent_div_1_mtx_grid_column_menu_6_Template_mtx_grid_column_menu_selectionChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r21); const ctx_r20 = ɵngcc0.ɵɵnextContext(2); return ctx_r20._handleColumnChange($event); })("sortChange", function MtxGridComponent_div_1_mtx_grid_column_menu_6_Template_mtx_grid_column_menu_sortChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r21); const ctx_r22 = ɵngcc0.ɵɵnextContext(2); return ctx_r22._handleColumnChange($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r16 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("columns", ctx_r16.columnMenuData)("buttonText", ctx_r16.columnMenuButtonText)("buttonType", ctx_r16.columnMenuButtonType)("buttonColor", ctx_r16.columnMenuButtonColor)("buttonClass", ctx_r16.columnMenuButtonClass)("buttonIcon", ctx_r16.columnMenuButtonIcon)("selectable", ctx_r16.columnHideable)("selectableChecked", ctx_r16.columnHideableChecked)("sortable", ctx_r16.columnMovable)("showHeader", ctx_r16.showColumnMenuHeader)("headerText", ctx_r16.columnMenuHeaderText)("headerTemplate", ctx_r16.columnMenuHeaderTemplate)("showFooter", ctx_r16.showColumnMenuFooter)("footerText", ctx_r16.columnMenuFooterText)("footerTemplate", ctx_r16.columnMenuFooterTemplate);
} }
function MtxGridComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 18);
    ɵngcc0.ɵɵelementStart(1, "div", 19);
    ɵngcc0.ɵɵtemplate(2, MtxGridComponent_div_1_ng_template_2_Template, 1, 1, "ng-template", 13);
    ɵngcc0.ɵɵtemplate(3, MtxGridComponent_div_1_ng_template_3_Template, 1, 1, "ng-template", null, 20, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 21);
    ɵngcc0.ɵɵtemplate(6, MtxGridComponent_div_1_mtx_grid_column_menu_6_Template, 2, 15, "mtx-grid-column-menu", 22);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const _r14 = ɵngcc0.ɵɵreference(4);
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1._isTemplateRef(ctx_r1.toolbarTemplate))("ngIfElse", _r14);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.showColumnMenuButton);
} }
function MtxGridComponent_table_6_ng_container_1_th_1_mat_checkbox_1_Template(rf, ctx) { if (rf & 1) {
    const _r34 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "mat-checkbox", 40);
    ɵngcc0.ɵɵlistener("change", function MtxGridComponent_table_6_ng_container_1_th_1_mat_checkbox_1_Template_mat_checkbox_change_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r34); const ctx_r33 = ɵngcc0.ɵɵnextContext(4); return $event ? ctx_r33._toggleMasterCheckbox() : null; });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r32 = ɵngcc0.ɵɵnextContext(4);
    ɵngcc0.ɵɵproperty("checked", ctx_r32.rowSelection.hasValue() && ctx_r32._isAllSelected())("indeterminate", ctx_r32.rowSelection.hasValue() && !ctx_r32._isAllSelected());
} }
function MtxGridComponent_table_6_ng_container_1_th_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "th", 38);
    ɵngcc0.ɵɵtemplate(1, MtxGridComponent_table_6_ng_container_1_th_1_mat_checkbox_1_Template, 1, 2, "mat-checkbox", 39);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r29 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r29.multiSelectable);
} }
function MtxGridComponent_table_6_ng_container_1_td_2_mat_checkbox_1_Template(rf, ctx) { if (rf & 1) {
    const _r42 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "mat-checkbox", 43);
    ɵngcc0.ɵɵlistener("click", function MtxGridComponent_table_6_ng_container_1_td_2_mat_checkbox_1_Template_mat_checkbox_click_0_listener($event) { return $event.stopPropagation(); })("change", function MtxGridComponent_table_6_ng_container_1_td_2_mat_checkbox_1_Template_mat_checkbox_change_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r42); const row_r35 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r40 = ɵngcc0.ɵɵnextContext(3); return $event ? ctx_r40._toggleNormalCheckbox(row_r35) : null; });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r43 = ɵngcc0.ɵɵnextContext();
    const row_r35 = ctx_r43.$implicit;
    const index_r36 = ctx_r43.index;
    const dataIndex_r37 = ctx_r43.dataIndex;
    const ctx_r38 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("disabled", ctx_r38.rowSelectionFormatter.disabled && ctx_r38.rowSelectionFormatter.disabled(row_r35, ctx_r38._getIndex(index_r36, dataIndex_r37)))("checked", ctx_r38.rowSelection.isSelected(row_r35));
} }
function MtxGridComponent_table_6_ng_container_1_td_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "td", 41);
    ɵngcc0.ɵɵtemplate(1, MtxGridComponent_table_6_ng_container_1_td_2_mat_checkbox_1_Template, 1, 2, "mat-checkbox", 42);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const row_r35 = ctx.$implicit;
    const index_r36 = ctx.index;
    const dataIndex_r37 = ctx.dataIndex;
    const ctx_r30 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !(ctx_r30.rowSelectionFormatter.hideCheckbox && ctx_r30.rowSelectionFormatter.hideCheckbox(row_r35, ctx_r30._getIndex(index_r36, dataIndex_r37))));
} }
function MtxGridComponent_table_6_ng_container_1_td_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "td", 44);
} }
function MtxGridComponent_table_6_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0, 34);
    ɵngcc0.ɵɵtemplate(1, MtxGridComponent_table_6_ng_container_1_th_1_Template, 2, 1, "th", 35);
    ɵngcc0.ɵɵtemplate(2, MtxGridComponent_table_6_ng_container_1_td_2_Template, 2, 1, "td", 36);
    ɵngcc0.ɵɵtemplate(3, MtxGridComponent_table_6_ng_container_1_td_3_Template, 1, 0, "td", 37);
    ɵngcc0.ɵɵelementContainerEnd();
} }
function MtxGridComponent_table_6_ng_container_2_th_2_ng_template_2_ng_template_0_Template(rf, ctx) { }
const _c2 = function (a0, a1) { return { $implicit: a0, colDef: a1 }; };
function MtxGridComponent_table_6_ng_container_2_th_2_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, MtxGridComponent_table_6_ng_container_2_th_2_ng_template_2_ng_template_0_Template, 0, 0, "ng-template", 53);
} if (rf & 2) {
    const col_r44 = ɵngcc0.ɵɵnextContext(2).$implicit;
    const ctx_r48 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r48.headerTemplate)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction2(2, _c2, col_r44, col_r44));
} }
function MtxGridComponent_table_6_ng_container_2_th_2_ng_template_3_ng_template_0_ng_template_0_Template(rf, ctx) { }
function MtxGridComponent_table_6_ng_container_2_th_2_ng_template_3_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, MtxGridComponent_table_6_ng_container_2_th_2_ng_template_3_ng_template_0_ng_template_0_Template, 0, 0, "ng-template", 53);
} if (rf & 2) {
    const col_r44 = ɵngcc0.ɵɵnextContext(3).$implicit;
    const ctx_r55 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r55.headerTemplate[col_r44.field])("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction2(2, _c2, col_r44, col_r44));
} }
function MtxGridComponent_table_6_ng_container_2_th_2_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, MtxGridComponent_table_6_ng_container_2_th_2_ng_template_3_ng_template_0_Template, 1, 5, "ng-template", 13);
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext();
    const _r51 = ɵngcc0.ɵɵreference(6);
    const col_r44 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r50 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r50.headerTemplate && ctx_r50._isTemplateRef(ctx_r50.headerTemplate[col_r44.field]))("ngIfElse", _r51);
} }
function MtxGridComponent_table_6_ng_container_2_th_2_ng_template_5_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 57);
} }
function MtxGridComponent_table_6_ng_container_2_th_2_ng_template_5_mat_icon_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-icon", 58);
    ɵngcc0.ɵɵtext(1, "sort");
    ɵngcc0.ɵɵelementEnd();
} }
function MtxGridComponent_table_6_ng_container_2_th_2_ng_template_5_ng_template_7_Template(rf, ctx) { }
function MtxGridComponent_table_6_ng_container_2_th_2_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 54);
    ɵngcc0.ɵɵtemplate(1, MtxGridComponent_table_6_ng_container_2_th_2_ng_template_5_span_1_Template, 1, 0, "span", 55);
    ɵngcc0.ɵɵelementStart(2, "span");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "async");
    ɵngcc0.ɵɵpipe(5, "toObservable");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(6, MtxGridComponent_table_6_ng_container_2_th_2_ng_template_5_mat_icon_6_Template, 2, 0, "mat-icon", 56);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(7, MtxGridComponent_table_6_ng_container_2_th_2_ng_template_5_ng_template_7_Template, 0, 0, "ng-template", 53);
} if (rf & 2) {
    const col_r44 = ɵngcc0.ɵɵnextContext(2).$implicit;
    const ctx_r52 = ɵngcc0.ɵɵnextContext(2);
    const _r11 = ɵngcc0.ɵɵreference(17);
    ɵngcc0.ɵɵproperty("mat-sort-header", (col_r44.sortProp == null ? null : col_r44.sortProp.id) || col_r44.field)("disabled", !col_r44.sortable)("arrowPosition", col_r44.sortProp == null ? null : col_r44.sortProp.arrowPosition)("disableClear", col_r44.sortProp == null ? null : col_r44.sortProp.disableClear)("start", col_r44.sortProp == null ? null : col_r44.sortProp.start);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", col_r44.showExpand);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(4, 10, ɵngcc0.ɵɵpipeBind1(5, 12, col_r44.header)));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", col_r44.sortable);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r11)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction2(14, _c2, ctx_r52.headerExtraTemplate, col_r44));
} }
const _c3 = function (a0, a1) { return { "mat-table-sticky-left": a0, "mat-table-sticky-right": a1 }; };
const _c4 = function (a0, a1, a2, a3) { return { "width": a0, "min-width": a1, "left": a2, "right": a3 }; };
function MtxGridComponent_table_6_ng_container_2_th_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "th", 49);
    ɵngcc0.ɵɵelementStart(1, "div", 50);
    ɵngcc0.ɵɵtemplate(2, MtxGridComponent_table_6_ng_container_2_th_2_ng_template_2_Template, 1, 5, "ng-template", 13);
    ɵngcc0.ɵɵtemplate(3, MtxGridComponent_table_6_ng_container_2_th_2_ng_template_3_Template, 1, 2, "ng-template", null, 51, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵtemplate(5, MtxGridComponent_table_6_ng_container_2_th_2_ng_template_5_Template, 8, 17, "ng-template", null, 52, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const _r49 = ɵngcc0.ɵɵreference(4);
    const col_r44 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r45 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵclassMap(col_r44.class);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(6, _c3, col_r44.pinned === "left", col_r44.pinned === "right"))("ngStyle", ɵngcc0.ɵɵpureFunction4(9, _c4, col_r44.width, col_r44.width, col_r44.left, col_r44.right));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r45._isTemplateRef(ctx_r45.headerTemplate))("ngIfElse", _r49);
} }
function MtxGridComponent_table_6_ng_container_2_td_3_ng_template_1_ng_template_0_Template(rf, ctx) { }
const _c5 = function (a0, a1, a2, a3) { return { $implicit: a0, rowData: a1, index: a2, colDef: a3 }; };
function MtxGridComponent_table_6_ng_container_2_td_3_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, MtxGridComponent_table_6_ng_container_2_td_3_ng_template_1_ng_template_0_Template, 0, 0, "ng-template", 53);
} if (rf & 2) {
    const ctx_r75 = ɵngcc0.ɵɵnextContext();
    const row_r64 = ctx_r75.$implicit;
    const index_r65 = ctx_r75.index;
    const dataIndex_r66 = ctx_r75.dataIndex;
    const col_r44 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r67 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r67.cellTemplate)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction4(2, _c5, row_r64, row_r64, ctx_r67._getIndex(index_r65, dataIndex_r66), col_r44));
} }
function MtxGridComponent_table_6_ng_container_2_td_3_ng_template_2_ng_template_0_ng_template_0_Template(rf, ctx) { }
function MtxGridComponent_table_6_ng_container_2_td_3_ng_template_2_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, MtxGridComponent_table_6_ng_container_2_td_3_ng_template_2_ng_template_0_ng_template_0_Template, 0, 0, "ng-template", 53);
} if (rf & 2) {
    const ctx_r80 = ɵngcc0.ɵɵnextContext(2);
    const row_r64 = ctx_r80.$implicit;
    const index_r65 = ctx_r80.index;
    const dataIndex_r66 = ctx_r80.dataIndex;
    const col_r44 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r77 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r77.cellTemplate[col_r44.field])("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction4(2, _c5, row_r64, row_r64, ctx_r77._getIndex(index_r65, dataIndex_r66), col_r44));
} }
function MtxGridComponent_table_6_ng_container_2_td_3_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, MtxGridComponent_table_6_ng_container_2_td_3_ng_template_2_ng_template_0_Template, 1, 7, "ng-template", 13);
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext();
    const _r70 = ɵngcc0.ɵɵreference(5);
    const col_r44 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r69 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r69.cellTemplate && ctx_r69._isTemplateRef(ctx_r69.cellTemplate[col_r44.field]))("ngIfElse", _r70);
} }
function MtxGridComponent_table_6_ng_container_2_td_3_ng_template_4_ng_template_0_Template(rf, ctx) { }
function MtxGridComponent_table_6_ng_container_2_td_3_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, MtxGridComponent_table_6_ng_container_2_td_3_ng_template_4_ng_template_0_Template, 0, 0, "ng-template", 63);
} if (rf & 2) {
    const ctx_r84 = ɵngcc0.ɵɵnextContext();
    const row_r64 = ctx_r84.$implicit;
    const index_r65 = ctx_r84.index;
    const dataIndex_r66 = ctx_r84.dataIndex;
    const _r72 = ɵngcc0.ɵɵreference(7);
    const col_r44 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r71 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngIf", col_r44.cellTemplate)("ngIfElse", _r72)("ngTemplateOutlet", col_r44.cellTemplate)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction4(4, _c5, row_r64, row_r64, ctx_r71._getIndex(index_r65, dataIndex_r66), col_r44));
} }
function MtxGridComponent_table_6_ng_container_2_td_3_ng_template_6_button_0_Template(rf, ctx) { if (rf & 1) {
    const _r87 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 66);
    ɵngcc0.ɵɵlistener("openedChange", function MtxGridComponent_table_6_ng_container_2_td_3_ng_template_6_button_0_Template_button_openedChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r87); const dataIndex_r66 = ɵngcc0.ɵɵnextContext(2).dataIndex; const ctx_r86 = ɵngcc0.ɵɵnextContext(3); return ctx_r86.expansionRowStates[dataIndex_r66].expanded = $event; })("toggleChange", function MtxGridComponent_table_6_ng_container_2_td_3_ng_template_6_button_0_Template_button_toggleChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r87); const ctx_r90 = ɵngcc0.ɵɵnextContext(2); const row_r64 = ctx_r90.$implicit; const dataIndex_r66 = ctx_r90.dataIndex; const col_r44 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r89 = ɵngcc0.ɵɵnextContext(2); return ctx_r89._handleExpansionChange($event, row_r64, col_r44, dataIndex_r66); });
    ɵngcc0.ɵɵelementStart(1, "mat-icon");
    ɵngcc0.ɵɵtext(2, "keyboard_arrow_right");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const dataIndex_r66 = ɵngcc0.ɵɵnextContext(2).dataIndex;
    const ctx_r85 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("opened", ctx_r85.expansionRowStates[dataIndex_r66].expanded);
} }
function MtxGridComponent_table_6_ng_container_2_td_3_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, MtxGridComponent_table_6_ng_container_2_td_3_ng_template_6_button_0_Template, 3, 1, "button", 64);
    ɵngcc0.ɵɵelement(1, "mtx-grid-cell", 65);
} if (rf & 2) {
    const row_r64 = ɵngcc0.ɵɵnextContext().$implicit;
    const col_r44 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("ngIf", col_r44.showExpand);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("rowData", row_r64)("colDef", col_r44);
} }
function MtxGridComponent_table_6_ng_container_2_td_3_Template(rf, ctx) { if (rf & 1) {
    const _r96 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "td", 59);
    ɵngcc0.ɵɵlistener("cellSelectionChange", function MtxGridComponent_table_6_ng_container_2_td_3_Template_td_cellSelectionChange_0_listener($event) { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r96); const row_r64 = restoredCtx.$implicit; const col_r44 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r95 = ɵngcc0.ɵɵnextContext(2); return ctx_r95._selectCell($event, row_r64, col_r44); });
    ɵngcc0.ɵɵtemplate(1, MtxGridComponent_table_6_ng_container_2_td_3_ng_template_1_Template, 1, 7, "ng-template", 13);
    ɵngcc0.ɵɵtemplate(2, MtxGridComponent_table_6_ng_container_2_td_3_ng_template_2_Template, 1, 2, "ng-template", null, 60, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵtemplate(4, MtxGridComponent_table_6_ng_container_2_td_3_ng_template_4_Template, 1, 9, "ng-template", null, 61, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵtemplate(6, MtxGridComponent_table_6_ng_container_2_td_3_ng_template_6_Template, 2, 3, "ng-template", null, 62, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const _r68 = ɵngcc0.ɵɵreference(3);
    const col_r44 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r46 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵclassMap(col_r44.class);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(6, _c3, col_r44.pinned === "left", col_r44.pinned === "right"))("ngStyle", ɵngcc0.ɵɵpureFunction4(9, _c4, col_r44.width, col_r44.width, col_r44.left, col_r44.right));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r46._isTemplateRef(ctx_r46.cellTemplate))("ngIfElse", _r68);
} }
function MtxGridComponent_table_6_ng_container_2_td_4_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 57);
} }
function MtxGridComponent_table_6_ng_container_2_td_4_ng_template_2_ng_template_0_Template(rf, ctx) { }
const _c6 = function (a0, a1, a2) { return { $implicit: a0, colDef: a1, data: a2 }; };
function MtxGridComponent_table_6_ng_container_2_td_4_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, MtxGridComponent_table_6_ng_container_2_td_4_ng_template_2_ng_template_0_Template, 0, 0, "ng-template", 53);
} if (rf & 2) {
    const col_r44 = ɵngcc0.ɵɵnextContext(2).$implicit;
    const ctx_r100 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r100.summaryTemplate)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction3(2, _c6, col_r44, col_r44, ctx_r100.data));
} }
function MtxGridComponent_table_6_ng_container_2_td_4_ng_template_3_ng_template_0_ng_template_0_Template(rf, ctx) { }
const _c7 = function (a0, a1, a2) { return { $implicit: a0, colData: a1, colDef: a2 }; };
function MtxGridComponent_table_6_ng_container_2_td_4_ng_template_3_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, MtxGridComponent_table_6_ng_container_2_td_4_ng_template_3_ng_template_0_ng_template_0_Template, 0, 0, "ng-template", 53);
} if (rf & 2) {
    const col_r44 = ɵngcc0.ɵɵnextContext(3).$implicit;
    const ctx_r107 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r107.summaryTemplate[col_r44.field])("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction3(2, _c7, ctx_r107._getColData(ctx_r107.data, col_r44), ctx_r107._getColData(ctx_r107.data, col_r44), col_r44));
} }
function MtxGridComponent_table_6_ng_container_2_td_4_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, MtxGridComponent_table_6_ng_container_2_td_4_ng_template_3_ng_template_0_Template, 1, 6, "ng-template", 13);
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext();
    const _r103 = ɵngcc0.ɵɵreference(6);
    const col_r44 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r102 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r102.summaryTemplate && ctx_r102._isTemplateRef(ctx_r102.summaryTemplate[col_r44.field]))("ngIfElse", _r103);
} }
function MtxGridComponent_table_6_ng_container_2_td_4_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "mtx-grid-cell", 70);
} if (rf & 2) {
    const col_r44 = ɵngcc0.ɵɵnextContext(2).$implicit;
    const ctx_r104 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("summary", true)("data", ctx_r104.data)("colDef", col_r44);
} }
function MtxGridComponent_table_6_ng_container_2_td_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "td", 67);
    ɵngcc0.ɵɵtemplate(1, MtxGridComponent_table_6_ng_container_2_td_4_span_1_Template, 1, 0, "span", 55);
    ɵngcc0.ɵɵtemplate(2, MtxGridComponent_table_6_ng_container_2_td_4_ng_template_2_Template, 1, 6, "ng-template", 13);
    ɵngcc0.ɵɵtemplate(3, MtxGridComponent_table_6_ng_container_2_td_4_ng_template_3_Template, 1, 2, "ng-template", null, 68, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵtemplate(5, MtxGridComponent_table_6_ng_container_2_td_4_ng_template_5_Template, 1, 3, "ng-template", null, 69, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const _r101 = ɵngcc0.ɵɵreference(4);
    const col_r44 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r47 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(5, _c3, col_r44.pinned === "left", col_r44.pinned === "right"))("ngStyle", ɵngcc0.ɵɵpureFunction4(8, _c4, col_r44.width, col_r44.width, col_r44.left, col_r44.right));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", col_r44.showExpand);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r47._isTemplateRef(ctx_r47.summaryTemplate))("ngIfElse", _r101);
} }
function MtxGridComponent_table_6_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementContainerStart(1, 45);
    ɵngcc0.ɵɵtemplate(2, MtxGridComponent_table_6_ng_container_2_th_2_Template, 7, 14, "th", 46);
    ɵngcc0.ɵɵtemplate(3, MtxGridComponent_table_6_ng_container_2_td_3_Template, 8, 14, "td", 47);
    ɵngcc0.ɵɵtemplate(4, MtxGridComponent_table_6_ng_container_2_td_4_Template, 7, 13, "td", 48);
    ɵngcc0.ɵɵelementContainerEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const col_r44 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("matColumnDef", col_r44.field)("sticky", col_r44.pinned === "left")("stickyEnd", col_r44.pinned === "right");
} }
function MtxGridComponent_table_6_tr_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "tr", 71);
} }
function MtxGridComponent_table_6_tr_4_Template(rf, ctx) { if (rf & 1) {
    const _r117 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "tr", 72);
    ɵngcc0.ɵɵlistener("click", function MtxGridComponent_table_6_tr_4_Template_tr_click_0_listener($event) { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r117); const row_r113 = restoredCtx.$implicit; const index_r114 = restoredCtx.index; const dataIndex_r115 = restoredCtx.dataIndex; const ctx_r116 = ɵngcc0.ɵɵnextContext(2); return ctx_r116._selectRow($event, row_r113, ctx_r116._getIndex(index_r114, dataIndex_r115)); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const row_r113 = ctx.$implicit;
    const index_r114 = ctx.index;
    const dataIndex_r115 = ctx.dataIndex;
    const ctx_r26 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r26._getRowClassList(row_r113, ctx_r26._getIndex(index_r114, dataIndex_r115)));
} }
function MtxGridComponent_table_6_ng_container_5_tr_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "tr", 74);
} }
function MtxGridComponent_table_6_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, MtxGridComponent_table_6_ng_container_5_tr_1_Template, 1, 0, "tr", 73);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r27 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("matFooterRowDef", ctx_r27.displayedColumns)("matFooterRowDefSticky", true);
} }
function MtxGridComponent_table_6_ng_container_6_td_2_ng_template_2_Template(rf, ctx) { }
const _c8 = function (a0, a1, a2, a3) { return { $implicit: a0, rowData: a1, index: a2, expanded: a3 }; };
function MtxGridComponent_table_6_ng_container_6_td_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "td", 78);
    ɵngcc0.ɵɵelementStart(1, "div", 79);
    ɵngcc0.ɵɵtemplate(2, MtxGridComponent_table_6_ng_container_6_td_2_ng_template_2_Template, 0, 0, "ng-template", 53);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const row_r121 = ctx.$implicit;
    const dataIndex_r122 = ctx.dataIndex;
    const ctx_r119 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵattribute("colspan", ctx_r119.displayedColumns.length);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("@expansion", ctx_r119.expansionRowStates[dataIndex_r122].expanded ? "expanded" : "collapsed");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r119.expansionTemplate)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction4(4, _c8, row_r121, row_r121, dataIndex_r122, ctx_r119.expansionRowStates[dataIndex_r122].expanded));
} }
const _c9 = function (a1) { return ["mtx-grid-expansion", a1]; };
function MtxGridComponent_table_6_ng_container_6_tr_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "tr", 80);
} if (rf & 2) {
    const dataIndex_r125 = ctx.dataIndex;
    const ctx_r120 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(1, _c9, ctx_r120.expansionRowStates[dataIndex_r125].expanded ? "expanded" : "collapsed"));
} }
const _c10 = function () { return ["MtxGridExpansionColumnDef"]; };
function MtxGridComponent_table_6_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementContainerStart(1, 75);
    ɵngcc0.ɵɵtemplate(2, MtxGridComponent_table_6_ng_container_6_td_2_Template, 3, 9, "td", 76);
    ɵngcc0.ɵɵelementContainerEnd();
    ɵngcc0.ɵɵtemplate(3, MtxGridComponent_table_6_ng_container_6_tr_3_Template, 1, 3, "tr", 77);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("matRowDefColumns", ɵngcc0.ɵɵpureFunction0(1, _c10));
} }
const _c11 = function (a0, a1, a2) { return { "mat-table-hover": a0, "mat-table-striped": a1, "mat-table-expandable": a2 }; };
function MtxGridComponent_table_6_Template(rf, ctx) { if (rf & 1) {
    const _r127 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "table", 28);
    ɵngcc0.ɵɵlistener("matSortChange", function MtxGridComponent_table_6_Template_table_matSortChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r127); const ctx_r126 = ɵngcc0.ɵɵnextContext(); return ctx_r126._handleSortChange($event); });
    ɵngcc0.ɵɵtemplate(1, MtxGridComponent_table_6_ng_container_1_Template, 4, 0, "ng-container", 29);
    ɵngcc0.ɵɵtemplate(2, MtxGridComponent_table_6_ng_container_2_Template, 5, 3, "ng-container", 30);
    ɵngcc0.ɵɵtemplate(3, MtxGridComponent_table_6_tr_3_Template, 1, 0, "tr", 31);
    ɵngcc0.ɵɵtemplate(4, MtxGridComponent_table_6_tr_4_Template, 1, 1, "tr", 32);
    ɵngcc0.ɵɵtemplate(5, MtxGridComponent_table_6_ng_container_5_Template, 2, 2, "ng-container", 33);
    ɵngcc0.ɵɵtemplate(6, MtxGridComponent_table_6_ng_container_6_Template, 4, 2, "ng-container", 33);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction3(16, _c11, ctx_r3.rowHover, ctx_r3.rowStriped, ctx_r3.expandable))("dataSource", ctx_r3.dataSource)("multiTemplateDataRows", ctx_r3.expandable)("matSortActive", ctx_r3.sortActive)("matSortDirection", ctx_r3.sortDirection)("matSortDisableClear", ctx_r3.sortDisableClear)("matSortDisabled", ctx_r3.sortDisabled)("matSortStart", ctx_r3.sortStart)("trackBy", ctx_r3.trackBy);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.rowSelectable && !ctx_r3.hideRowSelectionCheckbox);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r3.columns);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("matHeaderRowDef", ctx_r3.displayedColumns)("matHeaderRowDefSticky", true);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("matRowDefColumns", ctx_r3.displayedColumns);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3._whetherShowSummary);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.expandable);
} }
function MtxGridComponent_table_7_ng_container_1_th_1_mat_checkbox_1_Template(rf, ctx) { if (rf & 1) {
    const _r139 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "mat-checkbox", 40);
    ɵngcc0.ɵɵlistener("change", function MtxGridComponent_table_7_ng_container_1_th_1_mat_checkbox_1_Template_mat_checkbox_change_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r139); const ctx_r138 = ɵngcc0.ɵɵnextContext(4); return $event ? ctx_r138._toggleMasterCheckbox() : null; });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r137 = ɵngcc0.ɵɵnextContext(4);
    ɵngcc0.ɵɵproperty("checked", ctx_r137.rowSelection.hasValue() && ctx_r137._isAllSelected())("indeterminate", ctx_r137.rowSelection.hasValue() && !ctx_r137._isAllSelected());
} }
function MtxGridComponent_table_7_ng_container_1_th_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "th", 38);
    ɵngcc0.ɵɵtemplate(1, MtxGridComponent_table_7_ng_container_1_th_1_mat_checkbox_1_Template, 1, 2, "mat-checkbox", 39);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r134 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r134.multiSelectable);
} }
function MtxGridComponent_table_7_ng_container_1_td_2_mat_checkbox_1_Template(rf, ctx) { if (rf & 1) {
    const _r147 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "mat-checkbox", 43);
    ɵngcc0.ɵɵlistener("click", function MtxGridComponent_table_7_ng_container_1_td_2_mat_checkbox_1_Template_mat_checkbox_click_0_listener($event) { return $event.stopPropagation(); })("change", function MtxGridComponent_table_7_ng_container_1_td_2_mat_checkbox_1_Template_mat_checkbox_change_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r147); const row_r140 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r145 = ɵngcc0.ɵɵnextContext(3); return $event ? ctx_r145._toggleNormalCheckbox(row_r140) : null; });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r148 = ɵngcc0.ɵɵnextContext();
    const row_r140 = ctx_r148.$implicit;
    const index_r141 = ctx_r148.index;
    const dataIndex_r142 = ctx_r148.dataIndex;
    const ctx_r143 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("disabled", ctx_r143.rowSelectionFormatter.disabled && ctx_r143.rowSelectionFormatter.disabled(row_r140, ctx_r143._getIndex(index_r141, dataIndex_r142)))("checked", ctx_r143.rowSelection.isSelected(row_r140));
} }
function MtxGridComponent_table_7_ng_container_1_td_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "td", 41);
    ɵngcc0.ɵɵtemplate(1, MtxGridComponent_table_7_ng_container_1_td_2_mat_checkbox_1_Template, 1, 2, "mat-checkbox", 42);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const row_r140 = ctx.$implicit;
    const index_r141 = ctx.index;
    const dataIndex_r142 = ctx.dataIndex;
    const ctx_r135 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !(ctx_r135.rowSelectionFormatter.hideCheckbox && ctx_r135.rowSelectionFormatter.hideCheckbox(row_r140, ctx_r135._getIndex(index_r141, dataIndex_r142))));
} }
function MtxGridComponent_table_7_ng_container_1_td_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "td", 44);
} }
function MtxGridComponent_table_7_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0, 34);
    ɵngcc0.ɵɵtemplate(1, MtxGridComponent_table_7_ng_container_1_th_1_Template, 2, 1, "th", 35);
    ɵngcc0.ɵɵtemplate(2, MtxGridComponent_table_7_ng_container_1_td_2_Template, 2, 1, "td", 36);
    ɵngcc0.ɵɵtemplate(3, MtxGridComponent_table_7_ng_container_1_td_3_Template, 1, 0, "td", 37);
    ɵngcc0.ɵɵelementContainerEnd();
} }
function MtxGridComponent_table_7_ng_container_2_th_2_ng_template_2_ng_template_0_Template(rf, ctx) { }
function MtxGridComponent_table_7_ng_container_2_th_2_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, MtxGridComponent_table_7_ng_container_2_th_2_ng_template_2_ng_template_0_Template, 0, 0, "ng-template", 53);
} if (rf & 2) {
    const col_r149 = ɵngcc0.ɵɵnextContext(2).$implicit;
    const ctx_r153 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r153.headerTemplate)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction2(2, _c2, col_r149, col_r149));
} }
function MtxGridComponent_table_7_ng_container_2_th_2_ng_template_3_ng_template_0_ng_template_0_Template(rf, ctx) { }
function MtxGridComponent_table_7_ng_container_2_th_2_ng_template_3_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, MtxGridComponent_table_7_ng_container_2_th_2_ng_template_3_ng_template_0_ng_template_0_Template, 0, 0, "ng-template", 53);
} if (rf & 2) {
    const col_r149 = ɵngcc0.ɵɵnextContext(3).$implicit;
    const ctx_r160 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r160.headerTemplate[col_r149.field])("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction2(2, _c2, col_r149, col_r149));
} }
function MtxGridComponent_table_7_ng_container_2_th_2_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, MtxGridComponent_table_7_ng_container_2_th_2_ng_template_3_ng_template_0_Template, 1, 5, "ng-template", 13);
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext();
    const _r156 = ɵngcc0.ɵɵreference(6);
    const col_r149 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r155 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r155.headerTemplate && ctx_r155._isTemplateRef(ctx_r155.headerTemplate[col_r149.field]))("ngIfElse", _r156);
} }
function MtxGridComponent_table_7_ng_container_2_th_2_ng_template_5_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 57);
} }
function MtxGridComponent_table_7_ng_container_2_th_2_ng_template_5_mat_icon_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-icon", 58);
    ɵngcc0.ɵɵtext(1, "sort");
    ɵngcc0.ɵɵelementEnd();
} }
function MtxGridComponent_table_7_ng_container_2_th_2_ng_template_5_ng_template_7_Template(rf, ctx) { }
function MtxGridComponent_table_7_ng_container_2_th_2_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 54);
    ɵngcc0.ɵɵtemplate(1, MtxGridComponent_table_7_ng_container_2_th_2_ng_template_5_span_1_Template, 1, 0, "span", 55);
    ɵngcc0.ɵɵelementStart(2, "span");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "async");
    ɵngcc0.ɵɵpipe(5, "toObservable");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(6, MtxGridComponent_table_7_ng_container_2_th_2_ng_template_5_mat_icon_6_Template, 2, 0, "mat-icon", 56);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(7, MtxGridComponent_table_7_ng_container_2_th_2_ng_template_5_ng_template_7_Template, 0, 0, "ng-template", 53);
} if (rf & 2) {
    const col_r149 = ɵngcc0.ɵɵnextContext(2).$implicit;
    const ctx_r157 = ɵngcc0.ɵɵnextContext(2);
    const _r11 = ɵngcc0.ɵɵreference(17);
    ɵngcc0.ɵɵproperty("mat-sort-header", (col_r149.sortProp == null ? null : col_r149.sortProp.id) || col_r149.field)("disabled", !col_r149.sortable)("arrowPosition", col_r149.sortProp == null ? null : col_r149.sortProp.arrowPosition)("disableClear", col_r149.sortProp == null ? null : col_r149.sortProp.disableClear)("start", col_r149.sortProp == null ? null : col_r149.sortProp.start);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", col_r149.showExpand);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(4, 10, ɵngcc0.ɵɵpipeBind1(5, 12, col_r149.header)));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", col_r149.sortable);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r11)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction2(14, _c2, ctx_r157.headerExtraTemplate, col_r149));
} }
const _c12 = function (a0, a1, a2) { return { "width": a0, "left": a1, "right": a2 }; };
function MtxGridComponent_table_7_ng_container_2_th_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "th", 83);
    ɵngcc0.ɵɵelementStart(1, "div", 50);
    ɵngcc0.ɵɵtemplate(2, MtxGridComponent_table_7_ng_container_2_th_2_ng_template_2_Template, 1, 5, "ng-template", 13);
    ɵngcc0.ɵɵtemplate(3, MtxGridComponent_table_7_ng_container_2_th_2_ng_template_3_Template, 1, 2, "ng-template", null, 51, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵtemplate(5, MtxGridComponent_table_7_ng_container_2_th_2_ng_template_5_Template, 8, 17, "ng-template", null, 52, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const _r154 = ɵngcc0.ɵɵreference(4);
    const col_r149 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r150 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵclassMap(col_r149.class);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(9, _c3, col_r149.pinned === "left", col_r149.pinned === "right"))("ngStyle", ɵngcc0.ɵɵpureFunction3(12, _c12, col_r149.width, col_r149.left, col_r149.right))("resizable", col_r149.resizable)("matResizableMinWidthPx", col_r149.minWidth)("matResizableMaxWidthPx", col_r149.maxWidth);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r150._isTemplateRef(ctx_r150.headerTemplate))("ngIfElse", _r154);
} }
function MtxGridComponent_table_7_ng_container_2_td_3_ng_template_1_ng_template_0_Template(rf, ctx) { }
function MtxGridComponent_table_7_ng_container_2_td_3_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, MtxGridComponent_table_7_ng_container_2_td_3_ng_template_1_ng_template_0_Template, 0, 0, "ng-template", 53);
} if (rf & 2) {
    const ctx_r180 = ɵngcc0.ɵɵnextContext();
    const row_r169 = ctx_r180.$implicit;
    const index_r170 = ctx_r180.index;
    const dataIndex_r171 = ctx_r180.dataIndex;
    const col_r149 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r172 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r172.cellTemplate)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction4(2, _c5, row_r169, row_r169, ctx_r172._getIndex(index_r170, dataIndex_r171), col_r149));
} }
function MtxGridComponent_table_7_ng_container_2_td_3_ng_template_2_ng_template_0_ng_template_0_Template(rf, ctx) { }
function MtxGridComponent_table_7_ng_container_2_td_3_ng_template_2_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, MtxGridComponent_table_7_ng_container_2_td_3_ng_template_2_ng_template_0_ng_template_0_Template, 0, 0, "ng-template", 53);
} if (rf & 2) {
    const ctx_r185 = ɵngcc0.ɵɵnextContext(2);
    const row_r169 = ctx_r185.$implicit;
    const index_r170 = ctx_r185.index;
    const dataIndex_r171 = ctx_r185.dataIndex;
    const col_r149 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r182 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r182.cellTemplate[col_r149.field])("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction4(2, _c5, row_r169, row_r169, ctx_r182._getIndex(index_r170, dataIndex_r171), col_r149));
} }
function MtxGridComponent_table_7_ng_container_2_td_3_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, MtxGridComponent_table_7_ng_container_2_td_3_ng_template_2_ng_template_0_Template, 1, 7, "ng-template", 13);
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext();
    const _r175 = ɵngcc0.ɵɵreference(5);
    const col_r149 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r174 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r174.cellTemplate && ctx_r174._isTemplateRef(ctx_r174.cellTemplate[col_r149.field]))("ngIfElse", _r175);
} }
function MtxGridComponent_table_7_ng_container_2_td_3_ng_template_4_ng_template_0_Template(rf, ctx) { }
function MtxGridComponent_table_7_ng_container_2_td_3_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, MtxGridComponent_table_7_ng_container_2_td_3_ng_template_4_ng_template_0_Template, 0, 0, "ng-template", 63);
} if (rf & 2) {
    const ctx_r189 = ɵngcc0.ɵɵnextContext();
    const row_r169 = ctx_r189.$implicit;
    const index_r170 = ctx_r189.index;
    const dataIndex_r171 = ctx_r189.dataIndex;
    const _r177 = ɵngcc0.ɵɵreference(7);
    const col_r149 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r176 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngIf", col_r149.cellTemplate)("ngIfElse", _r177)("ngTemplateOutlet", col_r149.cellTemplate)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction4(4, _c5, row_r169, row_r169, ctx_r176._getIndex(index_r170, dataIndex_r171), col_r149));
} }
function MtxGridComponent_table_7_ng_container_2_td_3_ng_template_6_button_0_Template(rf, ctx) { if (rf & 1) {
    const _r192 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 66);
    ɵngcc0.ɵɵlistener("openedChange", function MtxGridComponent_table_7_ng_container_2_td_3_ng_template_6_button_0_Template_button_openedChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r192); const dataIndex_r171 = ɵngcc0.ɵɵnextContext(2).dataIndex; const ctx_r191 = ɵngcc0.ɵɵnextContext(3); return ctx_r191.expansionRowStates[dataIndex_r171].expanded = $event; })("toggleChange", function MtxGridComponent_table_7_ng_container_2_td_3_ng_template_6_button_0_Template_button_toggleChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r192); const ctx_r195 = ɵngcc0.ɵɵnextContext(2); const row_r169 = ctx_r195.$implicit; const dataIndex_r171 = ctx_r195.dataIndex; const col_r149 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r194 = ɵngcc0.ɵɵnextContext(2); return ctx_r194._handleExpansionChange($event, row_r169, col_r149, dataIndex_r171); });
    ɵngcc0.ɵɵelementStart(1, "mat-icon");
    ɵngcc0.ɵɵtext(2, "keyboard_arrow_right");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const dataIndex_r171 = ɵngcc0.ɵɵnextContext(2).dataIndex;
    const ctx_r190 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("opened", ctx_r190.expansionRowStates[dataIndex_r171].expanded);
} }
function MtxGridComponent_table_7_ng_container_2_td_3_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, MtxGridComponent_table_7_ng_container_2_td_3_ng_template_6_button_0_Template, 3, 1, "button", 64);
    ɵngcc0.ɵɵelement(1, "mtx-grid-cell", 65);
} if (rf & 2) {
    const row_r169 = ɵngcc0.ɵɵnextContext().$implicit;
    const col_r149 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("ngIf", col_r149.showExpand);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("rowData", row_r169)("colDef", col_r149);
} }
function MtxGridComponent_table_7_ng_container_2_td_3_Template(rf, ctx) { if (rf & 1) {
    const _r201 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "td", 59);
    ɵngcc0.ɵɵlistener("cellSelectionChange", function MtxGridComponent_table_7_ng_container_2_td_3_Template_td_cellSelectionChange_0_listener($event) { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r201); const row_r169 = restoredCtx.$implicit; const col_r149 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r200 = ɵngcc0.ɵɵnextContext(2); return ctx_r200._selectCell($event, row_r169, col_r149); });
    ɵngcc0.ɵɵtemplate(1, MtxGridComponent_table_7_ng_container_2_td_3_ng_template_1_Template, 1, 7, "ng-template", 13);
    ɵngcc0.ɵɵtemplate(2, MtxGridComponent_table_7_ng_container_2_td_3_ng_template_2_Template, 1, 2, "ng-template", null, 60, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵtemplate(4, MtxGridComponent_table_7_ng_container_2_td_3_ng_template_4_Template, 1, 9, "ng-template", null, 61, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵtemplate(6, MtxGridComponent_table_7_ng_container_2_td_3_ng_template_6_Template, 2, 3, "ng-template", null, 62, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const _r173 = ɵngcc0.ɵɵreference(3);
    const col_r149 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r151 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵclassMap(col_r149.class);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(6, _c3, col_r149.pinned === "left", col_r149.pinned === "right"))("ngStyle", ɵngcc0.ɵɵpureFunction3(9, _c12, col_r149.width, col_r149.left, col_r149.right));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r151._isTemplateRef(ctx_r151.cellTemplate))("ngIfElse", _r173);
} }
function MtxGridComponent_table_7_ng_container_2_td_4_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 57);
} }
function MtxGridComponent_table_7_ng_container_2_td_4_ng_template_2_ng_template_0_Template(rf, ctx) { }
function MtxGridComponent_table_7_ng_container_2_td_4_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, MtxGridComponent_table_7_ng_container_2_td_4_ng_template_2_ng_template_0_Template, 0, 0, "ng-template", 53);
} if (rf & 2) {
    const col_r149 = ɵngcc0.ɵɵnextContext(2).$implicit;
    const ctx_r205 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r205.summaryTemplate)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction3(2, _c6, col_r149, col_r149, ctx_r205.data));
} }
function MtxGridComponent_table_7_ng_container_2_td_4_ng_template_3_ng_template_0_ng_template_0_Template(rf, ctx) { }
function MtxGridComponent_table_7_ng_container_2_td_4_ng_template_3_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, MtxGridComponent_table_7_ng_container_2_td_4_ng_template_3_ng_template_0_ng_template_0_Template, 0, 0, "ng-template", 53);
} if (rf & 2) {
    const col_r149 = ɵngcc0.ɵɵnextContext(3).$implicit;
    const ctx_r212 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r212.summaryTemplate[col_r149.field])("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction3(2, _c7, ctx_r212._getColData(ctx_r212.data, col_r149), ctx_r212._getColData(ctx_r212.data, col_r149), col_r149));
} }
function MtxGridComponent_table_7_ng_container_2_td_4_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, MtxGridComponent_table_7_ng_container_2_td_4_ng_template_3_ng_template_0_Template, 1, 6, "ng-template", 13);
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext();
    const _r208 = ɵngcc0.ɵɵreference(6);
    const col_r149 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r207 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r207.summaryTemplate && ctx_r207._isTemplateRef(ctx_r207.summaryTemplate[col_r149.field]))("ngIfElse", _r208);
} }
function MtxGridComponent_table_7_ng_container_2_td_4_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "mtx-grid-cell", 70);
} if (rf & 2) {
    const col_r149 = ɵngcc0.ɵɵnextContext(2).$implicit;
    const ctx_r209 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("summary", true)("data", ctx_r209.data)("colDef", col_r149);
} }
function MtxGridComponent_table_7_ng_container_2_td_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "td", 67);
    ɵngcc0.ɵɵtemplate(1, MtxGridComponent_table_7_ng_container_2_td_4_span_1_Template, 1, 0, "span", 55);
    ɵngcc0.ɵɵtemplate(2, MtxGridComponent_table_7_ng_container_2_td_4_ng_template_2_Template, 1, 6, "ng-template", 13);
    ɵngcc0.ɵɵtemplate(3, MtxGridComponent_table_7_ng_container_2_td_4_ng_template_3_Template, 1, 2, "ng-template", null, 68, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵtemplate(5, MtxGridComponent_table_7_ng_container_2_td_4_ng_template_5_Template, 1, 3, "ng-template", null, 69, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const _r206 = ɵngcc0.ɵɵreference(4);
    const col_r149 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r152 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(5, _c3, col_r149.pinned === "left", col_r149.pinned === "right"))("ngStyle", ɵngcc0.ɵɵpureFunction3(8, _c12, col_r149.width, col_r149.left, col_r149.right));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", col_r149.showExpand);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r152._isTemplateRef(ctx_r152.summaryTemplate))("ngIfElse", _r206);
} }
function MtxGridComponent_table_7_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementContainerStart(1, 45);
    ɵngcc0.ɵɵtemplate(2, MtxGridComponent_table_7_ng_container_2_th_2_Template, 7, 16, "th", 82);
    ɵngcc0.ɵɵtemplate(3, MtxGridComponent_table_7_ng_container_2_td_3_Template, 8, 13, "td", 47);
    ɵngcc0.ɵɵtemplate(4, MtxGridComponent_table_7_ng_container_2_td_4_Template, 7, 12, "td", 48);
    ɵngcc0.ɵɵelementContainerEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const col_r149 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("matColumnDef", col_r149.field)("sticky", col_r149.pinned === "left")("stickyEnd", col_r149.pinned === "right");
} }
function MtxGridComponent_table_7_tr_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "tr", 71);
} }
function MtxGridComponent_table_7_tr_4_Template(rf, ctx) { if (rf & 1) {
    const _r222 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "tr", 72);
    ɵngcc0.ɵɵlistener("click", function MtxGridComponent_table_7_tr_4_Template_tr_click_0_listener($event) { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r222); const row_r218 = restoredCtx.$implicit; const index_r219 = restoredCtx.index; const dataIndex_r220 = restoredCtx.dataIndex; const ctx_r221 = ɵngcc0.ɵɵnextContext(2); return ctx_r221._selectRow($event, row_r218, ctx_r221._getIndex(index_r219, dataIndex_r220)); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const row_r218 = ctx.$implicit;
    const index_r219 = ctx.index;
    const dataIndex_r220 = ctx.dataIndex;
    const ctx_r131 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r131._getRowClassList(row_r218, ctx_r131._getIndex(index_r219, dataIndex_r220)));
} }
function MtxGridComponent_table_7_ng_container_5_tr_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "tr", 74);
} }
function MtxGridComponent_table_7_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, MtxGridComponent_table_7_ng_container_5_tr_1_Template, 1, 0, "tr", 73);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r132 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("matFooterRowDef", ctx_r132.displayedColumns)("matFooterRowDefSticky", true);
} }
function MtxGridComponent_table_7_ng_container_6_td_2_ng_template_2_Template(rf, ctx) { }
function MtxGridComponent_table_7_ng_container_6_td_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "td", 78);
    ɵngcc0.ɵɵelementStart(1, "div", 79);
    ɵngcc0.ɵɵtemplate(2, MtxGridComponent_table_7_ng_container_6_td_2_ng_template_2_Template, 0, 0, "ng-template", 53);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const row_r226 = ctx.$implicit;
    const dataIndex_r227 = ctx.dataIndex;
    const ctx_r224 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵattribute("colspan", ctx_r224.displayedColumns.length);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("@expansion", ctx_r224.expansionRowStates[dataIndex_r227].expanded ? "expanded" : "collapsed");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r224.expansionTemplate)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction4(4, _c8, row_r226, row_r226, dataIndex_r227, ctx_r224.expansionRowStates[dataIndex_r227].expanded));
} }
function MtxGridComponent_table_7_ng_container_6_tr_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "tr", 80);
} if (rf & 2) {
    const dataIndex_r230 = ctx.dataIndex;
    const ctx_r225 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(1, _c9, ctx_r225.expansionRowStates[dataIndex_r230].expanded ? "expanded" : "collapsed"));
} }
function MtxGridComponent_table_7_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementContainerStart(1, 75);
    ɵngcc0.ɵɵtemplate(2, MtxGridComponent_table_7_ng_container_6_td_2_Template, 3, 9, "td", 76);
    ɵngcc0.ɵɵelementContainerEnd();
    ɵngcc0.ɵɵtemplate(3, MtxGridComponent_table_7_ng_container_6_tr_3_Template, 1, 3, "tr", 77);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("matRowDefColumns", ɵngcc0.ɵɵpureFunction0(1, _c10));
} }
function MtxGridComponent_table_7_Template(rf, ctx) { if (rf & 1) {
    const _r232 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "table", 81);
    ɵngcc0.ɵɵlistener("matSortChange", function MtxGridComponent_table_7_Template_table_matSortChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r232); const ctx_r231 = ɵngcc0.ɵɵnextContext(); return ctx_r231._handleSortChange($event); });
    ɵngcc0.ɵɵtemplate(1, MtxGridComponent_table_7_ng_container_1_Template, 4, 0, "ng-container", 29);
    ɵngcc0.ɵɵtemplate(2, MtxGridComponent_table_7_ng_container_2_Template, 5, 3, "ng-container", 30);
    ɵngcc0.ɵɵtemplate(3, MtxGridComponent_table_7_tr_3_Template, 1, 0, "tr", 31);
    ɵngcc0.ɵɵtemplate(4, MtxGridComponent_table_7_tr_4_Template, 1, 1, "tr", 32);
    ɵngcc0.ɵɵtemplate(5, MtxGridComponent_table_7_ng_container_5_Template, 2, 2, "ng-container", 33);
    ɵngcc0.ɵɵtemplate(6, MtxGridComponent_table_7_ng_container_6_Template, 4, 2, "ng-container", 33);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction3(16, _c11, ctx_r4.rowHover, ctx_r4.rowStriped, ctx_r4.expandable))("dataSource", ctx_r4.dataSource)("multiTemplateDataRows", ctx_r4.expandable)("matSortActive", ctx_r4.sortActive)("matSortDirection", ctx_r4.sortDirection)("matSortDisableClear", ctx_r4.sortDisableClear)("matSortDisabled", ctx_r4.sortDisabled)("matSortStart", ctx_r4.sortStart)("trackBy", ctx_r4.trackBy);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.rowSelectable && !ctx_r4.hideRowSelectionCheckbox);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r4.columns);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("matHeaderRowDef", ctx_r4.displayedColumns)("matHeaderRowDefSticky", true);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("matRowDefColumns", ctx_r4.displayedColumns);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4._whetherShowSummary);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.expandable);
} }
function MtxGridComponent_div_8_ng_template_1_ng_template_0_Template(rf, ctx) { }
function MtxGridComponent_div_8_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, MtxGridComponent_div_8_ng_template_1_ng_template_0_Template, 0, 0, "ng-template", 23);
} if (rf & 2) {
    const ctx_r233 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r233.noResultTemplate);
} }
function MtxGridComponent_div_8_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtext(0);
} if (rf & 2) {
    const ctx_r235 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r235.noResultText);
} }
function MtxGridComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 84);
    ɵngcc0.ɵɵtemplate(1, MtxGridComponent_div_8_ng_template_1_Template, 1, 1, "ng-template", 13);
    ɵngcc0.ɵɵtemplate(2, MtxGridComponent_div_8_ng_template_2_Template, 1, 1, "ng-template", null, 85, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const _r234 = ɵngcc0.ɵɵreference(3);
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r5._isTemplateRef(ctx_r5.noResultTemplate))("ngIfElse", _r234);
} }
function MtxGridComponent_div_9_ng_template_1_ng_template_0_Template(rf, ctx) { }
function MtxGridComponent_div_9_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, MtxGridComponent_div_9_ng_template_1_ng_template_0_Template, 0, 0, "ng-template", 23);
} if (rf & 2) {
    const ctx_r237 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r237.sidebarTemplate);
} }
function MtxGridComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 86);
    ɵngcc0.ɵɵtemplate(1, MtxGridComponent_div_9_ng_template_1_Template, 1, 1, "ng-template", 87);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r6._isTemplateRef(ctx_r6.sidebarTemplate));
} }
function MtxGridComponent_div_11_ng_template_1_ng_template_0_Template(rf, ctx) { }
function MtxGridComponent_div_11_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, MtxGridComponent_div_11_ng_template_1_ng_template_0_Template, 0, 0, "ng-template", 23);
} if (rf & 2) {
    const ctx_r239 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r239.statusbarTemplate);
} }
function MtxGridComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 88);
    ɵngcc0.ɵɵtemplate(1, MtxGridComponent_div_11_ng_template_1_Template, 1, 1, "ng-template", 87);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r7._isTemplateRef(ctx_r7.statusbarTemplate));
} }
function MtxGridComponent_ng_template_13_ng_template_0_Template(rf, ctx) { }
function MtxGridComponent_ng_template_13_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, MtxGridComponent_ng_template_13_ng_template_0_Template, 0, 0, "ng-template", 23);
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r8.paginationTemplate);
} }
function MtxGridComponent_ng_template_14_Template(rf, ctx) { if (rf & 1) {
    const _r243 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "mat-paginator", 89);
    ɵngcc0.ɵɵlistener("page", function MtxGridComponent_ng_template_14_Template_mat_paginator_page_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r243); const ctx_r242 = ɵngcc0.ɵɵnextContext(); return ctx_r242._handlePage($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("mat-paginator-hidden", !ctx_r10.showPaginator || ctx_r10._hasNoResult);
    ɵngcc0.ɵɵproperty("showFirstLastButtons", ctx_r10.showFirstLastButtons)("length", ctx_r10.length)("pageIndex", ctx_r10.pageIndex)("pageSize", ctx_r10.pageSize)("pageSizeOptions", ctx_r10.pageSizeOptions)("hidePageSize", ctx_r10.hidePageSize)("disabled", ctx_r10.pageDisabled);
} }
function MtxGridComponent_ng_template_16_ng_template_0_ng_template_0_Template(rf, ctx) { }
function MtxGridComponent_ng_template_16_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, MtxGridComponent_ng_template_16_ng_template_0_ng_template_0_Template, 0, 0, "ng-template", 53);
} if (rf & 2) {
    const ctx_r250 = ɵngcc0.ɵɵnextContext();
    const headerExtraTemplate_r244 = ctx_r250.$implicit;
    const col_r245 = ctx_r250.colDef;
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", headerExtraTemplate_r244)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction2(2, _c2, col_r245, col_r245));
} }
function MtxGridComponent_ng_template_16_ng_template_1_ng_template_0_ng_template_0_Template(rf, ctx) { }
function MtxGridComponent_ng_template_16_ng_template_1_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, MtxGridComponent_ng_template_16_ng_template_1_ng_template_0_ng_template_0_Template, 0, 0, "ng-template", 53);
} if (rf & 2) {
    const ctx_r253 = ɵngcc0.ɵɵnextContext(2);
    const headerExtraTemplate_r244 = ctx_r253.$implicit;
    const col_r245 = ctx_r253.colDef;
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", headerExtraTemplate_r244[col_r245.field])("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction2(2, _c2, col_r245, col_r245));
} }
function MtxGridComponent_ng_template_16_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, MtxGridComponent_ng_template_16_ng_template_1_ng_template_0_Template, 1, 5, "ng-template", 87);
} if (rf & 2) {
    const ctx_r254 = ɵngcc0.ɵɵnextContext();
    const headerExtraTemplate_r244 = ctx_r254.$implicit;
    const col_r245 = ctx_r254.colDef;
    const ctx_r248 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngIf", headerExtraTemplate_r244 && ctx_r248._isTemplateRef(headerExtraTemplate_r244[col_r245.field]));
} }
function MtxGridComponent_ng_template_16_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, MtxGridComponent_ng_template_16_ng_template_0_Template, 1, 5, "ng-template", 13);
    ɵngcc0.ɵɵtemplate(1, MtxGridComponent_ng_template_16_ng_template_1_Template, 1, 1, "ng-template", null, 90, ɵngcc0.ɵɵtemplateRefExtractor);
} if (rf & 2) {
    const headerExtraTemplate_r244 = ctx.$implicit;
    const _r247 = ɵngcc0.ɵɵreference(2);
    const ctx_r12 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngIf", ctx_r12._isTemplateRef(headerExtraTemplate_r244))("ngIfElse", _r247);
} }
const _c13 = function (a0) { return { "mat-table-with-data": a0 }; };
function MtxGridCellComponent_span_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 3);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("title", ctx_r0._getFormatterTooltip(ctx_r0._formatSummary(ctx_r0.data, ctx_r0.colDef)))("innerHTML", ctx_r0._getText(ctx_r0._formatSummary(ctx_r0.data, ctx_r0.colDef)), ɵngcc0.ɵɵsanitizeHtml);
} }
function MtxGridCellComponent_ng_template_1_span_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 3);
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("title", ctx_r5._getFormatterTooltip(ctx_r5.colDef.formatter(ctx_r5.rowData, ctx_r5.colDef)))("innerHTML", ctx_r5._getText(ctx_r5.colDef.formatter(ctx_r5.rowData, ctx_r5.colDef)), ɵngcc0.ɵɵsanitizeHtml);
} }
function MtxGridCellComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, MtxGridCellComponent_ng_template_1_span_0_Template, 1, 2, "span", 0);
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    const _r3 = ɵngcc0.ɵɵreference(4);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.colDef.formatter)("ngIfElse", _r3);
} }
const _c14 = function (a0) { return [a0]; };
function MtxGridCellComponent_ng_template_3_ng_container_1_mat_chip_list_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-chip-list");
    ɵngcc0.ɵɵelementStart(1, "mat-chip", 9);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r16 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(2, _c14, "bg-" + ctx_r16.colDef.tag[ctx_r16._colValue].color));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r16.colDef.tag[ctx_r16._colValue].text, " ");
} }
function MtxGridCellComponent_ng_template_3_ng_container_1_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtext(0);
} if (rf & 2) {
    const ctx_r18 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r18._colValue);
} }
function MtxGridCellComponent_ng_template_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, MtxGridCellComponent_ng_template_3_ng_container_1_mat_chip_list_1_Template, 3, 4, "mat-chip-list", 7);
    ɵngcc0.ɵɵtemplate(2, MtxGridCellComponent_ng_template_3_ng_container_1_ng_template_2_Template, 1, 1, "ng-template", null, 8, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r17 = ɵngcc0.ɵɵreference(3);
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r6.colDef.tag && ctx_r6.colDef.tag[ctx_r6._colValue])("ngIfElse", _r17);
} }
function MtxGridCellComponent_ng_template_3_ng_container_2_ng_container_1_ng_container_1_ng_container_1_button_1_mat_icon_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-icon");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const btn_r20 = ɵngcc0.ɵɵnextContext(4).$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(btn_r20.icon);
} }
const _c15 = function (a1) { return ["mtx-grid-action-button", a1]; };
function MtxGridCellComponent_ng_template_3_ng_container_2_ng_container_1_ng_container_1_ng_container_1_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r31 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 15);
    ɵngcc0.ɵɵlistener("click", function MtxGridCellComponent_ng_template_3_ng_container_2_ng_container_1_ng_container_1_ng_container_1_button_1_Template_button_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r31); const btn_r20 = ɵngcc0.ɵɵnextContext(3).$implicit; const ctx_r29 = ɵngcc0.ɵɵnextContext(3); return ctx_r29._handleActionConfirm($event, btn_r20.popTitle, btn_r20.popDescription, btn_r20.popOkColor, btn_r20.popOkText, btn_r20.popCloseColor, btn_r20.popCloseText, btn_r20.click, ctx_r29.rowData); });
    ɵngcc0.ɵɵpipe(1, "async");
    ɵngcc0.ɵɵpipe(2, "toObservable");
    ɵngcc0.ɵɵtemplate(3, MtxGridCellComponent_ng_template_3_ng_container_2_ng_container_1_ng_container_1_ng_container_1_button_1_mat_icon_3_Template, 2, 1, "mat-icon", 11);
    ɵngcc0.ɵɵelementStart(4, "span");
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵpipe(6, "async");
    ɵngcc0.ɵɵpipe(7, "toObservable");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const btn_r20 = ɵngcc0.ɵɵnextContext(3).$implicit;
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(14, _c15, btn_r20.class || ""))("color", btn_r20.color || "primary")("disabled", btn_r20.disabled)("matTooltip", ɵngcc0.ɵɵpipeBind1(1, 6, ɵngcc0.ɵɵpipeBind1(2, 8, btn_r20.tooltip)));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", btn_r20.icon);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(6, 10, ɵngcc0.ɵɵpipeBind1(7, 12, btn_r20.text)));
} }
function MtxGridCellComponent_ng_template_3_ng_container_2_ng_container_1_ng_container_1_ng_container_1_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r35 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 16);
    ɵngcc0.ɵɵlistener("click", function MtxGridCellComponent_ng_template_3_ng_container_2_ng_container_1_ng_container_1_ng_container_1_button_2_Template_button_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r35); const btn_r20 = ɵngcc0.ɵɵnextContext(3).$implicit; const ctx_r33 = ɵngcc0.ɵɵnextContext(3); return ctx_r33._handleActionConfirm($event, btn_r20.popTitle, btn_r20.popDescription, btn_r20.popOkColor, btn_r20.popOkText, btn_r20.popCloseColor, btn_r20.popCloseText, btn_r20.click, ctx_r33.rowData); });
    ɵngcc0.ɵɵpipe(1, "async");
    ɵngcc0.ɵɵpipe(2, "toObservable");
    ɵngcc0.ɵɵelementStart(3, "mat-icon");
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const btn_r20 = ɵngcc0.ɵɵnextContext(3).$implicit;
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(9, _c15, btn_r20.class || ""))("color", btn_r20.color || "primary")("disabled", btn_r20.disabled)("matTooltip", ɵngcc0.ɵɵpipeBind1(1, 5, ɵngcc0.ɵɵpipeBind1(2, 7, btn_r20.tooltip)));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(btn_r20.icon);
} }
function MtxGridCellComponent_ng_template_3_ng_container_2_ng_container_1_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, MtxGridCellComponent_ng_template_3_ng_container_2_ng_container_1_ng_container_1_ng_container_1_button_1_Template, 8, 16, "button", 13);
    ɵngcc0.ɵɵtemplate(2, MtxGridCellComponent_ng_template_3_ng_container_2_ng_container_1_ng_container_1_ng_container_1_button_2_Template, 5, 11, "button", 14);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const btn_r20 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", btn_r20.type === "basic");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !btn_r20.type || btn_r20.type === "icon");
} }
function MtxGridCellComponent_ng_template_3_ng_container_2_ng_container_1_ng_container_1_ng_template_2_button_0_mat_icon_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-icon");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const btn_r20 = ɵngcc0.ɵɵnextContext(4).$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(btn_r20.icon);
} }
function MtxGridCellComponent_ng_template_3_ng_container_2_ng_container_1_ng_container_1_ng_template_2_button_0_Template(rf, ctx) { if (rf & 1) {
    const _r44 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 15);
    ɵngcc0.ɵɵlistener("click", function MtxGridCellComponent_ng_template_3_ng_container_2_ng_container_1_ng_container_1_ng_template_2_button_0_Template_button_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r44); const btn_r20 = ɵngcc0.ɵɵnextContext(3).$implicit; const ctx_r42 = ɵngcc0.ɵɵnextContext(3); return ctx_r42._handleActionClick($event, btn_r20, ctx_r42.rowData); });
    ɵngcc0.ɵɵpipe(1, "async");
    ɵngcc0.ɵɵpipe(2, "toObservable");
    ɵngcc0.ɵɵtemplate(3, MtxGridCellComponent_ng_template_3_ng_container_2_ng_container_1_ng_container_1_ng_template_2_button_0_mat_icon_3_Template, 2, 1, "mat-icon", 11);
    ɵngcc0.ɵɵelementStart(4, "span");
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵpipe(6, "async");
    ɵngcc0.ɵɵpipe(7, "toObservable");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const btn_r20 = ɵngcc0.ɵɵnextContext(3).$implicit;
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(14, _c15, btn_r20.class || ""))("color", btn_r20.color || "primary")("disabled", btn_r20.disabled)("matTooltip", ɵngcc0.ɵɵpipeBind1(1, 6, ɵngcc0.ɵɵpipeBind1(2, 8, btn_r20.tooltip)));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", btn_r20.icon);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(6, 10, ɵngcc0.ɵɵpipeBind1(7, 12, btn_r20.text)));
} }
function MtxGridCellComponent_ng_template_3_ng_container_2_ng_container_1_ng_container_1_ng_template_2_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r48 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 16);
    ɵngcc0.ɵɵlistener("click", function MtxGridCellComponent_ng_template_3_ng_container_2_ng_container_1_ng_container_1_ng_template_2_button_1_Template_button_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r48); const btn_r20 = ɵngcc0.ɵɵnextContext(3).$implicit; const ctx_r46 = ɵngcc0.ɵɵnextContext(3); return ctx_r46._handleActionClick($event, btn_r20, ctx_r46.rowData); });
    ɵngcc0.ɵɵpipe(1, "async");
    ɵngcc0.ɵɵpipe(2, "toObservable");
    ɵngcc0.ɵɵelementStart(3, "mat-icon");
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const btn_r20 = ɵngcc0.ɵɵnextContext(3).$implicit;
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(9, _c15, btn_r20.class || ""))("color", btn_r20.color || "primary")("disabled", btn_r20.disabled)("matTooltip", ɵngcc0.ɵɵpipeBind1(1, 5, ɵngcc0.ɵɵpipeBind1(2, 7, btn_r20.tooltip)));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(btn_r20.icon);
} }
function MtxGridCellComponent_ng_template_3_ng_container_2_ng_container_1_ng_container_1_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, MtxGridCellComponent_ng_template_3_ng_container_2_ng_container_1_ng_container_1_ng_template_2_button_0_Template, 8, 16, "button", 13);
    ɵngcc0.ɵɵtemplate(1, MtxGridCellComponent_ng_template_3_ng_container_2_ng_container_1_ng_container_1_ng_template_2_button_1_Template, 5, 11, "button", 14);
} if (rf & 2) {
    const btn_r20 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵproperty("ngIf", btn_r20.type === "basic");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !btn_r20.type || btn_r20.type === "icon");
} }
function MtxGridCellComponent_ng_template_3_ng_container_2_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, MtxGridCellComponent_ng_template_3_ng_container_2_ng_container_1_ng_container_1_ng_container_1_Template, 3, 2, "ng-container", 7);
    ɵngcc0.ɵɵtemplate(2, MtxGridCellComponent_ng_template_3_ng_container_2_ng_container_1_ng_container_1_ng_template_2_Template, 2, 2, "ng-template", null, 12, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r23 = ɵngcc0.ɵɵreference(3);
    const btn_r20 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", btn_r20.pop)("ngIfElse", _r23);
} }
function MtxGridCellComponent_ng_template_3_ng_container_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, MtxGridCellComponent_ng_template_3_ng_container_2_ng_container_1_ng_container_1_Template, 4, 2, "ng-container", 11);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const btn_r20 = ctx.$implicit;
    const ctx_r19 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !btn_r20.iif || btn_r20.iif(ctx_r19.rowData));
} }
function MtxGridCellComponent_ng_template_3_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, MtxGridCellComponent_ng_template_3_ng_container_2_ng_container_1_Template, 2, 1, "ng-container", 10);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r7.colDef.buttons);
} }
function MtxGridCellComponent_ng_template_3_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "a", 17);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("href", ctx_r8._colValue, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r8._colValue);
} }
function MtxGridCellComponent_ng_template_3_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    const _r53 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "img", 18);
    ɵngcc0.ɵɵlistener("click", function MtxGridCellComponent_ng_template_3_ng_container_4_Template_img_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r53); const ctx_r52 = ɵngcc0.ɵɵnextContext(2); return ctx_r52._onPreview(ctx_r52._colValue); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r9 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("src", ctx_r9._colValue, ɵngcc0.ɵɵsanitizeUrl);
} }
function MtxGridCellComponent_ng_template_3_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "span", 19);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r10 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("title", ctx_r10._getTooltip(ctx_r10._colValue));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r10._getText(ctx_r10._colValue));
} }
function MtxGridCellComponent_ng_template_3_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "span", 19);
    ɵngcc0.ɵɵpipe(2, "number");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "number");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r11 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("title", ctx_r11._getTooltip(ɵngcc0.ɵɵpipeBind3(2, 2, ctx_r11._colValue, ctx_r11.colDef.typeParameter == null ? null : ctx_r11.colDef.typeParameter.digitsInfo, ctx_r11.colDef.typeParameter == null ? null : ctx_r11.colDef.typeParameter.locale)));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r11._getText(ɵngcc0.ɵɵpipeBind3(4, 6, ctx_r11._colValue, ctx_r11.colDef.typeParameter == null ? null : ctx_r11.colDef.typeParameter.digitsInfo, ctx_r11.colDef.typeParameter == null ? null : ctx_r11.colDef.typeParameter.locale)), " ");
} }
const _c16 = function (a0, a1, a2, a3, a4) { return [a0, a1, a2, a3, a4]; };
function MtxGridCellComponent_ng_template_3_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "span", 19);
    ɵngcc0.ɵɵpipe(2, "currency");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "currency");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r12 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("title", ctx_r12._getTooltip(ɵngcc0.ɵɵpipeBindV(2, 2, ɵngcc0.ɵɵpureFunction5(14, _c16, ctx_r12._colValue, ctx_r12.colDef.typeParameter == null ? null : ctx_r12.colDef.typeParameter.currencyCode, ctx_r12.colDef.typeParameter == null ? null : ctx_r12.colDef.typeParameter.display, ctx_r12.colDef.typeParameter == null ? null : ctx_r12.colDef.typeParameter.digitsInfo, ctx_r12.colDef.typeParameter == null ? null : ctx_r12.colDef.typeParameter.locale))));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r12._getText(ɵngcc0.ɵɵpipeBindV(4, 8, ɵngcc0.ɵɵpureFunction5(20, _c16, ctx_r12._colValue, ctx_r12.colDef.typeParameter == null ? null : ctx_r12.colDef.typeParameter.currencyCode, ctx_r12.colDef.typeParameter == null ? null : ctx_r12.colDef.typeParameter.display, ctx_r12.colDef.typeParameter == null ? null : ctx_r12.colDef.typeParameter.digitsInfo, ctx_r12.colDef.typeParameter == null ? null : ctx_r12.colDef.typeParameter.locale))), " ");
} }
function MtxGridCellComponent_ng_template_3_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "span", 19);
    ɵngcc0.ɵɵpipe(2, "percent");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "percent");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r13 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("title", ctx_r13._getTooltip(ɵngcc0.ɵɵpipeBind3(2, 2, ctx_r13._colValue, ctx_r13.colDef.typeParameter == null ? null : ctx_r13.colDef.typeParameter.digitsInfo, ctx_r13.colDef.typeParameter == null ? null : ctx_r13.colDef.typeParameter.locale)));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r13._getText(ɵngcc0.ɵɵpipeBind3(4, 6, ctx_r13._colValue, ctx_r13.colDef.typeParameter == null ? null : ctx_r13.colDef.typeParameter.digitsInfo, ctx_r13.colDef.typeParameter == null ? null : ctx_r13.colDef.typeParameter.locale)), " ");
} }
function MtxGridCellComponent_ng_template_3_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "span", 19);
    ɵngcc0.ɵɵpipe(2, "date");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "date");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r14 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("title", ctx_r14._getTooltip(ɵngcc0.ɵɵpipeBind4(2, 2, ctx_r14._colValue, ctx_r14.colDef.typeParameter == null ? null : ctx_r14.colDef.typeParameter.format, ctx_r14.colDef.typeParameter == null ? null : ctx_r14.colDef.typeParameter.timezone, ctx_r14.colDef.typeParameter == null ? null : ctx_r14.colDef.typeParameter.locale)));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r14._getText(ɵngcc0.ɵɵpipeBind4(4, 7, ctx_r14._colValue, ctx_r14.colDef.typeParameter == null ? null : ctx_r14.colDef.typeParameter.format, ctx_r14.colDef.typeParameter == null ? null : ctx_r14.colDef.typeParameter.timezone, ctx_r14.colDef.typeParameter == null ? null : ctx_r14.colDef.typeParameter.locale)), " ");
} }
function MtxGridCellComponent_ng_template_3_ng_container_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "span", 19);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r15 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("title", ctx_r15._getTooltip(ctx_r15._colValue));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r15._getText(ctx_r15._colValue));
} }
function MtxGridCellComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0, 4);
    ɵngcc0.ɵɵtemplate(1, MtxGridCellComponent_ng_template_3_ng_container_1_Template, 4, 2, "ng-container", 5);
    ɵngcc0.ɵɵtemplate(2, MtxGridCellComponent_ng_template_3_ng_container_2_Template, 2, 1, "ng-container", 5);
    ɵngcc0.ɵɵtemplate(3, MtxGridCellComponent_ng_template_3_ng_container_3_Template, 3, 2, "ng-container", 5);
    ɵngcc0.ɵɵtemplate(4, MtxGridCellComponent_ng_template_3_ng_container_4_Template, 2, 1, "ng-container", 5);
    ɵngcc0.ɵɵtemplate(5, MtxGridCellComponent_ng_template_3_ng_container_5_Template, 3, 2, "ng-container", 5);
    ɵngcc0.ɵɵtemplate(6, MtxGridCellComponent_ng_template_3_ng_container_6_Template, 5, 10, "ng-container", 5);
    ɵngcc0.ɵɵtemplate(7, MtxGridCellComponent_ng_template_3_ng_container_7_Template, 5, 26, "ng-container", 5);
    ɵngcc0.ɵɵtemplate(8, MtxGridCellComponent_ng_template_3_ng_container_8_Template, 5, 10, "ng-container", 5);
    ɵngcc0.ɵɵtemplate(9, MtxGridCellComponent_ng_template_3_ng_container_9_Template, 5, 12, "ng-container", 5);
    ɵngcc0.ɵɵtemplate(10, MtxGridCellComponent_ng_template_3_ng_container_10_Template, 3, 2, "ng-container", 6);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngSwitch", ctx_r4.colDef.type);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", "tag");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", "button");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", "link");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", "image");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", "boolean");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", "number");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", "currency");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", "percent");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", "date");
} }
const _c17 = ["menu"];
function MtxGridColumnMenuComponent_ng_container_1_mat_icon_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-icon");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r14.buttonIcon);
} }
function MtxGridColumnMenuComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "button", 12);
    ɵngcc0.ɵɵtemplate(2, MtxGridColumnMenuComponent_ng_container_1_mat_icon_2_Template, 2, 1, "mat-icon", 13);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    const _r7 = ɵngcc0.ɵɵreference(9);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r0.buttonClass)("color", ctx_r0.buttonColor)("matMenuTriggerFor", _r7);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.buttonIcon);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.buttonText, " ");
} }
function MtxGridColumnMenuComponent_ng_container_2_mat_icon_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-icon");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r15 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r15.buttonIcon);
} }
function MtxGridColumnMenuComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "button", 14);
    ɵngcc0.ɵɵtemplate(2, MtxGridColumnMenuComponent_ng_container_2_mat_icon_2_Template, 2, 1, "mat-icon", 13);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    const _r7 = ɵngcc0.ɵɵreference(9);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r1.buttonClass)("color", ctx_r1.buttonColor)("matMenuTriggerFor", _r7);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.buttonIcon);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r1.buttonText, " ");
} }
function MtxGridColumnMenuComponent_ng_container_3_mat_icon_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-icon");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r16 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r16.buttonIcon);
} }
function MtxGridColumnMenuComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "button", 15);
    ɵngcc0.ɵɵtemplate(2, MtxGridColumnMenuComponent_ng_container_3_mat_icon_2_Template, 2, 1, "mat-icon", 13);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    const _r7 = ɵngcc0.ɵɵreference(9);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r2.buttonClass)("color", ctx_r2.buttonColor)("matMenuTriggerFor", _r7);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.buttonIcon);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r2.buttonText, " ");
} }
function MtxGridColumnMenuComponent_ng_container_4_mat_icon_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-icon");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r17 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r17.buttonIcon);
} }
function MtxGridColumnMenuComponent_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "button", 16);
    ɵngcc0.ɵɵtemplate(2, MtxGridColumnMenuComponent_ng_container_4_mat_icon_2_Template, 2, 1, "mat-icon", 13);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    const _r7 = ɵngcc0.ɵɵreference(9);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r3.buttonClass)("color", ctx_r3.buttonColor)("matMenuTriggerFor", _r7);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.buttonIcon);
} }
function MtxGridColumnMenuComponent_ng_container_5_mat_icon_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-icon");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r18 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r18.buttonIcon);
} }
function MtxGridColumnMenuComponent_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "button", 17);
    ɵngcc0.ɵɵtemplate(2, MtxGridColumnMenuComponent_ng_container_5_mat_icon_2_Template, 2, 1, "mat-icon", 13);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    const _r7 = ɵngcc0.ɵɵreference(9);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r4.buttonClass)("color", ctx_r4.buttonColor)("matMenuTriggerFor", _r7);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.buttonIcon);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r4.buttonText, " ");
} }
function MtxGridColumnMenuComponent_ng_container_6_mat_icon_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-icon");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r19 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r19.buttonIcon);
} }
function MtxGridColumnMenuComponent_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "button", 18);
    ɵngcc0.ɵɵtemplate(2, MtxGridColumnMenuComponent_ng_container_6_mat_icon_2_Template, 2, 1, "mat-icon", 13);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    const _r7 = ɵngcc0.ɵɵreference(9);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r5.buttonClass)("color", ctx_r5.buttonColor)("matMenuTriggerFor", _r7);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r5.buttonIcon);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r5.buttonText, " ");
} }
function MtxGridColumnMenuComponent_ng_container_7_mat_icon_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-icon");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r20 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r20.buttonIcon);
} }
function MtxGridColumnMenuComponent_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "button", 19);
    ɵngcc0.ɵɵtemplate(2, MtxGridColumnMenuComponent_ng_container_7_mat_icon_2_Template, 2, 1, "mat-icon", 13);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    const _r7 = ɵngcc0.ɵɵreference(9);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r6.buttonClass)("color", ctx_r6.buttonColor)("matMenuTriggerFor", _r7);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r6.buttonIcon);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r6.buttonText, " ");
} }
function MtxGridColumnMenuComponent_div_11_ng_template_1_ng_template_0_Template(rf, ctx) { }
function MtxGridColumnMenuComponent_div_11_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, MtxGridColumnMenuComponent_div_11_ng_template_1_ng_template_0_Template, 0, 0, "ng-template", 23);
} if (rf & 2) {
    const ctx_r21 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r21.headerTemplate);
} }
function MtxGridColumnMenuComponent_div_11_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtext(0);
} if (rf & 2) {
    const ctx_r23 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r23.headerText);
} }
function MtxGridColumnMenuComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 20);
    ɵngcc0.ɵɵtemplate(1, MtxGridColumnMenuComponent_div_11_ng_template_1_Template, 1, 1, "ng-template", 21);
    ɵngcc0.ɵɵtemplate(2, MtxGridColumnMenuComponent_div_11_ng_template_2_Template, 1, 1, "ng-template", null, 22, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const _r22 = ɵngcc0.ɵɵreference(3);
    const ctx_r8 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r8.headerTemplate)("ngIfElse", _r22);
} }
function MtxGridColumnMenuComponent_div_13_div_1_ng_template_3_Template(rf, ctx) { }
const _c18 = function (a0) { return { $implicit: a0 }; };
function MtxGridColumnMenuComponent_div_13_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 26);
    ɵngcc0.ɵɵelementStart(1, "mat-icon", 27);
    ɵngcc0.ɵɵtext(2, "drag_handle");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(3, MtxGridColumnMenuComponent_div_13_div_1_ng_template_3_Template, 0, 0, "ng-template", 28);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const col_r26 = ctx.$implicit;
    const ctx_r25 = ɵngcc0.ɵɵnextContext(2);
    const _r12 = ɵngcc0.ɵɵreference(17);
    ɵngcc0.ɵɵproperty("cdkDragDisabled", ctx_r25.selectableChecked === "show" ? !col_r26.show : col_r26.hide);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r12)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(3, _c18, col_r26));
} }
function MtxGridColumnMenuComponent_div_13_Template(rf, ctx) { if (rf & 1) {
    const _r29 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 24);
    ɵngcc0.ɵɵlistener("cdkDropListDropped", function MtxGridColumnMenuComponent_div_13_Template_div_cdkDropListDropped_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r29); const ctx_r28 = ɵngcc0.ɵɵnextContext(); return ctx_r28._handleDroped($event); });
    ɵngcc0.ɵɵtemplate(1, MtxGridColumnMenuComponent_div_13_div_1_Template, 4, 5, "div", 25);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r9.columns);
} }
function MtxGridColumnMenuComponent_div_14_div_1_ng_template_1_Template(rf, ctx) { }
function MtxGridColumnMenuComponent_div_14_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 31);
    ɵngcc0.ɵɵtemplate(1, MtxGridColumnMenuComponent_div_14_div_1_ng_template_1_Template, 0, 0, "ng-template", 28);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const col_r31 = ctx.$implicit;
    ɵngcc0.ɵɵnextContext(2);
    const _r12 = ɵngcc0.ɵɵreference(17);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r12)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(2, _c18, col_r31));
} }
function MtxGridColumnMenuComponent_div_14_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 29);
    ɵngcc0.ɵɵtemplate(1, MtxGridColumnMenuComponent_div_14_div_1_Template, 2, 4, "div", 30);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r10.columns);
} }
function MtxGridColumnMenuComponent_div_15_ng_template_1_ng_template_0_Template(rf, ctx) { }
function MtxGridColumnMenuComponent_div_15_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, MtxGridColumnMenuComponent_div_15_ng_template_1_ng_template_0_Template, 0, 0, "ng-template", 23);
} if (rf & 2) {
    const ctx_r33 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r33.footerTemplate);
} }
function MtxGridColumnMenuComponent_div_15_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtext(0);
} if (rf & 2) {
    const ctx_r35 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r35.footerText);
} }
function MtxGridColumnMenuComponent_div_15_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 32);
    ɵngcc0.ɵɵtemplate(1, MtxGridColumnMenuComponent_div_15_ng_template_1_Template, 1, 1, "ng-template", 21);
    ɵngcc0.ɵɵtemplate(2, MtxGridColumnMenuComponent_div_15_ng_template_2_Template, 1, 1, "ng-template", null, 33, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const _r34 = ɵngcc0.ɵɵreference(3);
    const ctx_r11 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r11.footerTemplate)("ngIfElse", _r34);
} }
function MtxGridColumnMenuComponent_ng_template_16_mat_checkbox_0_Template(rf, ctx) { if (rf & 1) {
    const _r42 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "mat-checkbox", 36);
    ɵngcc0.ɵɵlistener("ngModelChange", function MtxGridColumnMenuComponent_ng_template_16_mat_checkbox_0_Template_mat_checkbox_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r42); const col_r37 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r40 = ɵngcc0.ɵɵnextContext(); return (col_r37[ctx_r40.selectableChecked] = $event); })("change", function MtxGridColumnMenuComponent_ng_template_16_mat_checkbox_0_Template_mat_checkbox_change_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r42); const ctx_r43 = ɵngcc0.ɵɵnextContext(2); return ctx_r43._handleSelection($event); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "async");
    ɵngcc0.ɵɵpipe(3, "toObservable");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const col_r37 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r38 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngModel", col_r37[ctx_r38.selectableChecked])("disabled", col_r37.disabled);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(2, 3, ɵngcc0.ɵɵpipeBind1(3, 5, col_r37.label)), " ");
} }
function MtxGridColumnMenuComponent_ng_template_16_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 37);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "async");
    ɵngcc0.ɵɵpipe(3, "toObservable");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const col_r37 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(2, 1, ɵngcc0.ɵɵpipeBind1(3, 3, col_r37.label)), " ");
} }
function MtxGridColumnMenuComponent_ng_template_16_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, MtxGridColumnMenuComponent_ng_template_16_mat_checkbox_0_Template, 4, 7, "mat-checkbox", 34);
    ɵngcc0.ɵɵtemplate(1, MtxGridColumnMenuComponent_ng_template_16_span_1_Template, 4, 5, "span", 35);
} if (rf & 2) {
    const ctx_r13 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngIf", ctx_r13.selectable);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r13.selectable);
} }
export { TABLE_LAYOUT_FIXED_RESIZE_STRATEGY_PROVIDER as MAT_TABLE_LAYOUT_FIXED_RESIZE_STRATEGY_PROVIDER } from '@ng-matero/extensions/column-resize';
import { _CoalescedStyleScheduler, _COALESCED_STYLE_SCHEDULER, CdkTable, CdkColumnDef } from '@angular/cdk/table';
import { Directionality } from '@angular/cdk/bidi';

class MtxGridService {
    constructor() { }
    /**
     * Get cell value from column key e.g. `a.b.c`
     * @param rowData Row data
     * @param colDef Column definition
     */
    getCellValue(rowData, colDef) {
        const keyArr = colDef.field ? colDef.field.split('.') : [];
        let tmp = '';
        keyArr.forEach((key, i) => {
            if (i === 0) {
                tmp = rowData[key];
            }
            else {
                tmp = tmp && tmp[key];
            }
        });
        return tmp;
    }
    /**
     * Get all data of a col
     * @param data All data
     * @param colDef Column definition
     */
    getColData(data, colDef) {
        return data.map((rowData) => this.getCellValue(rowData, colDef));
    }
    /**
     * Remove white spaces in a string and convert string to array
     * @param str string
     */
    str2arr(str) {
        return str.replace(/[\r\n\s]/g, '').split(',');
    }
}
MtxGridService.ɵfac = function MtxGridService_Factory(t) { return new (t || MtxGridService)(); };
MtxGridService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: MtxGridService, factory: MtxGridService.ɵfac });
/** @nocollapse */
MtxGridService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MtxGridService, [{
        type: Injectable
    }], function () { return []; }, null); })();

class MtxGridComponent {
    constructor(_dataGridSrv, _changeDetectorRef) {
        this._dataGridSrv = _dataGridSrv;
        this._changeDetectorRef = _changeDetectorRef;
        this.dataSource = new MatTableDataSource();
        this.columns = [];
        this.data = [];
        this.length = 0;
        this.loading = false;
        this.columnResizable = false;
        // Page
        this.pageOnFront = true;
        this.showPaginator = true;
        this.pageDisabled = false;
        this.showFirstLastButtons = true;
        this.pageIndex = 0;
        this.pageSize = 10;
        this.pageSizeOptions = [10, 50, 100];
        this.hidePageSize = false;
        this.page = new EventEmitter();
        // Sort
        this.sortOnFront = true;
        this.sortDisableClear = false;
        this.sortDisabled = false;
        this.sortStart = 'asc';
        this.sortChange = new EventEmitter();
        // Row
        this.rowHover = false;
        this.rowStriped = false;
        this.rowClick = new EventEmitter();
        // Expansion
        this.expansionRowStates = [];
        this.expandable = false;
        this.expansionChange = new EventEmitter();
        // Row selection
        /** Whether support multiple row/cell selection */
        this.multiSelectable = true;
        this.rowSelection = new SelectionModel(true, []);
        this.rowSelected = [];
        this.rowSelectable = false;
        this.hideRowSelectionCheckbox = false;
        this.rowSelectionFormatter = {};
        this.rowSelectionChange = new EventEmitter();
        // Cell selection
        this.cellSelection = [];
        this.cellSelectable = true;
        this.cellSelectionChange = new EventEmitter();
        // Toolbar
        this.showToolbar = false;
        this.toolbarTitle = '';
        // Column menu
        this.columnMenuData = [];
        this.showColumnMenuButton = true;
        this.columnMenuButtonText = '';
        this.columnMenuButtonType = 'stroked';
        this.columnMenuButtonClass = '';
        this.columnMenuButtonIcon = '';
        this.columnHideable = true;
        this.columnHideableChecked = 'show';
        this.columnMovable = true;
        this.columnPinnable = true;
        this.columnChange = new EventEmitter();
        this.showColumnMenuHeader = false;
        this.columnMenuHeaderText = 'Columns Header';
        this.showColumnMenuFooter = false;
        this.columnMenuFooterText = 'Columns Footer';
        // No Result
        this.noResultText = 'No records found';
        // Summary
        this.showSummary = false;
        // Sidebar
        this.showSidebar = false;
        // Status bar
        this.showStatusbar = false;
    }
    get _hasNoResult() {
        return (!this.data || this.data.length === 0) && !this.loading;
    }
    // TODO: Summary display conditions
    get _whetherShowSummary() {
        return this.showSummary;
    }
    detectChanges() {
        this._changeDetectorRef.detectChanges();
    }
    _isTemplateRef(obj) {
        return obj instanceof TemplateRef;
    }
    _getColData(data, colDef) {
        return this._dataGridSrv.getColData(data, colDef);
    }
    _getRowClassList(rowData, index) {
        const classList = {
            'selected': this.rowSelection.isSelected(rowData),
            'mat-row-odd': index % 2,
        };
        if (this.rowClassFormatter) {
            for (const key of Object.keys(this.rowClassFormatter)) {
                classList[key] = this.rowClassFormatter[key](rowData, index);
            }
        }
        return classList;
    }
    ngOnInit() { }
    // Waiting for async data
    ngOnChanges(changes) {
        var _a;
        this._countPinnedPosition();
        this.displayedColumns = this.columns.filter(item => !item.hide).map(item => item.field);
        if (this.showColumnMenuButton) {
            this.columnMenuData = this.columns.map(item => {
                const newItem = {
                    label: item.header,
                    field: item.field,
                    disabled: item.disabled,
                };
                if (this.columnHideableChecked === 'show') {
                    newItem.show = !item.hide;
                }
                else {
                    newItem.hide = item.hide;
                }
                return newItem;
            });
        }
        if (this.rowSelectable && !this.hideRowSelectionCheckbox) {
            this.displayedColumns.unshift('MtxGridCheckboxColumnDef');
        }
        // We should copy each item of data for expansion data
        if (this.expandable) {
            this.expansionRowStates = []; // reset
            (_a = this.data) === null || _a === void 0 ? void 0 : _a.forEach(_ => {
                this.expansionRowStates.push({ expanded: false });
            });
        }
        if (this.rowSelectable) {
            this.rowSelection = new SelectionModel(this.multiSelectable, this.rowSelected);
        }
        this.dataSource = new MatTableDataSource(this.data);
        this.dataSource.paginator = this.pageOnFront ? this.paginator : null;
        this.dataSource.sort = this.sortOnFront ? this.sort : null;
        // Only scroll top with data change
        if (changes.data) {
            this.scrollTop(0);
        }
    }
    ngAfterViewInit() {
        if (this.pageOnFront) {
            this.dataSource.paginator = this.paginator;
        }
        if (this.sortOnFront) {
            this.dataSource.sort = this.sort;
        }
    }
    ngOnDestroy() { }
    _countPinnedPosition() {
        const count = (acc, cur) => acc + parseFloat(cur.width || '80px');
        const pinnedLeftCols = this.columns.filter(col => col.pinned && col.pinned === 'left');
        pinnedLeftCols.forEach((item, idx) => {
            item.left = pinnedLeftCols.slice(0, idx).reduce(count, 0) + 'px';
        });
        const pinnedRightCols = this.columns
            .filter(col => col.pinned && col.pinned === 'right')
            .reverse();
        pinnedRightCols.forEach((item, idx) => {
            item.right = pinnedRightCols.slice(0, idx).reduce(count, 0) + 'px';
        });
    }
    _getIndex(index, dataIndex) {
        return typeof index === 'undefined' ? dataIndex : index;
    }
    _handleSortChange(sort) {
        this.sortChange.emit(sort);
    }
    /** Expansion change event */
    _handleExpansionChange(expansionRef, rowData, column, index) {
        this.expansionChange.emit({ expanded: expansionRef.expanded, data: rowData, index, column });
    }
    /** Cell select event */
    _selectCell(cellRef, rowData, colDef) {
        // If not the same cell
        if (this._selectedCell !== cellRef) {
            const colValue = this._dataGridSrv.getCellValue(rowData, colDef);
            this.cellSelection = []; // reset
            this.cellSelection.push({ cellData: colValue, rowData, colDef });
            this.cellSelectionChange.emit(this.cellSelection);
            if (this._selectedCell) {
                this._selectedCell.deselect(); // the selectedCell will be undefined
            }
        }
        this._selectedCell = cellRef.selected ? cellRef : undefined;
    }
    /** Row select event */
    _selectRow(event, rowData, index) {
        var _a, _b, _c, _d;
        if (this.rowSelectable &&
            !((_b = (_a = this.rowSelectionFormatter).disabled) === null || _b === void 0 ? void 0 : _b.call(_a, rowData, index)) &&
            !((_d = (_c = this.rowSelectionFormatter).hideCheckbox) === null || _d === void 0 ? void 0 : _d.call(_c, rowData, index))) {
            // metaKey -> command key
            if (!event.ctrlKey && !event.metaKey) {
                this.rowSelection.clear();
            }
            this._toggleNormalCheckbox(rowData);
        }
        this.rowClick.emit({ rowData, index });
    }
    /** Whether the number of selected elements matches the total number of rows. */
    _isAllSelected() {
        const numSelected = this.rowSelection.selected.length;
        const numRows = this.dataSource.data.filter((row, index) => { var _a, _b; return !((_b = (_a = this.rowSelectionFormatter).disabled) === null || _b === void 0 ? void 0 : _b.call(_a, row, index)); }).length;
        return numSelected === numRows;
    }
    /** Select all rows if they are not all selected; otherwise clear selection. */
    _toggleMasterCheckbox() {
        this._isAllSelected()
            ? this.rowSelection.clear()
            : this.dataSource.data.forEach((row, index) => {
                var _a, _b;
                if (!((_b = (_a = this.rowSelectionFormatter).disabled) === null || _b === void 0 ? void 0 : _b.call(_a, row, index))) {
                    this.rowSelection.select(row);
                }
            });
        this.rowSelectionChange.emit(this.rowSelection.selected);
    }
    /** Select normal row */
    _toggleNormalCheckbox(row) {
        this.rowSelection.toggle(row);
        this.rowSelectionChange.emit(this.rowSelection.selected);
    }
    /** Column change event */
    _handleColumnChange(columns) {
        this.columnChange.emit(columns);
        this.displayedColumns = Object.assign([], this.getDisplayedColumnFields(columns));
        if (this.rowSelectable && !this.hideRowSelectionCheckbox) {
            this.displayedColumns.unshift('MtxGridCheckboxColumnDef');
        }
    }
    getDisplayedColumnFields(columns) {
        const fields = columns
            .filter((item) => this.columnHideableChecked === 'show' ? item.show : !item.hide)
            .map((item) => item.field);
        return fields;
    }
    /** Customize expansion event */
    toggleExpansion(index) {
        if (!this.expandable) {
            throw new Error('The `expandable` should be set true.');
        }
        this.expansionRowStates[index].expanded = !this.expansionRowStates[index].expanded;
        return this.expansionRowStates[index].expanded;
    }
    /** Scroll to top when turn to the next page */
    _handlePage(e) {
        if (this.pageOnFront) {
            this.scrollTop(0);
        }
        this.page.emit(e);
    }
    scrollTop(value) {
        var _a;
        if (value == null) {
            return (_a = this.tableContainer) === null || _a === void 0 ? void 0 : _a.nativeElement.scrollTop;
        }
        if (this.tableContainer && !this.loading) {
            this.tableContainer.nativeElement.scrollTop = value;
        }
    }
    scrollLeft(value) {
        var _a;
        if (value == null) {
            return (_a = this.tableContainer) === null || _a === void 0 ? void 0 : _a.nativeElement.scrollLeft;
        }
        if (this.tableContainer && !this.loading) {
            this.tableContainer.nativeElement.scrollLeft = value;
        }
    }
}
MtxGridComponent.ɵfac = function MtxGridComponent_Factory(t) { return new (t || MtxGridComponent)(ɵngcc0.ɵɵdirectiveInject(MtxGridService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
MtxGridComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: MtxGridComponent, selectors: [["mtx-grid"]], viewQuery: function MtxGridComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(MatPaginator, 5);
        ɵngcc0.ɵɵviewQuery(MatSort, 5);
        ɵngcc0.ɵɵviewQuery(_c0, 5);
        ɵngcc0.ɵɵviewQuery(_c1, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.paginator = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.sort = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.columnMenu = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.tableContainer = _t.first);
    } }, hostAttrs: [1, "mtx-grid"], inputs: { columns: "columns", data: "data", length: "length", loading: "loading", columnResizable: "columnResizable", pageOnFront: "pageOnFront", showPaginator: "showPaginator", pageDisabled: "pageDisabled", showFirstLastButtons: "showFirstLastButtons", pageIndex: "pageIndex", pageSize: "pageSize", pageSizeOptions: "pageSizeOptions", hidePageSize: "hidePageSize", sortOnFront: "sortOnFront", sortDisableClear: "sortDisableClear", sortDisabled: "sortDisabled", sortStart: "sortStart", rowHover: "rowHover", rowStriped: "rowStriped", expandable: "expandable", multiSelectable: "multiSelectable", rowSelected: "rowSelected", rowSelectable: "rowSelectable", hideRowSelectionCheckbox: "hideRowSelectionCheckbox", rowSelectionFormatter: "rowSelectionFormatter", cellSelectable: "cellSelectable", showToolbar: "showToolbar", toolbarTitle: "toolbarTitle", showColumnMenuButton: "showColumnMenuButton", columnMenuButtonText: "columnMenuButtonText", columnMenuButtonType: "columnMenuButtonType", columnMenuButtonClass: "columnMenuButtonClass", columnMenuButtonIcon: "columnMenuButtonIcon", columnHideable: "columnHideable", columnHideableChecked: "columnHideableChecked", columnMovable: "columnMovable", columnPinnable: "columnPinnable", showColumnMenuHeader: "showColumnMenuHeader", columnMenuHeaderText: "columnMenuHeaderText", showColumnMenuFooter: "showColumnMenuFooter", columnMenuFooterText: "columnMenuFooterText", noResultText: "noResultText", showSummary: "showSummary", showSidebar: "showSidebar", showStatusbar: "showStatusbar", displayedColumns: "displayedColumns", trackBy: "trackBy", paginationTemplate: "paginationTemplate", sortActive: "sortActive", sortDirection: "sortDirection", expansionTemplate: "expansionTemplate", rowClassFormatter: "rowClassFormatter", toolbarTemplate: "toolbarTemplate", columnMenuButtonColor: "columnMenuButtonColor", columnMenuHeaderTemplate: "columnMenuHeaderTemplate", columnMenuFooterTemplate: "columnMenuFooterTemplate", noResultTemplate: "noResultTemplate", headerTemplate: "headerTemplate", headerExtraTemplate: "headerExtraTemplate", cellTemplate: "cellTemplate", summaryTemplate: "summaryTemplate", sidebarTemplate: "sidebarTemplate", statusbarTemplate: "statusbarTemplate" }, outputs: { page: "page", sortChange: "sortChange", rowClick: "rowClick", expansionChange: "expansionChange", rowSelectionChange: "rowSelectionChange", cellSelectionChange: "cellSelectionChange", columnChange: "columnChange" }, exportAs: ["mtxGrid"], features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 18, vars: 12, consts: [["class", "mtx-grid-progress", 4, "ngIf"], ["class", "mtx-grid-toolbar", 4, "ngIf"], [1, "mtx-grid-main", "mtx-grid-layout"], [1, "mtx-grid-content", "mtx-grid-layout"], [1, "mat-table-container", 3, "ngClass"], ["tableContainer", ""], ["mat-table", "", "matSort", "", 3, "ngClass", "dataSource", "multiTemplateDataRows", "matSortActive", "matSortDirection", "matSortDisableClear", "matSortDisabled", "matSortStart", "trackBy", "matSortChange", 4, "ngIf"], ["mat-table", "", "columnResize", "", "matSort", "", 3, "ngClass", "dataSource", "multiTemplateDataRows", "matSortActive", "matSortDirection", "matSortDisableClear", "matSortDisabled", "matSortStart", "trackBy", "matSortChange", 4, "ngIf"], ["class", "mtx-grid-no-result", 4, "ngIf"], ["class", "mtx-grid-sidebar", 4, "ngIf"], [1, "mtx-grid-footer"], ["class", "mtx-grid-statusbar", 4, "ngIf"], [1, "mtx-grid-pagination"], [3, "ngIf", "ngIfElse"], ["defaultPaginationTemplate", ""], ["headerExtraTplBase", ""], [1, "mtx-grid-progress"], ["mode", "indeterminate"], [1, "mtx-grid-toolbar"], [1, "mtx-grid-toolbar-content"], ["defaultToolbarTemplate", ""], [1, "mtx-grid-toolbar-actions"], [3, "columns", "buttonText", "buttonType", "buttonColor", "buttonClass", "buttonIcon", "selectable", "selectableChecked", "sortable", "showHeader", "headerText", "headerTemplate", "showFooter", "footerText", "footerTemplate", "selectionChange", "sortChange", 4, "ngIf"], [3, "ngTemplateOutlet"], ["class", "mtx-grid-toolbar-title", 4, "ngIf"], [1, "mtx-grid-toolbar-title"], [3, "columns", "buttonText", "buttonType", "buttonColor", "buttonClass", "buttonIcon", "selectable", "selectableChecked", "sortable", "showHeader", "headerText", "headerTemplate", "showFooter", "footerText", "footerTemplate", "selectionChange", "sortChange"], ["columnMenu", ""], ["mat-table", "", "matSort", "", 3, "ngClass", "dataSource", "multiTemplateDataRows", "matSortActive", "matSortDirection", "matSortDisableClear", "matSortDisabled", "matSortStart", "trackBy", "matSortChange"], ["matColumnDef", "MtxGridCheckboxColumnDef", 4, "ngIf"], [4, "ngFor", "ngForOf"], ["mat-header-row", "", 4, "matHeaderRowDef", "matHeaderRowDefSticky"], ["mat-row", "", 3, "ngClass", "click", 4, "matRowDef", "matRowDefColumns"], [4, "ngIf"], ["matColumnDef", "MtxGridCheckboxColumnDef"], ["mat-header-cell", "", "class", "mtx-grid-checkbox-cell", 4, "matHeaderCellDef"], ["mat-cell", "", "class", "mtx-grid-checkbox-cell", 4, "matCellDef"], ["mat-footer-cell", "", "class", "mtx-grid-checkbox-cell", 4, "matFooterCellDef"], ["mat-header-cell", "", 1, "mtx-grid-checkbox-cell"], [3, "checked", "indeterminate", "change", 4, "ngIf"], [3, "checked", "indeterminate", "change"], ["mat-cell", "", 1, "mtx-grid-checkbox-cell"], [3, "disabled", "checked", "click", "change", 4, "ngIf"], [3, "disabled", "checked", "click", "change"], ["mat-footer-cell", "", 1, "mtx-grid-checkbox-cell"], [3, "matColumnDef", "sticky", "stickyEnd"], ["mat-header-cell", "", 3, "class", "ngClass", "ngStyle", 4, "matHeaderCellDef"], ["mat-cell", "", "mtx-grid-selectable-cell", "", 3, "class", "ngClass", "ngStyle", "cellSelectionChange", 4, "matCellDef"], ["mat-footer-cell", "", 3, "ngClass", "ngStyle", 4, "matFooterCellDef"], ["mat-header-cell", "", 3, "ngClass", "ngStyle"], [1, "mat-header-cell-inner"], ["headerTpl", ""], ["defaultHeaderTpl", ""], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [3, "mat-sort-header", "disabled", "arrowPosition", "disableClear", "start"], ["class", "mtx-grid-expansion-placeholder", 4, "ngIf"], ["class", "mat-sort-header-icon", 4, "ngIf"], [1, "mtx-grid-expansion-placeholder"], [1, "mat-sort-header-icon"], ["mat-cell", "", "mtx-grid-selectable-cell", "", 3, "ngClass", "ngStyle", "cellSelectionChange"], ["cellTpl", ""], ["colDefCellTpl", ""], ["defaultCellTpl", ""], [3, "ngIf", "ngIfElse", "ngTemplateOutlet", "ngTemplateOutletContext"], ["mat-icon-button", "", "mtx-grid-expansion-toggle", "", 3, "opened", "openedChange", "toggleChange", 4, "ngIf"], [3, "rowData", "colDef"], ["mat-icon-button", "", "mtx-grid-expansion-toggle", "", 3, "opened", "openedChange", "toggleChange"], ["mat-footer-cell", "", 3, "ngClass", "ngStyle"], ["summaryTpl", ""], ["defaultSummaryTpl", ""], [3, "summary", "data", "colDef"], ["mat-header-row", ""], ["mat-row", "", 3, "ngClass", "click"], ["mat-footer-row", "", 4, "matFooterRowDef", "matFooterRowDefSticky"], ["mat-footer-row", ""], ["matColumnDef", "MtxGridExpansionColumnDef"], ["mat-cell", "", 4, "matCellDef"], ["mat-row", "", 3, "ngClass", 4, "matRowDef", "matRowDefColumns"], ["mat-cell", ""], [1, "mtx-grid-expansion-detail"], ["mat-row", "", 3, "ngClass"], ["mat-table", "", "columnResize", "", "matSort", "", 3, "ngClass", "dataSource", "multiTemplateDataRows", "matSortActive", "matSortDirection", "matSortDisableClear", "matSortDisabled", "matSortStart", "trackBy", "matSortChange"], ["mat-header-cell", "", 3, "class", "ngClass", "ngStyle", "resizable", "matResizableMinWidthPx", "matResizableMaxWidthPx", 4, "matHeaderCellDef"], ["mat-header-cell", "", 3, "ngClass", "ngStyle", "resizable", "matResizableMinWidthPx", "matResizableMaxWidthPx"], [1, "mtx-grid-no-result"], ["defaultNoResultTpl", ""], [1, "mtx-grid-sidebar"], [3, "ngIf"], [1, "mtx-grid-statusbar"], [3, "showFirstLastButtons", "length", "pageIndex", "pageSize", "pageSizeOptions", "hidePageSize", "disabled", "page"], ["headerExtraTpl", ""]], template: function MtxGridComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, MtxGridComponent_div_0_Template, 2, 0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, MtxGridComponent_div_1_Template, 7, 3, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵelementStart(4, "div", 4, 5);
        ɵngcc0.ɵɵtemplate(6, MtxGridComponent_table_6_Template, 7, 20, "table", 6);
        ɵngcc0.ɵɵtemplate(7, MtxGridComponent_table_7_Template, 7, 20, "table", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(8, MtxGridComponent_div_8_Template, 4, 2, "div", 8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(9, MtxGridComponent_div_9_Template, 2, 1, "div", 9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "div", 10);
        ɵngcc0.ɵɵtemplate(11, MtxGridComponent_div_11_Template, 2, 1, "div", 11);
        ɵngcc0.ɵɵelementStart(12, "div", 12);
        ɵngcc0.ɵɵtemplate(13, MtxGridComponent_ng_template_13_Template, 1, 1, "ng-template", 13);
        ɵngcc0.ɵɵtemplate(14, MtxGridComponent_ng_template_14_Template, 1, 9, "ng-template", null, 14, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(16, MtxGridComponent_ng_template_16_Template, 3, 2, "ng-template", null, 15, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r9 = ɵngcc0.ɵɵreference(15);
        ɵngcc0.ɵɵproperty("ngIf", ctx.loading);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showToolbar);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(10, _c13, !ctx._hasNoResult));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.columnResizable);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.columnResizable);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx._hasNoResult);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showSidebar);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showStatusbar);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx._isTemplateRef(ctx.paginationTemplate))("ngIfElse", _r9);
    } }, directives: function () { return [ɵngcc1.NgIf, ɵngcc1.NgClass, ɵngcc2.MatProgressBar, ɵngcc1.NgTemplateOutlet, MtxGridColumnMenuComponent, ɵngcc3.MatTable, ɵngcc4.MatSort, ɵngcc1.NgForOf, ɵngcc3.MatHeaderRowDef, ɵngcc3.MatRowDef, ɵngcc3.MatColumnDef, ɵngcc3.MatHeaderCellDef, ɵngcc3.MatCellDef, ɵngcc3.MatFooterCellDef, ɵngcc3.MatHeaderCell, ɵngcc5.MatCheckbox, ɵngcc3.MatCell, ɵngcc3.MatFooterCell, ɵngcc1.NgStyle, ɵngcc4.MatSortHeader, ɵngcc6.MatIcon, MtxGridCellSelectionDirective, MtxGridCellComponent, ɵngcc7.MatButton, MtxGridExpansionToggleDirective, ɵngcc3.MatHeaderRow, ɵngcc3.MatRow, ɵngcc3.MatFooterRowDef, ɵngcc3.MatFooterRow, MatColumnResize, MatResizable, ɵngcc8.MatPaginator]; }, pipes: function () { return [ɵngcc1.AsyncPipe, ɵngcc9.MtxToObservablePipe]; }, styles: [".mtx-grid{position:relative;display:flex;flex-direction:column;width:100%}.mtx-grid .mat-table-container{overflow:auto}.mtx-grid .mat-table-container.mat-table-with-data{flex:1}.mtx-grid .mat-table:not(.mat-column-resize-table){min-width:100%;border-collapse:separate}.mtx-grid .mat-table:not(.mat-column-resize-table) .mat-cell:not(.mtx-grid-checkbox-cell),.mtx-grid .mat-table:not(.mat-column-resize-table) .mat-footer-cell:not(.mtx-grid-checkbox-cell),.mtx-grid .mat-table:not(.mat-column-resize-table) .mat-header-cell:not(.mtx-grid-checkbox-cell){min-width:80px}.mtx-grid .mat-table-sticky-left{border-right-width:1px;border-right-style:solid}[dir=rtl] .mtx-grid .mat-table-sticky-left{border-right-width:0;border-left-width:1px;border-left-style:solid}.mtx-grid .mat-table-sticky-right{border-left-width:1px;border-left-style:solid}[dir=rtl] .mtx-grid .mat-table-sticky-right{border-left-width:0;border-right-width:1px;border-right-style:solid}.mtx-grid .mat-cell,.mtx-grid .mat-footer-cell,.mtx-grid .mat-header-cell{padding:4px 10px;box-sizing:border-box}.mtx-grid .mat-cell:first-of-type:not(:only-of-type),.mtx-grid .mat-footer-cell:first-of-type:not(:only-of-type),.mtx-grid .mat-header-cell:first-of-type:not(:only-of-type){padding-left:24px}.mtx-grid .mat-cell:first-of-type:not(:only-of-type).mtx-grid-checkbox-cell,.mtx-grid .mat-footer-cell:first-of-type:not(:only-of-type).mtx-grid-checkbox-cell,.mtx-grid .mat-header-cell:first-of-type:not(:only-of-type).mtx-grid-checkbox-cell{padding-left:10px;padding-right:10px}[dir=rtl] .mtx-grid .mat-cell:first-of-type:not(:only-of-type),[dir=rtl] .mtx-grid .mat-footer-cell:first-of-type:not(:only-of-type),[dir=rtl] .mtx-grid .mat-header-cell:first-of-type:not(:only-of-type){padding-left:10px;padding-right:24px}[dir=rtl] .mtx-grid .mat-cell:first-of-type:not(:only-of-type).mtx-grid-checkbox-cell,[dir=rtl] .mtx-grid .mat-footer-cell:first-of-type:not(:only-of-type).mtx-grid-checkbox-cell,[dir=rtl] .mtx-grid .mat-header-cell:first-of-type:not(:only-of-type).mtx-grid-checkbox-cell{padding-left:10px;padding-right:10px}.mtx-grid .mat-cell:last-of-type:not(:only-of-type),.mtx-grid .mat-footer-cell:last-of-type:not(:only-of-type),.mtx-grid .mat-header-cell:last-of-type:not(:only-of-type){padding-right:24px}[dir=rtl] .mtx-grid .mat-cell:last-of-type:not(:only-of-type),[dir=rtl] .mtx-grid .mat-footer-cell:last-of-type:not(:only-of-type),[dir=rtl] .mtx-grid .mat-header-cell:last-of-type:not(:only-of-type){padding-left:24px;padding-right:10px}.mtx-grid .mat-cell .mat-icon-button.expanded .mat-icon{transform:rotate(90deg)}.mtx-grid .mat-row.mtx-grid-expansion{height:0;overflow:hidden}.mtx-grid .mat-row.mtx-grid-expansion .mat-cell{padding-top:0;padding-bottom:0}.mtx-grid .mat-row.mtx-grid-expansion.collapsed .mat-cell{border-bottom-width:0}.mtx-grid .mat-row:last-of-type .mat-cell{border-bottom-width:0}.mtx-grid .mat-sort-header-icon{width:18px;height:18px;margin:0 4px;font-size:18px}.mtx-grid .mat-header-cell-inner{display:flex;align-items:center}.mtx-grid .mat-paginator-hidden{display:none}.mtx-grid-progress{position:absolute;top:0;z-index:120;width:100%}.mtx-grid-toolbar{display:flex;justify-content:space-between;align-items:center;min-height:48px;padding:8px;box-sizing:border-box}.mtx-grid-layout{display:flex;flex:1 1 auto;overflow:auto}.mtx-grid-content{flex-direction:column;width:0}.mtx-grid-sidebar{max-width:50%;border-left-width:1px;border-left-style:solid}[dir=rtl] .mtx-grid-sidebar{border-left-width:0;border-right-width:1px;border-right-style:solid}.mtx-grid-footer{position:relative;z-index:1}.mtx-grid-statusbar{display:flex;align-items:center;min-height:56px;padding:8px}.mtx-grid-no-result{display:flex;justify-content:center;align-items:center;flex:1;min-height:150px}.mtx-grid-expansion-placeholder{display:inline-block;width:40px;height:40px;vertical-align:middle}.mtx-grid-expansion-detail{display:flex;align-items:center;min-height:48px;overflow:hidden}.mtx-grid-checkbox-cell{flex:none;justify-content:center;width:56px;min-width:56px}.mtx-grid-checkbox-cell .mat-checkbox{display:flex;margin:0 10px}.mtx-grid-checkbox-cell .mat-checkbox-inner-container{margin-left:0}"], encapsulation: 2, data: { animation: [
            trigger('expansion', [
                state('collapsed', style({ height: '0', minHeight: '0', visibility: 'hidden' })),
                state('expanded', style({ height: '*', visibility: 'visible' })),
                transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
            ]),
        ] }, changeDetection: 0 });
/** @nocollapse */
MtxGridComponent.ctorParameters = () => [
    { type: MtxGridService },
    { type: ChangeDetectorRef }
];
MtxGridComponent.propDecorators = {
    paginator: [{ type: ViewChild, args: [MatPaginator,] }],
    sort: [{ type: ViewChild, args: [MatSort,] }],
    columnMenu: [{ type: ViewChild, args: ['columnMenu',] }],
    tableContainer: [{ type: ViewChild, args: ['tableContainer',] }],
    displayedColumns: [{ type: Input }],
    columns: [{ type: Input }],
    data: [{ type: Input }],
    length: [{ type: Input }],
    loading: [{ type: Input }],
    trackBy: [{ type: Input }],
    columnResizable: [{ type: Input }],
    pageOnFront: [{ type: Input }],
    showPaginator: [{ type: Input }],
    pageDisabled: [{ type: Input }],
    showFirstLastButtons: [{ type: Input }],
    pageIndex: [{ type: Input }],
    pageSize: [{ type: Input }],
    pageSizeOptions: [{ type: Input }],
    hidePageSize: [{ type: Input }],
    page: [{ type: Output }],
    paginationTemplate: [{ type: Input }],
    sortOnFront: [{ type: Input }],
    sortActive: [{ type: Input }],
    sortDirection: [{ type: Input }],
    sortDisableClear: [{ type: Input }],
    sortDisabled: [{ type: Input }],
    sortStart: [{ type: Input }],
    sortChange: [{ type: Output }],
    rowHover: [{ type: Input }],
    rowStriped: [{ type: Input }],
    rowClick: [{ type: Output }],
    expandable: [{ type: Input }],
    expansionTemplate: [{ type: Input }],
    expansionChange: [{ type: Output }],
    multiSelectable: [{ type: Input }],
    rowSelected: [{ type: Input }],
    rowSelectable: [{ type: Input }],
    hideRowSelectionCheckbox: [{ type: Input }],
    rowSelectionFormatter: [{ type: Input }],
    rowClassFormatter: [{ type: Input }],
    rowSelectionChange: [{ type: Output }],
    cellSelectable: [{ type: Input }],
    cellSelectionChange: [{ type: Output }],
    showToolbar: [{ type: Input }],
    toolbarTitle: [{ type: Input }],
    toolbarTemplate: [{ type: Input }],
    showColumnMenuButton: [{ type: Input }],
    columnMenuButtonText: [{ type: Input }],
    columnMenuButtonType: [{ type: Input }],
    columnMenuButtonColor: [{ type: Input }],
    columnMenuButtonClass: [{ type: Input }],
    columnMenuButtonIcon: [{ type: Input }],
    columnHideable: [{ type: Input }],
    columnHideableChecked: [{ type: Input }],
    columnMovable: [{ type: Input }],
    columnPinnable: [{ type: Input }],
    columnChange: [{ type: Output }],
    showColumnMenuHeader: [{ type: Input }],
    columnMenuHeaderText: [{ type: Input }],
    columnMenuHeaderTemplate: [{ type: Input }],
    showColumnMenuFooter: [{ type: Input }],
    columnMenuFooterText: [{ type: Input }],
    columnMenuFooterTemplate: [{ type: Input }],
    noResultText: [{ type: Input }],
    noResultTemplate: [{ type: Input }],
    headerTemplate: [{ type: Input }],
    headerExtraTemplate: [{ type: Input }],
    cellTemplate: [{ type: Input }],
    showSummary: [{ type: Input }],
    summaryTemplate: [{ type: Input }],
    showSidebar: [{ type: Input }],
    sidebarTemplate: [{ type: Input }],
    showStatusbar: [{ type: Input }],
    statusbarTemplate: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MtxGridComponent, [{
        type: Component,
        args: [{
                selector: 'mtx-grid',
                exportAs: 'mtxGrid',
                template: "<!-- Progress bar-->\r\n<div class=\"mtx-grid-progress\" *ngIf=\"loading\">\r\n  <mat-progress-bar mode=\"indeterminate\"></mat-progress-bar>\r\n</div>\r\n\r\n<!-- Toolbar -->\r\n<div class=\"mtx-grid-toolbar\" *ngIf=\"showToolbar\">\r\n  <div class=\"mtx-grid-toolbar-content\">\r\n    <ng-template [ngIf]=\"_isTemplateRef(toolbarTemplate)\" [ngIfElse]=\"defaultToolbarTemplate\">\r\n      <ng-template [ngTemplateOutlet]=\"toolbarTemplate\"></ng-template>\r\n    </ng-template>\r\n    <ng-template #defaultToolbarTemplate>\r\n      <div class=\"mtx-grid-toolbar-title\" *ngIf=\"toolbarTitle\">{{toolbarTitle}}</div>\r\n    </ng-template>\r\n  </div>\r\n  <div class=\"mtx-grid-toolbar-actions\">\r\n    <mtx-grid-column-menu *ngIf=\"showColumnMenuButton\" #columnMenu\r\n                          [columns]=\"columnMenuData\"\r\n                          [buttonText]=\"columnMenuButtonText\"\r\n                          [buttonType]=\"columnMenuButtonType\"\r\n                          [buttonColor]=\"columnMenuButtonColor\"\r\n                          [buttonClass]=\"columnMenuButtonClass\"\r\n                          [buttonIcon]=\"columnMenuButtonIcon\"\r\n                          [selectable]=\"columnHideable\"\r\n                          [selectableChecked]=\"columnHideableChecked\"\r\n                          [sortable]=\"columnMovable\"\r\n                          (selectionChange)=\"_handleColumnChange($event)\"\r\n                          (sortChange)=\"_handleColumnChange($event)\"\r\n                          [showHeader]=\"showColumnMenuHeader\"\r\n                          [headerText]=\"columnMenuHeaderText\"\r\n                          [headerTemplate]=\"columnMenuHeaderTemplate\"\r\n                          [showFooter]=\"showColumnMenuFooter\"\r\n                          [footerText]=\"columnMenuFooterText\"\r\n                          [footerTemplate]=\"columnMenuFooterTemplate\">\r\n    </mtx-grid-column-menu>\r\n  </div>\r\n</div>\r\n\r\n<div class=\"mtx-grid-main mtx-grid-layout\">\r\n  <!-- Table content -->\r\n  <div class=\"mtx-grid-content mtx-grid-layout\">\r\n    <div #tableContainer class=\"mat-table-container\"\r\n         [ngClass]=\"{'mat-table-with-data': !_hasNoResult}\">\r\n      <table mat-table *ngIf=\"!columnResizable\"\r\n             [ngClass]=\"{'mat-table-hover': rowHover, 'mat-table-striped': rowStriped, 'mat-table-expandable': expandable}\"\r\n             [dataSource]=\"dataSource\" [multiTemplateDataRows]=\"expandable\"\r\n             matSort\r\n             [matSortActive]=\"sortActive\"\r\n             [matSortDirection]=\"sortDirection\"\r\n             [matSortDisableClear]=\"sortDisableClear\"\r\n             [matSortDisabled]=\"sortDisabled\"\r\n             [matSortStart]=\"sortStart\"\r\n             (matSortChange)=\"_handleSortChange($event)\"\r\n             [trackBy]=\"trackBy\">\r\n\r\n        <ng-container *ngIf=\"rowSelectable && !hideRowSelectionCheckbox\"\r\n                      matColumnDef=\"MtxGridCheckboxColumnDef\">\r\n          <th mat-header-cell *matHeaderCellDef class=\"mtx-grid-checkbox-cell\">\r\n            <mat-checkbox *ngIf=\"multiSelectable\"\r\n                          [checked]=\"rowSelection.hasValue() && _isAllSelected()\"\r\n                          [indeterminate]=\"rowSelection.hasValue() && !_isAllSelected()\"\r\n                          (change)=\"$event ? _toggleMasterCheckbox() : null\">\r\n            </mat-checkbox>\r\n          </th>\r\n          <td mat-cell *matCellDef=\"let row; let index = index; let dataIndex = dataIndex;\"\r\n              class=\"mtx-grid-checkbox-cell\">\r\n            <mat-checkbox *ngIf=\"!(rowSelectionFormatter.hideCheckbox && rowSelectionFormatter.hideCheckbox!(row, _getIndex(index, dataIndex)))\"\r\n                          [disabled]=\"rowSelectionFormatter.disabled && rowSelectionFormatter.disabled!(row, _getIndex(index, dataIndex))\"\r\n                          [checked]=\"rowSelection.isSelected(row)\"\r\n                          (click)=\"$event.stopPropagation()\"\r\n                          (change)=\"$event ? _toggleNormalCheckbox(row) : null\">\r\n            </mat-checkbox>\r\n          </td>\r\n          <td mat-footer-cell *matFooterCellDef class=\"mtx-grid-checkbox-cell\"></td>\r\n        </ng-container>\r\n\r\n        <ng-container *ngFor=\"let col of columns;\">\r\n          <ng-container [matColumnDef]=\"col.field\"\r\n                        [sticky]=\"col.pinned==='left'\" [stickyEnd]=\"col.pinned==='right'\">\r\n            <th mat-header-cell *matHeaderCellDef\r\n                [class]=\"col.class\"\r\n                [ngClass]=\"{'mat-table-sticky-left': col.pinned === 'left', 'mat-table-sticky-right': col.pinned === 'right'}\"\r\n                [ngStyle]=\"{'width': col.width, 'min-width': col.width, 'left': col.left, 'right': col.right}\">\r\n              <div class=\"mat-header-cell-inner\">\r\n                <ng-template [ngIf]=\"_isTemplateRef(headerTemplate)\" [ngIfElse]=\"headerTpl\">\r\n                  <ng-template [ngTemplateOutlet]=\"headerTemplate\"\r\n                               [ngTemplateOutletContext]=\"{ $implicit: col, colDef: col }\">\r\n                  </ng-template>\r\n                </ng-template>\r\n                <ng-template #headerTpl>\r\n                  <ng-template [ngIf]=\"headerTemplate && _isTemplateRef(headerTemplate[col.field])\"\r\n                               [ngIfElse]=\"defaultHeaderTpl\">\r\n                    <ng-template [ngTemplateOutlet]=\"headerTemplate[col.field]\"\r\n                                 [ngTemplateOutletContext]=\"{ $implicit: col, colDef: col }\">\r\n                    </ng-template>\r\n                  </ng-template>\r\n                </ng-template>\r\n                <ng-template #defaultHeaderTpl>\r\n                  <div [mat-sort-header]=\"col.sortProp?.id || col.field\"\r\n                       [disabled]=\"!col.sortable\"\r\n                       [arrowPosition]=\"col.sortProp?.arrowPosition\"\r\n                       [disableClear]=\"col.sortProp?.disableClear\"\r\n                       [start]=\"col.sortProp?.start\">\r\n                    <span class=\"mtx-grid-expansion-placeholder\" *ngIf=\"col.showExpand\"></span>\r\n                    <span>{{col.header | toObservable | async}}</span>\r\n                    <mat-icon class=\"mat-sort-header-icon\" *ngIf=\"col.sortable\">sort</mat-icon>\r\n                  </div>\r\n                  <ng-template [ngTemplateOutlet]=\"headerExtraTplBase\"\r\n                               [ngTemplateOutletContext]=\"{ $implicit: headerExtraTemplate, colDef: col }\">\r\n                  </ng-template>\r\n                </ng-template>\r\n              </div>\r\n            </th>\r\n\r\n            <td mat-cell *matCellDef=\"let row; let index = index; let dataIndex = dataIndex;\"\r\n                [class]=\"col.class\"\r\n                [ngClass]=\"{'mat-table-sticky-left': col.pinned === 'left', 'mat-table-sticky-right': col.pinned === 'right'}\"\r\n                [ngStyle]=\"{'width': col.width, 'min-width': col.width, 'left': col.left, 'right': col.right}\"\r\n                mtx-grid-selectable-cell (cellSelectionChange)=\"_selectCell($event, row, col)\">\r\n              <ng-template [ngIf]=\"_isTemplateRef(cellTemplate)\" [ngIfElse]=\"cellTpl\">\r\n                <ng-template [ngTemplateOutlet]=\"cellTemplate\"\r\n                             [ngTemplateOutletContext]=\"{ $implicit: row, rowData: row, index: _getIndex(index, dataIndex), colDef: col }\">\r\n                </ng-template>\r\n              </ng-template>\r\n              <ng-template #cellTpl>\r\n                <ng-template [ngIf]=\"cellTemplate && _isTemplateRef(cellTemplate[col.field])\"\r\n                             [ngIfElse]=\"colDefCellTpl\">\r\n                  <ng-template [ngTemplateOutlet]=\"cellTemplate[col.field]\"\r\n                               [ngTemplateOutletContext]=\"{ $implicit: row, rowData: row, index: _getIndex(index, dataIndex), colDef: col }\">\r\n                  </ng-template>\r\n                </ng-template>\r\n              </ng-template>\r\n              <ng-template #colDefCellTpl>\r\n                <ng-template [ngIf]=\"col.cellTemplate\" [ngIfElse]=\"defaultCellTpl\"\r\n                             [ngTemplateOutlet]=\"col.cellTemplate\"\r\n                             [ngTemplateOutletContext]=\"{ $implicit: row, rowData: row, index: _getIndex(index, dataIndex), colDef: col }\">\r\n                </ng-template>\r\n              </ng-template>\r\n              <ng-template #defaultCellTpl>\r\n                <button *ngIf=\"col.showExpand\" mat-icon-button mtx-grid-expansion-toggle\r\n                        [(opened)]=\"expansionRowStates[dataIndex].expanded\"\r\n                        (toggleChange)=\"_handleExpansionChange($event, row, col, dataIndex);\">\r\n                  <mat-icon>keyboard_arrow_right</mat-icon>\r\n                </button>\r\n\r\n                <mtx-grid-cell [rowData]=\"row\" [colDef]=\"col\"></mtx-grid-cell>\r\n              </ng-template>\r\n            </td>\r\n\r\n            <td mat-footer-cell *matFooterCellDef\r\n                [ngClass]=\"{'mat-table-sticky-left': col.pinned === 'left', 'mat-table-sticky-right': col.pinned === 'right'}\"\r\n                [ngStyle]=\"{'width': col.width, 'min-width': col.width, 'left': col.left, 'right': col.right}\">\r\n              <span class=\"mtx-grid-expansion-placeholder\" *ngIf=\"col.showExpand\"></span>\r\n\r\n              <ng-template [ngIf]=\"_isTemplateRef(summaryTemplate)\" [ngIfElse]=\"summaryTpl\">\r\n                <ng-template [ngTemplateOutlet]=\"summaryTemplate\"\r\n                             [ngTemplateOutletContext]=\"{ $implicit: col, colDef: col, data: data }\">\r\n                </ng-template>\r\n              </ng-template>\r\n              <ng-template #summaryTpl>\r\n                <ng-template [ngIf]=\"summaryTemplate && _isTemplateRef(summaryTemplate[col.field])\"\r\n                             [ngIfElse]=\"defaultSummaryTpl\">\r\n                  <ng-template [ngTemplateOutlet]=\"summaryTemplate[col.field]\"\r\n                               [ngTemplateOutletContext]=\"{ $implicit: _getColData(data, col), colData: _getColData(data, col), colDef: col }\">\r\n                  </ng-template>\r\n                </ng-template>\r\n              </ng-template>\r\n              <ng-template #defaultSummaryTpl>\r\n                <mtx-grid-cell [summary]=\"true\" [data]=\"data\" [colDef]=\"col\">\r\n                </mtx-grid-cell>\r\n              </ng-template>\r\n            </td>\r\n          </ng-container>\r\n        </ng-container>\r\n\r\n        <tr mat-header-row *matHeaderRowDef=\"displayedColumns; sticky: true\"></tr>\r\n        <tr mat-row\r\n            *matRowDef=\"let row; let index = index; let dataIndex = dataIndex; columns: displayedColumns;\"\r\n            [ngClass]=\"_getRowClassList(row, _getIndex(index, dataIndex))\"\r\n            (click)=\"_selectRow($event, row, _getIndex(index, dataIndex))\">\r\n        </tr>\r\n        <ng-container *ngIf=\"_whetherShowSummary\">\r\n          <tr mat-footer-row *matFooterRowDef=\"displayedColumns; sticky: true\"></tr>\r\n        </ng-container>\r\n\r\n        <ng-container *ngIf=\"expandable\">\r\n          <!-- Expanded Content Column - The expandable row is made up of this one column that spans across all columns -->\r\n          <ng-container matColumnDef=\"MtxGridExpansionColumnDef\">\r\n            <td mat-cell *matCellDef=\"let row; let dataIndex = dataIndex\"\r\n                [attr.colspan]=\"displayedColumns.length\">\r\n              <div class=\"mtx-grid-expansion-detail\"\r\n                   [@expansion]=\"expansionRowStates[dataIndex].expanded ? 'expanded' : 'collapsed'\">\r\n                <ng-template [ngTemplateOutlet]=\"expansionTemplate\"\r\n                             [ngTemplateOutletContext]=\"{ $implicit: row, rowData: row, index: dataIndex, expanded: expansionRowStates[dataIndex].expanded }\">\r\n                </ng-template>\r\n              </div>\r\n            </td>\r\n          </ng-container>\r\n\r\n          <tr mat-row\r\n              *matRowDef=\"let row; columns: ['MtxGridExpansionColumnDef']; let dataIndex = dataIndex\"\r\n              [ngClass]=\"['mtx-grid-expansion', expansionRowStates[dataIndex].expanded ? 'expanded' : 'collapsed']\">\r\n          </tr>\r\n        </ng-container>\r\n      </table>\r\n\r\n      <!-- TODO: Use flexbox-based mat-table -->\r\n      <table mat-table *ngIf=\"columnResizable\"\r\n             columnResize\r\n             [ngClass]=\"{'mat-table-hover': rowHover, 'mat-table-striped': rowStriped, 'mat-table-expandable': expandable}\"\r\n             [dataSource]=\"dataSource\" [multiTemplateDataRows]=\"expandable\"\r\n             matSort\r\n             [matSortActive]=\"sortActive\"\r\n             [matSortDirection]=\"sortDirection\"\r\n             [matSortDisableClear]=\"sortDisableClear\"\r\n             [matSortDisabled]=\"sortDisabled\"\r\n             [matSortStart]=\"sortStart\"\r\n             (matSortChange)=\"_handleSortChange($event)\"\r\n             [trackBy]=\"trackBy\">\r\n\r\n        <ng-container *ngIf=\"rowSelectable && !hideRowSelectionCheckbox\"\r\n                      matColumnDef=\"MtxGridCheckboxColumnDef\">\r\n          <th mat-header-cell *matHeaderCellDef class=\"mtx-grid-checkbox-cell\">\r\n            <mat-checkbox *ngIf=\"multiSelectable\"\r\n                          [checked]=\"rowSelection.hasValue() && _isAllSelected()\"\r\n                          [indeterminate]=\"rowSelection.hasValue() && !_isAllSelected()\"\r\n                          (change)=\"$event ? _toggleMasterCheckbox() : null\">\r\n            </mat-checkbox>\r\n          </th>\r\n          <td mat-cell *matCellDef=\"let row; let index = index; let dataIndex = dataIndex;\"\r\n              class=\"mtx-grid-checkbox-cell\">\r\n            <mat-checkbox *ngIf=\"!(rowSelectionFormatter.hideCheckbox && rowSelectionFormatter.hideCheckbox!(row, _getIndex(index, dataIndex)))\"\r\n                          [disabled]=\"rowSelectionFormatter.disabled && rowSelectionFormatter.disabled!(row, _getIndex(index, dataIndex))\"\r\n                          [checked]=\"rowSelection.isSelected(row)\"\r\n                          (click)=\"$event.stopPropagation()\"\r\n                          (change)=\"$event ? _toggleNormalCheckbox(row) : null\">\r\n            </mat-checkbox>\r\n          </td>\r\n          <td mat-footer-cell *matFooterCellDef class=\"mtx-grid-checkbox-cell\"></td>\r\n        </ng-container>\r\n\r\n        <ng-container *ngFor=\"let col of columns;\">\r\n          <ng-container [matColumnDef]=\"col.field\"\r\n                        [sticky]=\"col.pinned==='left'\" [stickyEnd]=\"col.pinned==='right'\">\r\n            <th mat-header-cell *matHeaderCellDef\r\n                [class]=\"col.class\"\r\n                [ngClass]=\"{'mat-table-sticky-left': col.pinned === 'left', 'mat-table-sticky-right': col.pinned === 'right'}\"\r\n                [ngStyle]=\"{'width': col.width, 'left': col.left, 'right': col.right}\"\r\n                [resizable]=\"col.resizable\"\r\n                [matResizableMinWidthPx]=\"col.minWidth\" [matResizableMaxWidthPx]=\"col.maxWidth\">\r\n              <div class=\"mat-header-cell-inner\">\r\n                <ng-template [ngIf]=\"_isTemplateRef(headerTemplate)\" [ngIfElse]=\"headerTpl\">\r\n                  <ng-template [ngTemplateOutlet]=\"headerTemplate\"\r\n                               [ngTemplateOutletContext]=\"{ $implicit: col, colDef: col }\">\r\n                  </ng-template>\r\n                </ng-template>\r\n                <ng-template #headerTpl>\r\n                  <ng-template [ngIf]=\"headerTemplate && _isTemplateRef(headerTemplate[col.field])\"\r\n                               [ngIfElse]=\"defaultHeaderTpl\">\r\n                    <ng-template [ngTemplateOutlet]=\"headerTemplate[col.field]\"\r\n                                 [ngTemplateOutletContext]=\"{ $implicit: col, colDef: col }\">\r\n                    </ng-template>\r\n                  </ng-template>\r\n                </ng-template>\r\n                <ng-template #defaultHeaderTpl>\r\n                  <div [mat-sort-header]=\"col.sortProp?.id || col.field\"\r\n                       [disabled]=\"!col.sortable\"\r\n                       [arrowPosition]=\"col.sortProp?.arrowPosition\"\r\n                       [disableClear]=\"col.sortProp?.disableClear\"\r\n                       [start]=\"col.sortProp?.start\">\r\n                    <span class=\"mtx-grid-expansion-placeholder\" *ngIf=\"col.showExpand\"></span>\r\n                    <span>{{col.header | toObservable | async}}</span>\r\n                    <mat-icon class=\"mat-sort-header-icon\" *ngIf=\"col.sortable\">sort</mat-icon>\r\n                  </div>\r\n                  <ng-template [ngTemplateOutlet]=\"headerExtraTplBase\"\r\n                               [ngTemplateOutletContext]=\"{ $implicit: headerExtraTemplate, colDef: col }\">\r\n                  </ng-template>\r\n                </ng-template>\r\n              </div>\r\n            </th>\r\n\r\n            <td mat-cell *matCellDef=\"let row; let index = index; let dataIndex = dataIndex;\"\r\n                [class]=\"col.class\"\r\n                [ngClass]=\"{'mat-table-sticky-left': col.pinned === 'left', 'mat-table-sticky-right': col.pinned === 'right'}\"\r\n                [ngStyle]=\"{'width': col.width, 'left': col.left, 'right': col.right}\"\r\n                mtx-grid-selectable-cell (cellSelectionChange)=\"_selectCell($event, row, col)\">\r\n              <ng-template [ngIf]=\"_isTemplateRef(cellTemplate)\" [ngIfElse]=\"cellTpl\">\r\n                <ng-template [ngTemplateOutlet]=\"cellTemplate\"\r\n                             [ngTemplateOutletContext]=\"{ $implicit: row, rowData: row, index: _getIndex(index, dataIndex), colDef: col }\">\r\n                </ng-template>\r\n              </ng-template>\r\n              <ng-template #cellTpl>\r\n                <ng-template [ngIf]=\"cellTemplate && _isTemplateRef(cellTemplate[col.field])\"\r\n                             [ngIfElse]=\"colDefCellTpl\">\r\n                  <ng-template [ngTemplateOutlet]=\"cellTemplate[col.field]\"\r\n                               [ngTemplateOutletContext]=\"{ $implicit: row, rowData: row, index: _getIndex(index, dataIndex), colDef: col }\">\r\n                  </ng-template>\r\n                </ng-template>\r\n              </ng-template>\r\n              <ng-template #colDefCellTpl>\r\n                <ng-template [ngIf]=\"col.cellTemplate\" [ngIfElse]=\"defaultCellTpl\"\r\n                             [ngTemplateOutlet]=\"col.cellTemplate\"\r\n                             [ngTemplateOutletContext]=\"{ $implicit: row, rowData: row, index: _getIndex(index, dataIndex), colDef: col }\">\r\n                </ng-template>\r\n              </ng-template>\r\n              <ng-template #defaultCellTpl>\r\n                <button *ngIf=\"col.showExpand\" mat-icon-button mtx-grid-expansion-toggle\r\n                        [(opened)]=\"expansionRowStates[dataIndex].expanded\"\r\n                        (toggleChange)=\"_handleExpansionChange($event, row, col, dataIndex);\">\r\n                  <mat-icon>keyboard_arrow_right</mat-icon>\r\n                </button>\r\n\r\n                <mtx-grid-cell [rowData]=\"row\" [colDef]=\"col\"></mtx-grid-cell>\r\n              </ng-template>\r\n            </td>\r\n\r\n            <td mat-footer-cell *matFooterCellDef\r\n                [ngClass]=\"{'mat-table-sticky-left': col.pinned === 'left', 'mat-table-sticky-right': col.pinned === 'right'}\"\r\n                [ngStyle]=\"{'width': col.width, 'left': col.left, 'right': col.right}\">\r\n              <span class=\"mtx-grid-expansion-placeholder\" *ngIf=\"col.showExpand\"></span>\r\n\r\n              <ng-template [ngIf]=\"_isTemplateRef(summaryTemplate)\" [ngIfElse]=\"summaryTpl\">\r\n                <ng-template [ngTemplateOutlet]=\"summaryTemplate\"\r\n                             [ngTemplateOutletContext]=\"{ $implicit: col, colDef: col, data: data }\">\r\n                </ng-template>\r\n              </ng-template>\r\n              <ng-template #summaryTpl>\r\n                <ng-template [ngIf]=\"summaryTemplate && _isTemplateRef(summaryTemplate[col.field])\"\r\n                             [ngIfElse]=\"defaultSummaryTpl\">\r\n                  <ng-template [ngTemplateOutlet]=\"summaryTemplate[col.field]\"\r\n                               [ngTemplateOutletContext]=\"{ $implicit: _getColData(data, col), colData: _getColData(data, col), colDef: col }\">\r\n                  </ng-template>\r\n                </ng-template>\r\n              </ng-template>\r\n              <ng-template #defaultSummaryTpl>\r\n                <mtx-grid-cell [summary]=\"true\" [data]=\"data\" [colDef]=\"col\">\r\n                </mtx-grid-cell>\r\n              </ng-template>\r\n            </td>\r\n          </ng-container>\r\n        </ng-container>\r\n\r\n        <tr mat-header-row *matHeaderRowDef=\"displayedColumns; sticky: true\"></tr>\r\n        <tr mat-row\r\n            *matRowDef=\"let row; let index = index; let dataIndex = dataIndex; columns: displayedColumns;\"\r\n            [ngClass]=\"_getRowClassList(row, _getIndex(index, dataIndex))\"\r\n            (click)=\"_selectRow($event, row, _getIndex(index, dataIndex))\">\r\n        </tr>\r\n        <ng-container *ngIf=\"_whetherShowSummary\">\r\n          <tr mat-footer-row *matFooterRowDef=\"displayedColumns; sticky: true\"></tr>\r\n        </ng-container>\r\n\r\n        <ng-container *ngIf=\"expandable\">\r\n          <!-- Expanded Content Column - The expandable row is made up of this one column that spans across all columns -->\r\n          <ng-container matColumnDef=\"MtxGridExpansionColumnDef\">\r\n            <td mat-cell *matCellDef=\"let row; let dataIndex = dataIndex\"\r\n                [attr.colspan]=\"displayedColumns.length\">\r\n              <div class=\"mtx-grid-expansion-detail\"\r\n                   [@expansion]=\"expansionRowStates[dataIndex].expanded ? 'expanded' : 'collapsed'\">\r\n                <ng-template [ngTemplateOutlet]=\"expansionTemplate\"\r\n                             [ngTemplateOutletContext]=\"{ $implicit: row, rowData: row, index: dataIndex, expanded: expansionRowStates[dataIndex].expanded }\">\r\n                </ng-template>\r\n              </div>\r\n            </td>\r\n          </ng-container>\r\n\r\n          <tr mat-row\r\n              *matRowDef=\"let row; columns: ['MtxGridExpansionColumnDef']; let dataIndex = dataIndex\"\r\n              [ngClass]=\"['mtx-grid-expansion', expansionRowStates[dataIndex].expanded ? 'expanded' : 'collapsed']\">\r\n          </tr>\r\n        </ng-container>\r\n      </table>\r\n    </div>\r\n\r\n    <!-- No result -->\r\n    <div class=\"mtx-grid-no-result\" *ngIf=\"_hasNoResult\">\r\n      <ng-template [ngIf]=\"_isTemplateRef(noResultTemplate)\" [ngIfElse]=\"defaultNoResultTpl\">\r\n        <ng-template [ngTemplateOutlet]=\"noResultTemplate\"></ng-template>\r\n      </ng-template>\r\n      <ng-template #defaultNoResultTpl>{{noResultText}}</ng-template>\r\n    </div>\r\n  </div>\r\n\r\n  <!-- Tool sidebar -->\r\n  <div class=\"mtx-grid-sidebar\" *ngIf=\"showSidebar\">\r\n    <ng-template [ngIf]=\"_isTemplateRef(sidebarTemplate)\">\r\n      <ng-template [ngTemplateOutlet]=\"sidebarTemplate\"></ng-template>\r\n    </ng-template>\r\n  </div>\r\n</div>\r\n\r\n<div class=\"mtx-grid-footer\">\r\n  <!-- Status Bar -->\r\n  <div class=\"mtx-grid-statusbar\" *ngIf=\"showStatusbar\">\r\n    <ng-template [ngIf]=\"_isTemplateRef(statusbarTemplate)\">\r\n      <ng-template [ngTemplateOutlet]=\"statusbarTemplate\"></ng-template>\r\n    </ng-template>\r\n  </div>\r\n\r\n  <!-- Pagination -->\r\n  <div class=\"mtx-grid-pagination\">\r\n    <ng-template [ngIf]=\"_isTemplateRef(paginationTemplate)\" [ngIfElse]=\"defaultPaginationTemplate\">\r\n      <ng-template [ngTemplateOutlet]=\"paginationTemplate\"></ng-template>\r\n    </ng-template>\r\n    <ng-template #defaultPaginationTemplate>\r\n      <mat-paginator [class.mat-paginator-hidden]=\"!showPaginator || _hasNoResult\"\r\n                     [showFirstLastButtons]=\"showFirstLastButtons\"\r\n                     [length]=\"length\"\r\n                     [pageIndex]=\"pageIndex\"\r\n                     [pageSize]=\"pageSize\"\r\n                     [pageSizeOptions]=\"pageSizeOptions\"\r\n                     [hidePageSize]=\"hidePageSize\"\r\n                     (page)=\"_handlePage($event)\"\r\n                     [disabled]=\"pageDisabled\">\r\n      </mat-paginator>\r\n    </ng-template>\r\n  </div>\r\n</div>\r\n\r\n<!-- Header template for extra content -->\r\n<ng-template #headerExtraTplBase let-headerExtraTemplate let-col=\"colDef\">\r\n  <ng-template [ngIf]=\"_isTemplateRef(headerExtraTemplate)\" [ngIfElse]=\"headerExtraTpl\">\r\n    <ng-template [ngTemplateOutlet]=\"headerExtraTemplate\"\r\n                 [ngTemplateOutletContext]=\"{ $implicit: col, colDef: col }\">\r\n    </ng-template>\r\n  </ng-template>\r\n  <ng-template #headerExtraTpl>\r\n    <ng-template [ngIf]=\"headerExtraTemplate && _isTemplateRef(headerExtraTemplate[col.field])\">\r\n      <ng-template [ngTemplateOutlet]=\"headerExtraTemplate[col.field]\"\r\n                   [ngTemplateOutletContext]=\"{ $implicit: col, colDef: col }\">\r\n      </ng-template>\r\n    </ng-template>\r\n  </ng-template>\r\n</ng-template>\r\n",
                host: {
                    class: 'mtx-grid'
                },
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush,
                animations: [
                    trigger('expansion', [
                        state('collapsed', style({ height: '0', minHeight: '0', visibility: 'hidden' })),
                        state('expanded', style({ height: '*', visibility: 'visible' })),
                        transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
                    ]),
                ],
                styles: [".mtx-grid{position:relative;display:flex;flex-direction:column;width:100%}.mtx-grid .mat-table-container{overflow:auto}.mtx-grid .mat-table-container.mat-table-with-data{flex:1}.mtx-grid .mat-table:not(.mat-column-resize-table){min-width:100%;border-collapse:separate}.mtx-grid .mat-table:not(.mat-column-resize-table) .mat-cell:not(.mtx-grid-checkbox-cell),.mtx-grid .mat-table:not(.mat-column-resize-table) .mat-footer-cell:not(.mtx-grid-checkbox-cell),.mtx-grid .mat-table:not(.mat-column-resize-table) .mat-header-cell:not(.mtx-grid-checkbox-cell){min-width:80px}.mtx-grid .mat-table-sticky-left{border-right-width:1px;border-right-style:solid}[dir=rtl] .mtx-grid .mat-table-sticky-left{border-right-width:0;border-left-width:1px;border-left-style:solid}.mtx-grid .mat-table-sticky-right{border-left-width:1px;border-left-style:solid}[dir=rtl] .mtx-grid .mat-table-sticky-right{border-left-width:0;border-right-width:1px;border-right-style:solid}.mtx-grid .mat-cell,.mtx-grid .mat-footer-cell,.mtx-grid .mat-header-cell{padding:4px 10px;box-sizing:border-box}.mtx-grid .mat-cell:first-of-type:not(:only-of-type),.mtx-grid .mat-footer-cell:first-of-type:not(:only-of-type),.mtx-grid .mat-header-cell:first-of-type:not(:only-of-type){padding-left:24px}.mtx-grid .mat-cell:first-of-type:not(:only-of-type).mtx-grid-checkbox-cell,.mtx-grid .mat-footer-cell:first-of-type:not(:only-of-type).mtx-grid-checkbox-cell,.mtx-grid .mat-header-cell:first-of-type:not(:only-of-type).mtx-grid-checkbox-cell{padding-left:10px;padding-right:10px}[dir=rtl] .mtx-grid .mat-cell:first-of-type:not(:only-of-type),[dir=rtl] .mtx-grid .mat-footer-cell:first-of-type:not(:only-of-type),[dir=rtl] .mtx-grid .mat-header-cell:first-of-type:not(:only-of-type){padding-left:10px;padding-right:24px}[dir=rtl] .mtx-grid .mat-cell:first-of-type:not(:only-of-type).mtx-grid-checkbox-cell,[dir=rtl] .mtx-grid .mat-footer-cell:first-of-type:not(:only-of-type).mtx-grid-checkbox-cell,[dir=rtl] .mtx-grid .mat-header-cell:first-of-type:not(:only-of-type).mtx-grid-checkbox-cell{padding-left:10px;padding-right:10px}.mtx-grid .mat-cell:last-of-type:not(:only-of-type),.mtx-grid .mat-footer-cell:last-of-type:not(:only-of-type),.mtx-grid .mat-header-cell:last-of-type:not(:only-of-type){padding-right:24px}[dir=rtl] .mtx-grid .mat-cell:last-of-type:not(:only-of-type),[dir=rtl] .mtx-grid .mat-footer-cell:last-of-type:not(:only-of-type),[dir=rtl] .mtx-grid .mat-header-cell:last-of-type:not(:only-of-type){padding-left:24px;padding-right:10px}.mtx-grid .mat-cell .mat-icon-button.expanded .mat-icon{transform:rotate(90deg)}.mtx-grid .mat-row.mtx-grid-expansion{height:0;overflow:hidden}.mtx-grid .mat-row.mtx-grid-expansion .mat-cell{padding-top:0;padding-bottom:0}.mtx-grid .mat-row.mtx-grid-expansion.collapsed .mat-cell{border-bottom-width:0}.mtx-grid .mat-row:last-of-type .mat-cell{border-bottom-width:0}.mtx-grid .mat-sort-header-icon{width:18px;height:18px;margin:0 4px;font-size:18px}.mtx-grid .mat-header-cell-inner{display:flex;align-items:center}.mtx-grid .mat-paginator-hidden{display:none}.mtx-grid-progress{position:absolute;top:0;z-index:120;width:100%}.mtx-grid-toolbar{display:flex;justify-content:space-between;align-items:center;min-height:48px;padding:8px;box-sizing:border-box}.mtx-grid-layout{display:flex;flex:1 1 auto;overflow:auto}.mtx-grid-content{flex-direction:column;width:0}.mtx-grid-sidebar{max-width:50%;border-left-width:1px;border-left-style:solid}[dir=rtl] .mtx-grid-sidebar{border-left-width:0;border-right-width:1px;border-right-style:solid}.mtx-grid-footer{position:relative;z-index:1}.mtx-grid-statusbar{display:flex;align-items:center;min-height:56px;padding:8px}.mtx-grid-no-result{display:flex;justify-content:center;align-items:center;flex:1;min-height:150px}.mtx-grid-expansion-placeholder{display:inline-block;width:40px;height:40px;vertical-align:middle}.mtx-grid-expansion-detail{display:flex;align-items:center;min-height:48px;overflow:hidden}.mtx-grid-checkbox-cell{flex:none;justify-content:center;width:56px;min-width:56px}.mtx-grid-checkbox-cell .mat-checkbox{display:flex;margin:0 10px}.mtx-grid-checkbox-cell .mat-checkbox-inner-container{margin-left:0}"]
            }]
    }], function () { return [{ type: MtxGridService }, { type: ɵngcc0.ChangeDetectorRef }]; }, { columns: [{
            type: Input
        }], data: [{
            type: Input
        }], length: [{
            type: Input
        }], loading: [{
            type: Input
        }], columnResizable: [{
            type: Input
        }], pageOnFront: [{
            type: Input
        }], showPaginator: [{
            type: Input
        }], pageDisabled: [{
            type: Input
        }], showFirstLastButtons: [{
            type: Input
        }], pageIndex: [{
            type: Input
        }], pageSize: [{
            type: Input
        }], pageSizeOptions: [{
            type: Input
        }], hidePageSize: [{
            type: Input
        }], page: [{
            type: Output
        }], sortOnFront: [{
            type: Input
        }], sortDisableClear: [{
            type: Input
        }], sortDisabled: [{
            type: Input
        }], sortStart: [{
            type: Input
        }], sortChange: [{
            type: Output
        }], rowHover: [{
            type: Input
        }], rowStriped: [{
            type: Input
        }], rowClick: [{
            type: Output
        }], expandable: [{
            type: Input
        }], expansionChange: [{
            type: Output
        }], multiSelectable: [{
            type: Input
        }], rowSelected: [{
            type: Input
        }], rowSelectable: [{
            type: Input
        }], hideRowSelectionCheckbox: [{
            type: Input
        }], rowSelectionFormatter: [{
            type: Input
        }], rowSelectionChange: [{
            type: Output
        }], cellSelectable: [{
            type: Input
        }], cellSelectionChange: [{
            type: Output
        }], showToolbar: [{
            type: Input
        }], toolbarTitle: [{
            type: Input
        }], showColumnMenuButton: [{
            type: Input
        }], columnMenuButtonText: [{
            type: Input
        }], columnMenuButtonType: [{
            type: Input
        }], columnMenuButtonClass: [{
            type: Input
        }], columnMenuButtonIcon: [{
            type: Input
        }], columnHideable: [{
            type: Input
        }], columnHideableChecked: [{
            type: Input
        }], columnMovable: [{
            type: Input
        }], columnPinnable: [{
            type: Input
        }], columnChange: [{
            type: Output
        }], showColumnMenuHeader: [{
            type: Input
        }], columnMenuHeaderText: [{
            type: Input
        }], showColumnMenuFooter: [{
            type: Input
        }], columnMenuFooterText: [{
            type: Input
        }], noResultText: [{
            type: Input
        }], showSummary: [{
            type: Input
        }], showSidebar: [{
            type: Input
        }], showStatusbar: [{
            type: Input
        }], displayedColumns: [{
            type: Input
        }], paginator: [{
            type: ViewChild,
            args: [MatPaginator]
        }], sort: [{
            type: ViewChild,
            args: [MatSort]
        }], columnMenu: [{
            type: ViewChild,
            args: ['columnMenu']
        }], tableContainer: [{
            type: ViewChild,
            args: ['tableContainer']
        }], trackBy: [{
            type: Input
        }], paginationTemplate: [{
            type: Input
        }], sortActive: [{
            type: Input
        }], sortDirection: [{
            type: Input
        }], expansionTemplate: [{
            type: Input
        }], rowClassFormatter: [{
            type: Input
        }], toolbarTemplate: [{
            type: Input
        }], columnMenuButtonColor: [{
            type: Input
        }], columnMenuHeaderTemplate: [{
            type: Input
        }], columnMenuFooterTemplate: [{
            type: Input
        }], noResultTemplate: [{
            type: Input
        }], headerTemplate: [{
            type: Input
        }], headerExtraTemplate: [{
            type: Input
        }], cellTemplate: [{
            type: Input
        }], summaryTemplate: [{
            type: Input
        }], sidebarTemplate: [{
            type: Input
        }], statusbarTemplate: [{
            type: Input
        }] }); })();

class MtxGridCellComponent {
    constructor(_dialog, _dataGridSrv) {
        this._dialog = _dialog;
        this._dataGridSrv = _dataGridSrv;
        /** Row data */
        this.rowData = {};
        /** All data */
        this.data = [];
        /** Whether show summary */
        this.summary = false;
    }
    get _colValue() {
        return this._dataGridSrv.getCellValue(this.rowData, this.colDef);
    }
    _isString(fn) {
        return Object.prototype.toString.call(fn) === '[object String]';
    }
    _isFunction(fn) {
        return Object.prototype.toString.call(fn) === '[object Function]';
    }
    _isEmptyValue(value) {
        return value == null || value.toString() === '';
    }
    _isContainHTML(value) {
        return /<\/?[a-z][\s\S]*>/i.test(value);
    }
    _getText(value) {
        return this._isEmptyValue(value) ? '--' : value;
    }
    _getTooltip(value) {
        return this._isEmptyValue(value) ? '' : value;
    }
    _getFormatterTooltip(value) {
        return this._isContainHTML(value) || this._isEmptyValue(value) ? '' : value;
    }
    _formatSummary(data, colDef) {
        if (this._isString(colDef.summary)) {
            return colDef.summary;
        }
        else if (this._isFunction(colDef.summary)) {
            return colDef.summary(this._dataGridSrv.getColData(data, colDef), colDef);
        }
    }
    _handleActionConfirm(event, title, description = '', okColor = 'primary', okText = 'OK', closeColor, closeText = 'CLOSE', fn, data) {
        event.preventDefault();
        event.stopPropagation();
        this._dialog.open({
            title,
            description,
            buttons: [
                {
                    color: okColor,
                    text: okText,
                    onClick: () => (fn ? fn(data) : {}),
                },
                { color: closeColor, text: closeText, onClick: () => { } },
            ],
        });
    }
    _handleActionClick(event, btn, rowData) {
        event.preventDefault();
        event.stopPropagation();
        if (btn.click) {
            btn.click(rowData);
        }
    }
    /** Preview enlarged image */
    _onPreview(urlStr) {
        const imgs = [];
        this._dataGridSrv.str2arr(urlStr).forEach((url, index) => {
            imgs.push({ title: index + 1 + '', src: url });
        });
        const footerToolbar = imgs.length > 1
            ? ['zoomIn', 'zoomOut', 'prev', 'next', 'rotateRight', 'rotateLeft', 'actualSize']
            : ['zoomIn', 'zoomOut', 'rotateRight', 'rotateLeft', 'actualSize'];
        const options = {
            title: imgs.length > 1,
            footerToolbar,
        };
        const viewer = new PhotoViewer(imgs, options);
    }
}
MtxGridCellComponent.ɵfac = function MtxGridCellComponent_Factory(t) { return new (t || MtxGridCellComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc10.MtxDialog), ɵngcc0.ɵɵdirectiveInject(MtxGridService)); };
MtxGridCellComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: MtxGridCellComponent, selectors: [["mtx-grid-cell"]], inputs: { rowData: "rowData", data: "data", summary: "summary", colDef: "colDef" }, exportAs: ["mtxGridCell"], decls: 5, vars: 2, consts: [[3, "title", "innerHTML", 4, "ngIf", "ngIfElse"], ["customCellFormattingTpl", ""], ["defaultCellFormattingTpl", ""], [3, "title", "innerHTML"], [3, "ngSwitch"], [4, "ngSwitchCase"], [4, "ngSwitchDefault"], [4, "ngIf", "ngIfElse"], ["tagEmptyTpl", ""], ["color", "primary", 3, "ngClass"], [4, "ngFor", "ngForOf"], [4, "ngIf"], ["btnDefaultTpl", ""], ["mat-button", "", 3, "ngClass", "color", "disabled", "matTooltip", "click", 4, "ngIf"], ["mat-icon-button", "", 3, "ngClass", "color", "disabled", "matTooltip", "click", 4, "ngIf"], ["mat-button", "", 3, "ngClass", "color", "disabled", "matTooltip", "click"], ["mat-icon-button", "", 3, "ngClass", "color", "disabled", "matTooltip", "click"], ["target", "_blank", 3, "href"], [1, "mtx-grid-img", 3, "src", "click"], [3, "title"]], template: function MtxGridCellComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, MtxGridCellComponent_span_0_Template, 1, 2, "span", 0);
        ɵngcc0.ɵɵtemplate(1, MtxGridCellComponent_ng_template_1_Template, 1, 2, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(3, MtxGridCellComponent_ng_template_3_Template, 11, 10, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = ɵngcc0.ɵɵreference(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.summary)("ngIfElse", _r1);
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgSwitch, ɵngcc1.NgSwitchCase, ɵngcc1.NgSwitchDefault, ɵngcc11.MatChipList, ɵngcc11.MatChip, ɵngcc1.NgClass, ɵngcc1.NgForOf, ɵngcc7.MatButton, ɵngcc12.MatTooltip, ɵngcc6.MatIcon], pipes: [ɵngcc1.AsyncPipe, ɵngcc9.MtxToObservablePipe, ɵngcc1.DecimalPipe, ɵngcc1.CurrencyPipe, ɵngcc1.PercentPipe, ɵngcc1.DatePipe], styles: [".mtx-grid-action-button .mat-icon{width:18px;height:18px;font-size:18px;line-height:18px}.mtx-grid-img{display:block;width:30px;border-radius:4px;cursor:pointer}"], encapsulation: 2 });
/** @nocollapse */
MtxGridCellComponent.ctorParameters = () => [
    { type: MtxDialog },
    { type: MtxGridService }
];
MtxGridCellComponent.propDecorators = {
    rowData: [{ type: Input }],
    colDef: [{ type: Input }],
    data: [{ type: Input }],
    summary: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MtxGridCellComponent, [{
        type: Component,
        args: [{
                selector: 'mtx-grid-cell',
                exportAs: 'mtxGridCell',
                template: "<span *ngIf=\"summary; else customCellFormattingTpl\"\r\n      [title]=\"_getFormatterTooltip(_formatSummary(data, colDef))\"\r\n      [innerHTML]=\"_getText(_formatSummary(data, colDef))\">\r\n</span>\r\n\r\n<!-- Custom formatting -->\r\n<ng-template #customCellFormattingTpl>\r\n  <span *ngIf=\"colDef.formatter; else defaultCellFormattingTpl\"\r\n        [title]=\"_getFormatterTooltip(colDef.formatter!(rowData, colDef))\"\r\n        [innerHTML]=\"_getText(colDef.formatter!(rowData, colDef))\">\r\n  </span>\r\n</ng-template>\r\n\r\n<!-- Default formatting -->\r\n<ng-template #defaultCellFormattingTpl>\r\n  <ng-container [ngSwitch]=\"colDef.type\">\r\n    <!-- Tag -->\r\n    <ng-container *ngSwitchCase=\"'tag'\">\r\n      <mat-chip-list *ngIf=\"colDef.tag && colDef.tag[_colValue]; else tagEmptyTpl\">\r\n        <mat-chip color=\"primary\" [ngClass]=\"['bg-' + colDef.tag[_colValue].color]\">\r\n          {{colDef.tag[_colValue].text}}\r\n        </mat-chip>\r\n      </mat-chip-list>\r\n      <ng-template #tagEmptyTpl>{{_colValue}}</ng-template>\r\n    </ng-container>\r\n    <!-- Buttons -->\r\n    <ng-container *ngSwitchCase=\"'button'\">\r\n      <ng-container *ngFor=\"let btn of colDef.buttons;\">\r\n        <ng-container *ngIf=\"!btn.iif || btn.iif(rowData)\">\r\n          <ng-container *ngIf=\"btn.pop; else btnDefaultTpl\">\r\n            <button [ngClass]=\"['mtx-grid-action-button', btn.class||'']\"\r\n                    *ngIf=\"btn.type==='basic'\"\r\n                    mat-button\r\n                    [color]=\"btn.color || 'primary'\"\r\n                    [disabled]=\"btn.disabled\"\r\n                    [matTooltip]=\"btn.tooltip | toObservable | async\"\r\n                    (click)=\"_handleActionConfirm($event, btn.popTitle, btn.popDescription,\r\n                                                          btn.popOkColor, btn.popOkText,\r\n                                                          btn.popCloseColor, btn.popCloseText,\r\n                                                          btn.click, rowData)\">\r\n              <mat-icon *ngIf=\"btn.icon\">{{btn.icon}}</mat-icon>\r\n              <span>{{btn.text | toObservable | async}}</span>\r\n            </button>\r\n            <button [ngClass]=\"['mtx-grid-action-button', btn.class||'']\"\r\n                    *ngIf=\"!btn.type || btn.type==='icon'\"\r\n                    mat-icon-button\r\n                    [color]=\"btn.color || 'primary'\"\r\n                    [disabled]=\"btn.disabled\"\r\n                    [matTooltip]=\"btn.tooltip | toObservable | async\"\r\n                    (click)=\"_handleActionConfirm($event, btn.popTitle, btn.popDescription,\r\n                                                          btn.popOkColor, btn.popOkText,\r\n                                                          btn.popCloseColor, btn.popCloseText,\r\n                                                          btn.click, rowData)\">\r\n              <mat-icon>{{btn.icon}}</mat-icon>\r\n            </button>\r\n          </ng-container>\r\n          <ng-template #btnDefaultTpl>\r\n            <button [ngClass]=\"['mtx-grid-action-button', btn.class||'']\"\r\n                    *ngIf=\"btn.type==='basic'\"\r\n                    mat-button\r\n                    [color]=\"btn.color || 'primary'\"\r\n                    [disabled]=\"btn.disabled\"\r\n                    [matTooltip]=\"btn.tooltip | toObservable | async\"\r\n                    (click)=\"_handleActionClick($event, btn, rowData)\">\r\n              <mat-icon *ngIf=\"btn.icon\">{{btn.icon}}</mat-icon>\r\n              <span>{{btn.text | toObservable | async}}</span>\r\n            </button>\r\n            <button [ngClass]=\"['mtx-grid-action-button', btn.class||'']\"\r\n                    *ngIf=\"!btn.type || btn.type==='icon'\"\r\n                    mat-icon-button\r\n                    [color]=\"btn.color || 'primary'\"\r\n                    [disabled]=\"btn.disabled\"\r\n                    [matTooltip]=\"btn.tooltip | toObservable | async\"\r\n                    (click)=\"_handleActionClick($event, btn, rowData)\">\r\n              <mat-icon>{{btn.icon}}</mat-icon>\r\n            </button>\r\n          </ng-template>\r\n        </ng-container>\r\n      </ng-container>\r\n    </ng-container>\r\n    <!-- Link -->\r\n    <ng-container *ngSwitchCase=\"'link'\">\r\n      <a [href]=\"_colValue\" target=\"_blank\">{{_colValue}}</a>\r\n    </ng-container>\r\n    <!-- Image -->\r\n    <ng-container *ngSwitchCase=\"'image'\">\r\n      <img class=\"mtx-grid-img\" [src]=\"_colValue\" (click)=\"_onPreview(_colValue)\">\r\n    </ng-container>\r\n    <!-- Boolean -->\r\n    <ng-container *ngSwitchCase=\"'boolean'\">\r\n      <span [title]=\"_getTooltip(_colValue)\">{{_getText(_colValue)}}</span>\r\n    </ng-container>\r\n    <!-- Number -->\r\n    <ng-container *ngSwitchCase=\"'number'\">\r\n      <span [title]=\"_getTooltip(_colValue | number: colDef.typeParameter?.digitsInfo : colDef.typeParameter?.locale)\">\r\n        {{_getText(_colValue | number: colDef.typeParameter?.digitsInfo : colDef.typeParameter?.locale)}}\r\n      </span>\r\n    </ng-container>\r\n    <!-- Currency -->\r\n    <ng-container *ngSwitchCase=\"'currency'\">\r\n      <span [title]=\"_getTooltip(_colValue | currency: colDef.typeParameter?.currencyCode : colDef.typeParameter?.display : colDef.typeParameter?.digitsInfo : colDef.typeParameter?.locale)\">\r\n        {{_getText(_colValue | currency: colDef.typeParameter?.currencyCode : colDef.typeParameter?.display : colDef.typeParameter?.digitsInfo : colDef.typeParameter?.locale)}}\r\n      </span>\r\n    </ng-container>\r\n    <!-- Percent -->\r\n    <ng-container *ngSwitchCase=\"'percent'\">\r\n      <span [title]=\"_getTooltip(_colValue | percent: colDef.typeParameter?.digitsInfo : colDef.typeParameter?.locale)\">\r\n        {{_getText(_colValue | percent: colDef.typeParameter?.digitsInfo : colDef.typeParameter?.locale)}}\r\n      </span>\r\n    </ng-container>\r\n    <!-- Date -->\r\n    <ng-container *ngSwitchCase=\"'date'\">\r\n      <span [title]=\"_getTooltip(_colValue | date: colDef.typeParameter?.format : colDef.typeParameter?.timezone : colDef.typeParameter?.locale)\">\r\n        {{_getText(_colValue | date: colDef.typeParameter?.format : colDef.typeParameter?.timezone : colDef.typeParameter?.locale)}}\r\n      </span>\r\n    </ng-container>\r\n    <!-- Default -->\r\n    <ng-container *ngSwitchDefault>\r\n      <span [title]=\"_getTooltip(_colValue)\">{{_getText(_colValue)}}</span>\r\n    </ng-container>\r\n  </ng-container>\r\n</ng-template>\r\n",
                encapsulation: ViewEncapsulation.None,
                styles: [".mtx-grid-action-button .mat-icon{width:18px;height:18px;font-size:18px;line-height:18px}.mtx-grid-img{display:block;width:30px;border-radius:4px;cursor:pointer}"]
            }]
    }], function () { return [{ type: ɵngcc10.MtxDialog }, { type: MtxGridService }]; }, { rowData: [{
            type: Input
        }], data: [{
            type: Input
        }], summary: [{
            type: Input
        }], colDef: [{
            type: Input
        }] }); })();

class MtxGridColumnMenuComponent {
    constructor() {
        this.columns = [];
        this.selectable = true;
        this.selectableChecked = 'show';
        this.sortable = true;
        this.dndSortable = true;
        this._buttonText = '';
        this.buttonType = 'stroked';
        this.buttonClass = '';
        this.buttonIcon = '';
        this.showHeader = false;
        this.headerText = 'Columns Header';
        this.showFooter = false;
        this.footerText = 'Columns Footer';
        this.selectionChange = new EventEmitter();
        this.sortChange = new EventEmitter();
    }
    get buttonText() {
        const defaultText = `Columns ${this.selectableChecked === 'show' ? 'Shown' : 'Hidden'}`;
        const text = this._buttonText ? this._buttonText : defaultText;
        return text;
    }
    set buttonText(value) {
        this._buttonText = value;
    }
    _handleDroped(event) {
        moveItemInArray(this.columns, event.previousIndex, event.currentIndex);
        this.sortChange.emit(this.columns);
    }
    _handleSelection(e) {
        this.selectionChange.emit(this.columns);
    }
}
MtxGridColumnMenuComponent.ɵfac = function MtxGridColumnMenuComponent_Factory(t) { return new (t || MtxGridColumnMenuComponent)(); };
MtxGridColumnMenuComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: MtxGridColumnMenuComponent, selectors: [["mtx-grid-column-menu"]], viewQuery: function MtxGridColumnMenuComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c17, 7);
        ɵngcc0.ɵɵviewQuery(MatMenuTrigger, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.menuPanel = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.menuTrigger = _t.first);
    } }, inputs: { columns: "columns", selectable: "selectable", selectableChecked: "selectableChecked", sortable: "sortable", dndSortable: "dndSortable", buttonType: "buttonType", buttonClass: "buttonClass", buttonIcon: "buttonIcon", showHeader: "showHeader", headerText: "headerText", showFooter: "showFooter", footerText: "footerText", buttonText: "buttonText", buttonColor: "buttonColor", headerTemplate: "headerTemplate", footerTemplate: "footerTemplate" }, outputs: { selectionChange: "selectionChange", sortChange: "sortChange" }, exportAs: ["mtxGridColumnMenu"], decls: 18, vars: 11, consts: [[3, "ngSwitch"], [4, "ngSwitchCase"], [4, "ngSwitchDefault"], [1, "mtx-grid-column-menu"], ["menu", "matMenu"], [1, "mtx-grid-column-menu-content", 3, "click", "keydown"], ["class", "mtx-grid-column-menu-header", 4, "ngIf"], [1, "mtx-grid-column-menu-body"], ["class", "mtx-grid-column-menu-list", "cdkDropList", "", 3, "cdkDropListDropped", 4, "ngIf"], ["class", "mtx-grid-column-menu-list", 4, "ngIf"], ["class", "mtx-grid-column-menu-footer", 4, "ngIf"], ["checkboxList", ""], ["mat-raised-button", "", 3, "ngClass", "color", "matMenuTriggerFor"], [4, "ngIf"], ["mat-stroked-button", "", 3, "ngClass", "color", "matMenuTriggerFor"], ["mat-flat-button", "", 3, "ngClass", "color", "matMenuTriggerFor"], ["mat-icon-button", "", 3, "ngClass", "color", "matMenuTriggerFor"], ["mat-fab", "", 3, "ngClass", "color", "matMenuTriggerFor"], ["mat-mini-fab", "", 3, "ngClass", "color", "matMenuTriggerFor"], ["mat-button", "", 3, "ngClass", "color", "matMenuTriggerFor"], [1, "mtx-grid-column-menu-header"], [3, "ngIf", "ngIfElse"], ["defaultHeaderTpl", ""], [3, "ngTemplateOutlet"], ["cdkDropList", "", 1, "mtx-grid-column-menu-list", 3, "cdkDropListDropped"], ["class", "mtx-grid-column-menu-item", "cdkDrag", "", 3, "cdkDragDisabled", 4, "ngFor", "ngForOf"], ["cdkDrag", "", 1, "mtx-grid-column-menu-item", 3, "cdkDragDisabled"], ["cdkDragHandle", ""], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "mtx-grid-column-menu-list"], ["class", "mtx-grid-column-menu-item", 4, "ngFor", "ngForOf"], [1, "mtx-grid-column-menu-item"], [1, "mtx-grid-column-menu-footer"], ["defaultFooterTpl", ""], ["class", "mtx-grid-column-menu-item-label", 3, "ngModel", "disabled", "ngModelChange", "change", 4, "ngIf"], ["class", "mtx-grid-column-menu-item-label", 4, "ngIf"], [1, "mtx-grid-column-menu-item-label", 3, "ngModel", "disabled", "ngModelChange", "change"], [1, "mtx-grid-column-menu-item-label"]], template: function MtxGridColumnMenuComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementContainerStart(0, 0);
        ɵngcc0.ɵɵtemplate(1, MtxGridColumnMenuComponent_ng_container_1_Template, 4, 5, "ng-container", 1);
        ɵngcc0.ɵɵtemplate(2, MtxGridColumnMenuComponent_ng_container_2_Template, 4, 5, "ng-container", 1);
        ɵngcc0.ɵɵtemplate(3, MtxGridColumnMenuComponent_ng_container_3_Template, 4, 5, "ng-container", 1);
        ɵngcc0.ɵɵtemplate(4, MtxGridColumnMenuComponent_ng_container_4_Template, 3, 4, "ng-container", 1);
        ɵngcc0.ɵɵtemplate(5, MtxGridColumnMenuComponent_ng_container_5_Template, 4, 5, "ng-container", 1);
        ɵngcc0.ɵɵtemplate(6, MtxGridColumnMenuComponent_ng_container_6_Template, 4, 5, "ng-container", 1);
        ɵngcc0.ɵɵtemplate(7, MtxGridColumnMenuComponent_ng_container_7_Template, 4, 5, "ng-container", 2);
        ɵngcc0.ɵɵelementContainerEnd();
        ɵngcc0.ɵɵelementStart(8, "mat-menu", 3, 4);
        ɵngcc0.ɵɵelementStart(10, "div", 5);
        ɵngcc0.ɵɵlistener("click", function MtxGridColumnMenuComponent_Template_div_click_10_listener($event) { return $event.stopPropagation(); })("keydown", function MtxGridColumnMenuComponent_Template_div_keydown_10_listener($event) { return $event.stopPropagation(); });
        ɵngcc0.ɵɵtemplate(11, MtxGridColumnMenuComponent_div_11_Template, 4, 2, "div", 6);
        ɵngcc0.ɵɵelementStart(12, "div", 7);
        ɵngcc0.ɵɵtemplate(13, MtxGridColumnMenuComponent_div_13_Template, 2, 1, "div", 8);
        ɵngcc0.ɵɵtemplate(14, MtxGridColumnMenuComponent_div_14_Template, 2, 1, "div", 9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(15, MtxGridColumnMenuComponent_div_15_Template, 4, 2, "div", 10);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(16, MtxGridColumnMenuComponent_ng_template_16_Template, 2, 2, "ng-template", null, 11, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngSwitch", ctx.buttonType);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", "raised");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", "stroked");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", "flat");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", "icon");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", "fab");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", "mini-fab");
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showHeader);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.sortable);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.sortable);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showFooter);
    } }, directives: [ɵngcc1.NgSwitch, ɵngcc1.NgSwitchCase, ɵngcc1.NgSwitchDefault, ɵngcc13.MatMenu, ɵngcc1.NgIf, ɵngcc7.MatButton, ɵngcc1.NgClass, ɵngcc13.MatMenuTrigger, ɵngcc6.MatIcon, ɵngcc1.NgTemplateOutlet, ɵngcc14.CdkDropList, ɵngcc1.NgForOf, ɵngcc14.CdkDrag, ɵngcc14.CdkDragHandle, ɵngcc5.MatCheckbox, ɵngcc15.NgControlStatus, ɵngcc15.NgModel], pipes: [ɵngcc1.AsyncPipe, ɵngcc9.MtxToObservablePipe], styles: [".mtx-grid-column-menu .mat-menu-content{padding:0}.mtx-grid-column-menu-body{padding:16px}.mtx-grid-column-menu-footer,.mtx-grid-column-menu-header{position:sticky;z-index:1;padding:8px 16px}.mtx-grid-column-menu-header{top:0}.mtx-grid-column-menu-footer{bottom:0}.mtx-grid-column-menu-list{display:block;max-width:100%}.mtx-grid-column-menu-list.cdk-drop-list-dragging .mtx-grid-column-menu-item:not(.cdk-drag-placeholder){transition:transform .25s cubic-bezier(0,0,.2,1)}.mtx-grid-column-menu-list.cdk-drop-list .mtx-grid-column-menu-item-label{padding:0 4px}.mtx-grid-column-menu-item{display:flex;flex-direction:row;align-items:center;padding:4px 0}.mtx-grid-column-menu-item.cdk-drag-disabled .cdk-drag-handle{opacity:.35;cursor:no-drop}.mtx-grid-column-menu-item .cdk-drag-handle{cursor:move}.mtx-grid-column-menu-item.cdk-drag-preview{box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12)}.mtx-grid-column-menu-item.cdk-drag-placeholder{opacity:0}.mtx-grid-column-menu-item.cdk-drag-animating{transition:transform .25s cubic-bezier(0,0,.2,1)}"], encapsulation: 2, changeDetection: 0 });
MtxGridColumnMenuComponent.propDecorators = {
    menuPanel: [{ type: ViewChild, args: ['menu', { static: true },] }],
    menuTrigger: [{ type: ViewChild, args: [MatMenuTrigger,] }],
    columns: [{ type: Input }],
    selectable: [{ type: Input }],
    selectableChecked: [{ type: Input }],
    sortable: [{ type: Input }],
    dndSortable: [{ type: Input }],
    buttonText: [{ type: Input }],
    buttonType: [{ type: Input }],
    buttonColor: [{ type: Input }],
    buttonClass: [{ type: Input }],
    buttonIcon: [{ type: Input }],
    showHeader: [{ type: Input }],
    headerText: [{ type: Input }],
    headerTemplate: [{ type: Input }],
    showFooter: [{ type: Input }],
    footerText: [{ type: Input }],
    footerTemplate: [{ type: Input }],
    selectionChange: [{ type: Output }],
    sortChange: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MtxGridColumnMenuComponent, [{
        type: Component,
        args: [{
                selector: 'mtx-grid-column-menu',
                exportAs: 'mtxGridColumnMenu',
                template: "<ng-container [ngSwitch]=\"buttonType\">\r\n  <ng-container *ngSwitchCase=\"'raised'\">\r\n    <button [ngClass]=\"buttonClass\" mat-raised-button [color]=\"buttonColor\"\r\n            [matMenuTriggerFor]=\"menu\">\r\n      <mat-icon *ngIf=\"buttonIcon\">{{buttonIcon}}</mat-icon> {{buttonText}}\r\n    </button>\r\n  </ng-container>\r\n  <ng-container *ngSwitchCase=\"'stroked'\">\r\n    <button [ngClass]=\"buttonClass\" mat-stroked-button [color]=\"buttonColor\"\r\n            [matMenuTriggerFor]=\"menu\">\r\n      <mat-icon *ngIf=\"buttonIcon\">{{buttonIcon}}</mat-icon> {{buttonText}}\r\n    </button>\r\n  </ng-container>\r\n  <ng-container *ngSwitchCase=\"'flat'\">\r\n    <button [ngClass]=\"buttonClass\" mat-flat-button [color]=\"buttonColor\"\r\n            [matMenuTriggerFor]=\"menu\">\r\n      <mat-icon *ngIf=\"buttonIcon\">{{buttonIcon}}</mat-icon> {{buttonText}}\r\n    </button>\r\n  </ng-container>\r\n  <ng-container *ngSwitchCase=\"'icon'\">\r\n    <button [ngClass]=\"buttonClass\" mat-icon-button [color]=\"buttonColor\"\r\n            [matMenuTriggerFor]=\"menu\">\r\n      <mat-icon *ngIf=\"buttonIcon\">{{buttonIcon}}</mat-icon>\r\n    </button>\r\n  </ng-container>\r\n  <ng-container *ngSwitchCase=\"'fab'\">\r\n    <button [ngClass]=\"buttonClass\" mat-fab [color]=\"buttonColor\" [matMenuTriggerFor]=\"menu\">\r\n      <mat-icon *ngIf=\"buttonIcon\">{{buttonIcon}}</mat-icon> {{buttonText}}\r\n    </button>\r\n  </ng-container>\r\n  <ng-container *ngSwitchCase=\"'mini-fab'\">\r\n    <button [ngClass]=\"buttonClass\" mat-mini-fab [color]=\"buttonColor\"\r\n            [matMenuTriggerFor]=\"menu\">\r\n      <mat-icon *ngIf=\"buttonIcon\">{{buttonIcon}}</mat-icon> {{buttonText}}\r\n    </button>\r\n  </ng-container>\r\n  <ng-container *ngSwitchDefault>\r\n    <button [ngClass]=\"buttonClass\" mat-button [color]=\"buttonColor\" [matMenuTriggerFor]=\"menu\">\r\n      <mat-icon *ngIf=\"buttonIcon\">{{buttonIcon}}</mat-icon> {{buttonText}}\r\n    </button>\r\n  </ng-container>\r\n</ng-container>\r\n\r\n<mat-menu #menu=\"matMenu\" class=\"mtx-grid-column-menu\">\r\n  <div class=\"mtx-grid-column-menu-content\"\r\n       (click)=\"$event.stopPropagation()\" (keydown)=\"$event.stopPropagation()\">\r\n    <div class=\"mtx-grid-column-menu-header\" *ngIf=\"showHeader\">\r\n      <ng-template [ngIf]=\"headerTemplate\" [ngIfElse]=\"defaultHeaderTpl\">\r\n        <ng-template [ngTemplateOutlet]=\"headerTemplate\"></ng-template>\r\n      </ng-template>\r\n      <ng-template #defaultHeaderTpl>{{headerText}}</ng-template>\r\n    </div>\r\n\r\n    <div class=\"mtx-grid-column-menu-body\">\r\n      <div class=\"mtx-grid-column-menu-list\"\r\n           cdkDropList (cdkDropListDropped)=\"_handleDroped($event)\"\r\n           *ngIf=\"sortable\">\r\n        <div class=\"mtx-grid-column-menu-item\" *ngFor=\"let col of columns\"\r\n             cdkDrag [cdkDragDisabled]=\"selectableChecked === 'show'? !col.show : col.hide\">\r\n          <mat-icon cdkDragHandle>drag_handle</mat-icon>\r\n          <ng-template [ngTemplateOutlet]=\"checkboxList\"\r\n                       [ngTemplateOutletContext]=\"{ $implicit: col }\">\r\n          </ng-template>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"mtx-grid-column-menu-list\" *ngIf=\"!sortable\">\r\n        <div class=\"mtx-grid-column-menu-item\" *ngFor=\"let col of columns\">\r\n          <ng-template [ngTemplateOutlet]=\"checkboxList\"\r\n                       [ngTemplateOutletContext]=\"{ $implicit: col }\">\r\n          </ng-template>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"mtx-grid-column-menu-footer\" *ngIf=\"showFooter\">\r\n      <ng-template [ngIf]=\"footerTemplate\" [ngIfElse]=\"defaultFooterTpl\">\r\n        <ng-template [ngTemplateOutlet]=\"footerTemplate\"></ng-template>\r\n      </ng-template>\r\n      <ng-template #defaultFooterTpl>{{footerText}}</ng-template>\r\n    </div>\r\n  </div>\r\n</mat-menu>\r\n\r\n<ng-template #checkboxList let-col>\r\n  <mat-checkbox class=\"mtx-grid-column-menu-item-label\"\r\n                *ngIf=\"selectable\"\r\n                [(ngModel)]=\"col[selectableChecked]\"\r\n                [disabled]=\"col.disabled\"\r\n                (change)=\"_handleSelection($event)\">\r\n    {{col.label | toObservable | async}}\r\n  </mat-checkbox>\r\n  <span class=\"mtx-grid-column-menu-item-label\" *ngIf=\"!selectable\">\r\n    {{col.label | toObservable | async}}\r\n  </span>\r\n</ng-template>\r\n",
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [".mtx-grid-column-menu .mat-menu-content{padding:0}.mtx-grid-column-menu-body{padding:16px}.mtx-grid-column-menu-footer,.mtx-grid-column-menu-header{position:sticky;z-index:1;padding:8px 16px}.mtx-grid-column-menu-header{top:0}.mtx-grid-column-menu-footer{bottom:0}.mtx-grid-column-menu-list{display:block;max-width:100%}.mtx-grid-column-menu-list.cdk-drop-list-dragging .mtx-grid-column-menu-item:not(.cdk-drag-placeholder){transition:transform .25s cubic-bezier(0,0,.2,1)}.mtx-grid-column-menu-list.cdk-drop-list .mtx-grid-column-menu-item-label{padding:0 4px}.mtx-grid-column-menu-item{display:flex;flex-direction:row;align-items:center;padding:4px 0}.mtx-grid-column-menu-item.cdk-drag-disabled .cdk-drag-handle{opacity:.35;cursor:no-drop}.mtx-grid-column-menu-item .cdk-drag-handle{cursor:move}.mtx-grid-column-menu-item.cdk-drag-preview{box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12)}.mtx-grid-column-menu-item.cdk-drag-placeholder{opacity:0}.mtx-grid-column-menu-item.cdk-drag-animating{transition:transform .25s cubic-bezier(0,0,.2,1)}"]
            }]
    }], function () { return []; }, { columns: [{
            type: Input
        }], selectable: [{
            type: Input
        }], selectableChecked: [{
            type: Input
        }], sortable: [{
            type: Input
        }], dndSortable: [{
            type: Input
        }], buttonType: [{
            type: Input
        }], buttonClass: [{
            type: Input
        }], buttonIcon: [{
            type: Input
        }], showHeader: [{
            type: Input
        }], headerText: [{
            type: Input
        }], showFooter: [{
            type: Input
        }], footerText: [{
            type: Input
        }], selectionChange: [{
            type: Output
        }], sortChange: [{
            type: Output
        }], buttonText: [{
            type: Input
        }], menuPanel: [{
            type: ViewChild,
            args: ['menu', { static: true }]
        }], menuTrigger: [{
            type: ViewChild,
            args: [MatMenuTrigger]
        }], buttonColor: [{
            type: Input
        }], headerTemplate: [{
            type: Input
        }], footerTemplate: [{
            type: Input
        }] }); })();

class MtxGridExpansionToggleDirective {
    constructor() {
        this._opened = false;
        this.openedChange = new EventEmitter();
        this.toggleChange = new EventEmitter();
    }
    get opened() {
        return this._opened;
    }
    set opened(newValue) {
        this._opened = newValue;
        this.openedChange.emit(newValue);
    }
    get expanded() {
        return this._opened;
    }
    set expandableRow(value) {
        if (value !== this._row) {
            this._row = value;
        }
    }
    set template(value) {
        if (value !== this._tplRef) {
            this._tplRef = value;
        }
    }
    onClick(event) {
        event.preventDefault();
        event.stopPropagation();
        this.toggle();
    }
    toggle() {
        this.opened = !this.opened;
        this.toggleChange.emit(this);
    }
}
MtxGridExpansionToggleDirective.ɵfac = function MtxGridExpansionToggleDirective_Factory(t) { return new (t || MtxGridExpansionToggleDirective)(); };
MtxGridExpansionToggleDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: MtxGridExpansionToggleDirective, selectors: [["", "mtx-grid-expansion-toggle", ""]], hostVars: 2, hostBindings: function MtxGridExpansionToggleDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function MtxGridExpansionToggleDirective_click_HostBindingHandler($event) { return ctx.onClick($event); });
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("expanded", ctx.expanded);
    } }, inputs: { opened: "opened", expandableRow: "expandableRow", template: ["expansionRowTpl", "template"] }, outputs: { openedChange: "openedChange", toggleChange: "toggleChange" } });
/** @nocollapse */
MtxGridExpansionToggleDirective.ctorParameters = () => [];
MtxGridExpansionToggleDirective.propDecorators = {
    opened: [{ type: Input }],
    openedChange: [{ type: Output }],
    expanded: [{ type: HostBinding, args: ['class.expanded',] }],
    expandableRow: [{ type: Input }],
    template: [{ type: Input, args: ['expansionRowTpl',] }],
    toggleChange: [{ type: Output }],
    onClick: [{ type: HostListener, args: ['click', ['$event'],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MtxGridExpansionToggleDirective, [{
        type: Directive,
        args: [{
                selector: '[mtx-grid-expansion-toggle]'
            }]
    }], function () { return []; }, { openedChange: [{
            type: Output
        }], toggleChange: [{
            type: Output
        }], opened: [{
            type: Input
        }], expanded: [{
            type: HostBinding,
            args: ['class.expanded']
        }], expandableRow: [{
            type: Input
        }], template: [{
            type: Input,
            args: ['expansionRowTpl']
        }], onClick: [{
            type: HostListener,
            args: ['click', ['$event']]
        }] }); })();

class MtxGridCellSelectionDirective {
    constructor(_dataGrid) {
        this._dataGrid = _dataGrid;
        this._selected = false;
        this.shiftKeyPressed = false;
        this.ctrlKeyPressed = false;
        this.cellSelectionChange = new EventEmitter();
    }
    get selected() {
        return this._selected;
    }
    set matSelectableRowData(value) {
        if (value !== this._rowData) {
            this._rowData = value;
        }
    }
    onClick(event) {
        this.ctrlKeyPressed = event.ctrlKey;
        this.shiftKeyPressed = event.shiftKey;
        if (this._dataGrid.cellSelectable) {
            this.select();
        }
    }
    select() {
        this._selected = true;
        this.cellSelectionChange.emit(this);
    }
    deselect() {
        this._selected = false;
        this.cellSelectionChange.emit(this);
    }
    toggle() {
        this._selected = !this._selected;
        this.cellSelectionChange.emit(this);
    }
}
MtxGridCellSelectionDirective.ɵfac = function MtxGridCellSelectionDirective_Factory(t) { return new (t || MtxGridCellSelectionDirective)(ɵngcc0.ɵɵdirectiveInject(MtxGridComponent)); };
MtxGridCellSelectionDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: MtxGridCellSelectionDirective, selectors: [["", "mtx-grid-selectable-cell", ""]], hostVars: 2, hostBindings: function MtxGridCellSelectionDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function MtxGridCellSelectionDirective_click_HostBindingHandler($event) { return ctx.onClick($event); });
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("selected", ctx.selected);
    } }, inputs: { matSelectableRowData: "matSelectableRowData" }, outputs: { cellSelectionChange: "cellSelectionChange" } });
/** @nocollapse */
MtxGridCellSelectionDirective.ctorParameters = () => [
    { type: MtxGridComponent }
];
MtxGridCellSelectionDirective.propDecorators = {
    selected: [{ type: HostBinding, args: ['class.selected',] }],
    matSelectableRowData: [{ type: Input }],
    cellSelectionChange: [{ type: Output }],
    onClick: [{ type: HostListener, args: ['click', ['$event'],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MtxGridCellSelectionDirective, [{
        type: Directive,
        args: [{
                selector: '[mtx-grid-selectable-cell]'
            }]
    }], function () { return [{ type: MtxGridComponent }]; }, { cellSelectionChange: [{
            type: Output
        }], selected: [{
            type: HostBinding,
            args: ['class.selected']
        }], matSelectableRowData: [{
            type: Input
        }], onClick: [{
            type: HostListener,
            args: ['click', ['$event']]
        }] }); })();

/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Overrides CdkFlexTableResizeStrategy to match mat-column elements.
 */
class MatFlexTableResizeStrategy extends CdkFlexTableResizeStrategy {
    constructor(columnResize, styleScheduler, table, document) {
        super(columnResize, styleScheduler, table, document);
    }
    getColumnCssClass(cssFriendlyColumnName) {
        return `mat-column-${cssFriendlyColumnName}`;
    }
}
MatFlexTableResizeStrategy.ɵfac = function MatFlexTableResizeStrategy_Factory(t) { return new (t || MatFlexTableResizeStrategy)(ɵngcc0.ɵɵinject(ɵngcc16.ColumnResize), ɵngcc0.ɵɵinject(_COALESCED_STYLE_SCHEDULER), ɵngcc0.ɵɵinject(ɵngcc17.CdkTable), ɵngcc0.ɵɵinject(DOCUMENT)); };
MatFlexTableResizeStrategy.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: MatFlexTableResizeStrategy, factory: MatFlexTableResizeStrategy.ɵfac });
/** @nocollapse */
MatFlexTableResizeStrategy.ctorParameters = () => [
    { type: ColumnResize },
    { type: _CoalescedStyleScheduler, decorators: [{ type: Inject, args: [_COALESCED_STYLE_SCHEDULER,] }] },
    { type: CdkTable },
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MatFlexTableResizeStrategy, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc16.ColumnResize }, { type: ɵngcc17._CoalescedStyleScheduler, decorators: [{
                type: Inject,
                args: [_COALESCED_STYLE_SCHEDULER]
            }] }, { type: ɵngcc17.CdkTable }, { type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }]; }, null); })();
const FLEX_RESIZE_STRATEGY_PROVIDER = {
    provide: ResizeStrategy,
    useClass: MatFlexTableResizeStrategy,
};

/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
const PROVIDERS = [
    ColumnResizeNotifier,
    HeaderRowEventDispatcher,
    ColumnResizeNotifierSource,
];
const TABLE_PROVIDERS = [
    ...PROVIDERS,
    TABLE_LAYOUT_FIXED_RESIZE_STRATEGY_PROVIDER,
];
const FLEX_PROVIDERS = [...PROVIDERS, FLEX_RESIZE_STRATEGY_PROVIDER];
const TABLE_HOST_BINDINGS = {
    class: 'mat-column-resize-table',
};
const FLEX_HOST_BINDINGS = {
    class: 'mat-column-resize-flex',
};
class AbstractMatColumnResize extends ColumnResize {
    getTableHeight() {
        const table = this.elementRef.nativeElement;
        const tableParent = table.parentNode;
        const isTableContainer = tableParent.classList.contains('mat-table-container');
        return isTableContainer ? tableParent.offsetHeight : table.offsetHeight;
    }
}

/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Explicitly enables column resizing for a table-based mat-table.
 * Individual columns must be annotated specifically.
 */
class MatColumnResize extends AbstractMatColumnResize {
    constructor(columnResizeNotifier, elementRef, eventDispatcher, ngZone, notifier) {
        super();
        this.columnResizeNotifier = columnResizeNotifier;
        this.elementRef = elementRef;
        this.eventDispatcher = eventDispatcher;
        this.ngZone = ngZone;
        this.notifier = notifier;
    }
}
MatColumnResize.ɵfac = function MatColumnResize_Factory(t) { return new (t || MatColumnResize)(ɵngcc0.ɵɵdirectiveInject(ɵngcc16.ColumnResizeNotifier), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc16.HeaderRowEventDispatcher), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone), ɵngcc0.ɵɵdirectiveInject(ɵngcc16.ColumnResizeNotifierSource)); };
MatColumnResize.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: MatColumnResize, selectors: [["table", "mat-table", "", "columnResize", ""]], hostAttrs: [1, "mat-column-resize-table"], features: [ɵngcc0.ɵɵProvidersFeature([...TABLE_PROVIDERS, { provide: ColumnResize, useExisting: MatColumnResize }]), ɵngcc0.ɵɵInheritDefinitionFeature] });
/** @nocollapse */
MatColumnResize.ctorParameters = () => [
    { type: ColumnResizeNotifier },
    { type: ElementRef },
    { type: HeaderRowEventDispatcher },
    { type: NgZone },
    { type: ColumnResizeNotifierSource }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MatColumnResize, [{
        type: Directive,
        args: [{
                selector: 'table[mat-table][columnResize]',
                host: TABLE_HOST_BINDINGS,
                providers: [...TABLE_PROVIDERS, { provide: ColumnResize, useExisting: MatColumnResize }]
            }]
    }], function () { return [{ type: ɵngcc16.ColumnResizeNotifier }, { type: ɵngcc0.ElementRef }, { type: ɵngcc16.HeaderRowEventDispatcher }, { type: ɵngcc0.NgZone }, { type: ɵngcc16.ColumnResizeNotifierSource }]; }, null); })();

/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Explicitly enables column resizing for a flexbox-based mat-table.
 * Individual columns must be annotated specifically.
 */
class MatColumnResizeFlex extends AbstractMatColumnResize {
    constructor(columnResizeNotifier, elementRef, eventDispatcher, ngZone, notifier) {
        super();
        this.columnResizeNotifier = columnResizeNotifier;
        this.elementRef = elementRef;
        this.eventDispatcher = eventDispatcher;
        this.ngZone = ngZone;
        this.notifier = notifier;
    }
}
MatColumnResizeFlex.ɵfac = function MatColumnResizeFlex_Factory(t) { return new (t || MatColumnResizeFlex)(ɵngcc0.ɵɵdirectiveInject(ɵngcc16.ColumnResizeNotifier), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc16.HeaderRowEventDispatcher), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone), ɵngcc0.ɵɵdirectiveInject(ɵngcc16.ColumnResizeNotifierSource)); };
MatColumnResizeFlex.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: MatColumnResizeFlex, selectors: [["mat-table", "columnResize", ""]], hostAttrs: [1, "mat-column-resize-flex"], features: [ɵngcc0.ɵɵProvidersFeature([...FLEX_PROVIDERS, { provide: ColumnResize, useExisting: MatColumnResizeFlex }]), ɵngcc0.ɵɵInheritDefinitionFeature] });
/** @nocollapse */
MatColumnResizeFlex.ctorParameters = () => [
    { type: ColumnResizeNotifier },
    { type: ElementRef },
    { type: HeaderRowEventDispatcher },
    { type: NgZone },
    { type: ColumnResizeNotifierSource }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MatColumnResizeFlex, [{
        type: Directive,
        args: [{
                selector: 'mat-table[columnResize]',
                host: FLEX_HOST_BINDINGS,
                providers: [...FLEX_PROVIDERS, { provide: ColumnResize, useExisting: MatColumnResizeFlex }]
            }]
    }], function () { return [{ type: ɵngcc16.ColumnResizeNotifier }, { type: ɵngcc0.ElementRef }, { type: ɵngcc16.HeaderRowEventDispatcher }, { type: ɵngcc0.NgZone }, { type: ɵngcc16.ColumnResizeNotifierSource }]; }, null); })();

/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Component shown over the edge of a resizable column that is responsible
 * for handling column resize mouse events and displaying a vertical line along the column edge.
 */
class MatColumnResizeOverlayHandle extends ResizeOverlayHandle {
    constructor(columnDef, columnResize, directionality, elementRef, eventDispatcher, ngZone, resizeNotifier, resizeRef, styleScheduler, document) {
        super();
        this.columnDef = columnDef;
        this.columnResize = columnResize;
        this.directionality = directionality;
        this.elementRef = elementRef;
        this.eventDispatcher = eventDispatcher;
        this.ngZone = ngZone;
        this.resizeNotifier = resizeNotifier;
        this.resizeRef = resizeRef;
        this.styleScheduler = styleScheduler;
        this.document = document;
    }
    updateResizeActive(active) {
        super.updateResizeActive(active);
        this.resizeRef.overlayRef.updateSize({
            height: active
                ? this.columnResize.getTableHeight()
                : this.resizeRef.origin.nativeElement.offsetHeight,
        });
    }
}
MatColumnResizeOverlayHandle.ɵfac = function MatColumnResizeOverlayHandle_Factory(t) { return new (t || MatColumnResizeOverlayHandle)(ɵngcc0.ɵɵdirectiveInject(ɵngcc17.CdkColumnDef), ɵngcc0.ɵɵdirectiveInject(ɵngcc16.ColumnResize), ɵngcc0.ɵɵdirectiveInject(ɵngcc18.Directionality), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc16.HeaderRowEventDispatcher), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone), ɵngcc0.ɵɵdirectiveInject(ɵngcc16.ColumnResizeNotifierSource), ɵngcc0.ɵɵdirectiveInject(ɵngcc16.ResizeRef), ɵngcc0.ɵɵdirectiveInject(_COALESCED_STYLE_SCHEDULER), ɵngcc0.ɵɵdirectiveInject(DOCUMENT)); };
MatColumnResizeOverlayHandle.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: MatColumnResizeOverlayHandle, selectors: [["ng-component"]], hostAttrs: [1, "mat-column-resize-overlay-thumb"], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 0, vars: 0, template: function MatColumnResizeOverlayHandle_Template(rf, ctx) { }, encapsulation: 2, changeDetection: 0 });
/** @nocollapse */
MatColumnResizeOverlayHandle.ctorParameters = () => [
    { type: CdkColumnDef },
    { type: ColumnResize },
    { type: Directionality },
    { type: ElementRef },
    { type: HeaderRowEventDispatcher },
    { type: NgZone },
    { type: ColumnResizeNotifierSource },
    { type: ResizeRef },
    { type: _CoalescedStyleScheduler, decorators: [{ type: Inject, args: [_COALESCED_STYLE_SCHEDULER,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MatColumnResizeOverlayHandle, [{
        type: Component,
        args: [{
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
                host: { class: 'mat-column-resize-overlay-thumb' },
                template: ''
            }]
    }], function () { return [{ type: ɵngcc17.CdkColumnDef }, { type: ɵngcc16.ColumnResize }, { type: ɵngcc18.Directionality }, { type: ɵngcc0.ElementRef }, { type: ɵngcc16.HeaderRowEventDispatcher }, { type: ɵngcc0.NgZone }, { type: ɵngcc16.ColumnResizeNotifierSource }, { type: ɵngcc16.ResizeRef }, { type: ɵngcc17._CoalescedStyleScheduler, decorators: [{
                type: Inject,
                args: [_COALESCED_STYLE_SCHEDULER]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }]; }, null); })();

/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
class AbstractMatResizable extends Resizable {
    constructor() {
        super(...arguments);
        this.minWidthPxInternal = 32;
    }
    getInlineHandleCssClassName() {
        return 'mat-resizable-handle';
    }
    getOverlayHandleComponentType() {
        return MatColumnResizeOverlayHandle;
    }
}
const RESIZABLE_HOST_BINDINGS = {
    class: 'mat-resizable',
};
const RESIZABLE_INPUTS = [
    'minWidthPx: matResizableMinWidthPx',
    'maxWidthPx: matResizableMaxWidthPx',
];

/**
 * Explicitly enables column resizing for a mat-header-cell.
 */
class MatResizable extends AbstractMatResizable {
    constructor(columnDef, columnResize, directionality, document, elementRef, eventDispatcher, injector, ngZone, overlay, resizeNotifier, resizeStrategy, styleScheduler, viewContainerRef, changeDetectorRef) {
        super();
        this.columnDef = columnDef;
        this.columnResize = columnResize;
        this.directionality = directionality;
        this.elementRef = elementRef;
        this.eventDispatcher = eventDispatcher;
        this.injector = injector;
        this.ngZone = ngZone;
        this.overlay = overlay;
        this.resizeNotifier = resizeNotifier;
        this.resizeStrategy = resizeStrategy;
        this.styleScheduler = styleScheduler;
        this.viewContainerRef = viewContainerRef;
        this.changeDetectorRef = changeDetectorRef;
        this.isResizable = true;
        this.document = document;
    }
    get hasResizableClass() {
        return this.isResizable ? RESIZABLE_HOST_BINDINGS.class : '';
    }
    get resizable() {
        return this.isResizable;
    }
    set resizable(newValue) {
        this.isResizable = newValue == null || newValue === '' || newValue;
    }
}
MatResizable.ɵfac = function MatResizable_Factory(t) { return new (t || MatResizable)(ɵngcc0.ɵɵdirectiveInject(ɵngcc17.CdkColumnDef), ɵngcc0.ɵɵdirectiveInject(ɵngcc16.ColumnResize), ɵngcc0.ɵɵdirectiveInject(ɵngcc18.Directionality), ɵngcc0.ɵɵdirectiveInject(DOCUMENT), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc16.HeaderRowEventDispatcher), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone), ɵngcc0.ɵɵdirectiveInject(ɵngcc19.Overlay), ɵngcc0.ɵɵdirectiveInject(ɵngcc16.ColumnResizeNotifierSource), ɵngcc0.ɵɵdirectiveInject(ɵngcc16.ResizeStrategy), ɵngcc0.ɵɵdirectiveInject(_COALESCED_STYLE_SCHEDULER), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
MatResizable.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: MatResizable, selectors: [["mat-header-cell", "resizable", ""], ["th", "mat-header-cell", "", "resizable", ""]], hostVars: 2, hostBindings: function MatResizable_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.hasResizableClass);
    } }, inputs: { minWidthPx: ["matResizableMinWidthPx", "minWidthPx"], maxWidthPx: ["matResizableMaxWidthPx", "maxWidthPx"], resizable: "resizable" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
/** @nocollapse */
MatResizable.ctorParameters = () => [
    { type: CdkColumnDef },
    { type: ColumnResize },
    { type: Directionality },
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] },
    { type: ElementRef },
    { type: HeaderRowEventDispatcher },
    { type: Injector },
    { type: NgZone },
    { type: Overlay },
    { type: ColumnResizeNotifierSource },
    { type: ResizeStrategy },
    { type: _CoalescedStyleScheduler, decorators: [{ type: Inject, args: [_COALESCED_STYLE_SCHEDULER,] }] },
    { type: ViewContainerRef },
    { type: ChangeDetectorRef }
];
MatResizable.propDecorators = {
    hasResizableClass: [{ type: HostBinding, args: ['class',] }],
    resizable: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MatResizable, [{
        type: Directive,
        args: [{
                selector: 'mat-header-cell[resizable], th[mat-header-cell][resizable]',
                inputs: RESIZABLE_INPUTS
            }]
    }], function () { return [{ type: ɵngcc17.CdkColumnDef }, { type: ɵngcc16.ColumnResize }, { type: ɵngcc18.Directionality }, { type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }, { type: ɵngcc0.ElementRef }, { type: ɵngcc16.HeaderRowEventDispatcher }, { type: ɵngcc0.Injector }, { type: ɵngcc0.NgZone }, { type: ɵngcc19.Overlay }, { type: ɵngcc16.ColumnResizeNotifierSource }, { type: ɵngcc16.ResizeStrategy }, { type: ɵngcc17._CoalescedStyleScheduler, decorators: [{
                type: Inject,
                args: [_COALESCED_STYLE_SCHEDULER]
            }] }, { type: ɵngcc0.ViewContainerRef }, { type: ɵngcc0.ChangeDetectorRef }]; }, { hasResizableClass: [{
            type: HostBinding,
            args: ['class']
        }], resizable: [{
            type: Input
        }] }); })();

/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
const ENTRY_COMMON_COMPONENTS = [MatColumnResizeOverlayHandle];
class MatColumnResizeCommonModule {
}
MatColumnResizeCommonModule.ɵfac = function MatColumnResizeCommonModule_Factory(t) { return new (t || MatColumnResizeCommonModule)(); };
MatColumnResizeCommonModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: MatColumnResizeCommonModule });
MatColumnResizeCommonModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MatColumnResizeCommonModule, [{
        type: NgModule,
        args: [{
                declarations: ENTRY_COMMON_COMPONENTS,
                exports: ENTRY_COMMON_COMPONENTS,
                entryComponents: ENTRY_COMMON_COMPONENTS
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(MatColumnResizeCommonModule, { declarations: [MatColumnResizeOverlayHandle], exports: [MatColumnResizeOverlayHandle] }); })();
const IMPORTS = [OverlayModule, MatColumnResizeCommonModule];
class MatColumnResizeModule {
}
MatColumnResizeModule.ɵfac = function MatColumnResizeModule_Factory(t) { return new (t || MatColumnResizeModule)(); };
MatColumnResizeModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: MatColumnResizeModule });
MatColumnResizeModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [IMPORTS] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MatColumnResizeModule, [{
        type: NgModule,
        args: [{
                imports: IMPORTS,
                declarations: [MatColumnResize, MatColumnResizeFlex, MatResizable],
                exports: [MatColumnResize, MatColumnResizeFlex, MatResizable]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(MatColumnResizeModule, { declarations: [MatColumnResize, MatColumnResizeFlex, MatResizable], imports: [OverlayModule, MatColumnResizeCommonModule], exports: [MatColumnResize, MatColumnResizeFlex, MatResizable] }); })();

class MtxGridModule {
}
MtxGridModule.ɵfac = function MtxGridModule_Factory(t) { return new (t || MtxGridModule)(); };
MtxGridModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: MtxGridModule });
MtxGridModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [MtxGridService], imports: [[
            CommonModule,
            FormsModule,
            MatTableModule,
            MatSortModule,
            MatPaginatorModule,
            MatCheckboxModule,
            MatButtonModule,
            MatProgressBarModule,
            MatChipsModule,
            MatTooltipModule,
            MatIconModule,
            MatSelectModule,
            MatFormFieldModule,
            MatMenuModule,
            DragDropModule,
            MtxDialogModule,
            MtxUtilsModule,
            MatColumnResizeModule,
        ], MatColumnResizeModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MtxGridModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    MatTableModule,
                    MatSortModule,
                    MatPaginatorModule,
                    MatCheckboxModule,
                    MatButtonModule,
                    MatProgressBarModule,
                    MatChipsModule,
                    MatTooltipModule,
                    MatIconModule,
                    MatSelectModule,
                    MatFormFieldModule,
                    MatMenuModule,
                    DragDropModule,
                    MtxDialogModule,
                    MtxUtilsModule,
                    MatColumnResizeModule,
                ],
                exports: [
                    MtxGridComponent,
                    MtxGridCellComponent,
                    MtxGridColumnMenuComponent,
                    MtxGridExpansionToggleDirective,
                    MtxGridCellSelectionDirective,
                    MatColumnResizeModule,
                ],
                declarations: [
                    MtxGridComponent,
                    MtxGridCellComponent,
                    MtxGridColumnMenuComponent,
                    MtxGridExpansionToggleDirective,
                    MtxGridCellSelectionDirective,
                ],
                providers: [MtxGridService]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(MtxGridModule, { declarations: function () { return [MtxGridComponent, MtxGridCellComponent, MtxGridColumnMenuComponent, MtxGridExpansionToggleDirective, MtxGridCellSelectionDirective]; }, imports: function () { return [CommonModule,
        FormsModule,
        MatTableModule,
        MatSortModule,
        MatPaginatorModule,
        MatCheckboxModule,
        MatButtonModule,
        MatProgressBarModule,
        MatChipsModule,
        MatTooltipModule,
        MatIconModule,
        MatSelectModule,
        MatFormFieldModule,
        MatMenuModule,
        DragDropModule,
        MtxDialogModule,
        MtxUtilsModule, MatColumnResizeModule]; }, exports: function () { return [MtxGridComponent, MtxGridCellComponent, MtxGridColumnMenuComponent, MtxGridExpansionToggleDirective, MtxGridCellSelectionDirective, MatColumnResizeModule]; } }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { AbstractMatColumnResize, AbstractMatResizable, FLEX_HOST_BINDINGS as MAT_FLEX_HOST_BINDINGS, FLEX_PROVIDERS as MAT_FLEX_PROVIDERS, FLEX_RESIZE_STRATEGY_PROVIDER as MAT_FLEX_RESIZE_STRATEGY_PROVIDER, RESIZABLE_HOST_BINDINGS as MAT_RESIZABLE_HOST_BINDINGS, RESIZABLE_INPUTS as MAT_RESIZABLE_INPUTS, TABLE_HOST_BINDINGS as MAT_TABLE_HOST_BINDINGS, TABLE_PROVIDERS as MAT_TABLE_PROVIDERS, MatColumnResize, MatColumnResizeCommonModule, MatColumnResizeFlex, MatColumnResizeModule, MatColumnResizeOverlayHandle, MatFlexTableResizeStrategy, MatResizable, MtxGridCellComponent, MtxGridCellSelectionDirective, MtxGridColumnMenuComponent, MtxGridComponent, MtxGridExpansionToggleDirective, MtxGridModule, MtxGridService };

